import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stateProvinceCode?: Maybe<Scalars['String']['output']>;
  stateProvinceName?: Maybe<Scalars['String']['output']>;
};

export type AgeCategory = {
  __typename?: 'AgeCategory';
  minimumAge: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type Agency = Node & {
  __typename?: 'Agency';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  license: AgencyLicense;
  licenseNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameEnglish: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AgencyAuthRole =
  | 'account'
  | 'admin'
  | 'member';

export type AgencyBranchConnection = Connection & {
  __typename?: 'AgencyBranchConnection';
  nodes: Array<AgencyBranchInList>;
  pageInfo: PageInfo;
};

export type AgencyBranchInDetail = AgencyBranchInterface & {
  __typename?: 'AgencyBranchInDetail';
  adminEmployee: Employee;
  agency: Agency;
  agencyId: Scalars['ID']['output'];
  /** Stripeに保持されている、顧客の現金残高（JPY） */
  cashBalance: Scalars['Int']['output'];
  cityAndLine: Scalars['String']['output'];
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  emergencyPhone: Scalars['String']['output'];
  fax?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isInvoicePaymentEnabled: Scalars['Boolean']['output'];
  /** 最新のTravelのcreatedAt */
  lastTravelCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  saRateSetting: AgencyBranchSaRateSetting;
  staffName?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  status: AgencyBranchStatus;
  stripeCustomerId: Scalars['ID']['output'];
  travelSummary: AgencyBranchTravelSummary;
  updatedAt: Scalars['DateTime']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type AgencyBranchInList = AgencyBranchInterface & Node & {
  __typename?: 'AgencyBranchInList';
  agency: Agency;
  agencyId: Scalars['ID']['output'];
  cityAndLine: Scalars['String']['output'];
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  emergencyPhone: Scalars['String']['output'];
  fax?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isInvoicePaymentEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  staffName?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  status: AgencyBranchStatus;
  stripeCustomerId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type AgencyBranchInterface = {
  agency: Agency;
  agencyId: Scalars['ID']['output'];
  cityAndLine: Scalars['String']['output'];
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  emergencyPhone: Scalars['String']['output'];
  fax?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isInvoicePaymentEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  staffName?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  status: AgencyBranchStatus;
  stripeCustomerId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type AgencyBranchSaRateSetting = {
  __typename?: 'AgencyBranchSaRateSetting';
  percent: Scalars['Float']['output'];
  tier: SaTierType;
};

export type AgencyBranchStatus =
  | 'freezed'
  | 'normal';

export type AgencyBranchTravelSummary = {
  __typename?: 'AgencyBranchTravelSummary';
  /** 集計期間の終了日（inclusive） */
  endDate: Scalars['DateTime']['output'];
  /** 集計期間の開始日（inclusive） */
  startDate: Scalars['DateTime']['output'];
  totalPaymentPrice: Scalars['Int']['output'];
  travelCount: Scalars['Int']['output'];
};

export type AgencyLicense =
  | 'agency'
  | 'first'
  | 'otoa'
  | 'second'
  | 'service'
  | 'third';

export type AgencyRegistration = Node & {
  __typename?: 'AgencyRegistration';
  agencyBranch?: Maybe<AgencyBranchInList>;
  agencyLicense: AgencyLicense;
  agencyLicenseNumber: Scalars['String']['output'];
  agencyName: Scalars['String']['output'];
  agencyNameEnglish: Scalars['String']['output'];
  agencyWebsiteUrl?: Maybe<Scalars['String']['output']>;
  branchEmergencyPhone: Scalars['String']['output'];
  branchFax?: Maybe<Scalars['String']['output']>;
  branchId?: Maybe<Scalars['ID']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  branchPhone: Scalars['String']['output'];
  cityAndLine: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  state: Scalars['String']['output'];
  status: AgencyRegistrationStatus;
  type: AgencyRegistrationType;
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AgencyRegistrationStatus =
  | 'applied'
  | 'approved'
  | 'rejected';

export type AgencyRegistrationType =
  | 'create'
  | 'update';

export type AgencyTravelMemo = Node & {
  __typename?: 'AgencyTravelMemo';
  createdAt: Scalars['DateTime']['output'];
  employee?: Maybe<Employee>;
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  travelId: Scalars['ID']['output'];
};

export type Airports = {
  __typename?: 'Airports';
  preferred: Preferred;
};

export type AllInclusive = {
  __typename?: 'AllInclusive';
  allRatePlans: Scalars['Boolean']['output'];
  details: Scalars['String']['output'];
  someRatePlans: Scalars['Boolean']['output'];
};

export type Amenity = {
  __typename?: 'Amenity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AmenitySmoking =
  | 'allowed'
  | 'both'
  | 'denied';

export type Amount = {
  __typename?: 'Amount';
  currency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type AmountCancelPenalty = CancelPenalty & {
  __typename?: 'AmountCancelPenalty';
  amount: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type Area = {
  __typename?: 'Area';
  squareFeet: Scalars['Float']['output'];
  squareMeters?: Maybe<Scalars['Float']['output']>;
};

export type Attributes = {
  __typename?: 'Attributes';
  general: GeneralAttributes;
  pets?: Maybe<Array<Maybe<Amenity>>>;
};

export type BedGroup = {
  __typename?: 'BedGroup';
  configuration: Array<Maybe<BedGroupConfiguration>>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type BedGroupAvailability = {
  __typename?: 'BedGroupAvailability';
  configuration: Array<Maybe<BedGroupConfiguration>>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type BedGroupConfiguration = {
  __typename?: 'BedGroupConfiguration';
  quantity: Scalars['Float']['output'];
  size: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BookExpediaHotelErrorCode =
  | 'cannotUseInvoicePayment'
  | 'cardDeclined'
  | 'expiredCard'
  | 'invalidCardInfo'
  | 'invalidPaymentMethod'
  | 'noBooking'
  | 'noPaymentMethod'
  | 'noPreparation'
  | 'paymentFailedButNoCharge'
  | 'priceChanged'
  | 'requires3ds'
  | 'soldOut'
  | 'unexpected';

export type BookExpediaHotelErrorResponse = {
  __typename?: 'BookExpediaHotelErrorResponse';
  errorCode: BookExpediaHotelErrorCode;
  /** 再度prepareを呼ぶ必要があるかどうか */
  rePrepareRequired: Scalars['Boolean']['output'];
  /** カード会社に問い合わせてもらわないといけないかどうか */
  shouldAskToCardIssuer: Scalars['Boolean']['output'];
};

export type BookExpediaHotelInput = {
  /** 登録済みのカードID */
  existingPaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  /** 新しく使いたいカード情報 */
  newPaymentMethod?: InputMaybe<BookExpediaHotelNewPaymentMethodInput>;
  priceCheckId: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
  rateId: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
  rooms: Array<BookingRoomInput>;
};

export type BookExpediaHotelNewPaymentMethodInput = {
  nickname?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['String']['input'];
  register: Scalars['Boolean']['input'];
};

export type BookExpediaHotelResponse = BookExpediaHotelErrorResponse | BookExpediaHotelSuccessResponse;

export type BookExpediaHotelSuccessResponse = {
  __typename?: 'BookExpediaHotelSuccessResponse';
  travel: TravelInDetail;
};

export type BookingRoomInput = {
  bedGroupId: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  occupancy: Scalars['String']['input'];
  smoking: Scalars['Boolean']['input'];
  specialRequest?: InputMaybe<Scalars['String']['input']>;
};

export type Brand = {
  __typename?: 'Brand';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BusinessModel = {
  __typename?: 'BusinessModel';
  expediaCollect: Scalars['Boolean']['output'];
  propertyCollect: Scalars['Boolean']['output'];
};

export type CmsImage = {
  __typename?: 'CMSImage';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type CancelPenalty = {
  currency: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type CancelRefundItinerary = {
  __typename?: 'CancelRefundItinerary';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type CancelRoomsErrorCode =
  | 'failedToCancelRoomToEps'
  | 'failedToRefund'
  | 'invalidPairOfArgs';

export type CancelRoomsErrorResponse = {
  __typename?: 'CancelRoomsErrorResponse';
  errorCode: CancelRoomsErrorCode;
};

export type CancelRoomsInput = {
  itineraryId: Scalars['ID']['input'];
  rooms: Array<CancelRoomsRoomInput>;
  travelId: Scalars['ID']['input'];
};

export type CancelRoomsResponse = CancelRoomsErrorResponse | CancelRoomsSuccessResponse;

export type CancelRoomsRoomInput = {
  expediaHotelRoomId: Scalars['ID']['input'];
  roomItineraryId: Scalars['ID']['input'];
};

export type CancelRoomsSuccessResponse = {
  __typename?: 'CancelRoomsSuccessResponse';
  travel: TravelInDetail;
};

export type CategoryValueAdd =
  | 'activity'
  | 'credit'
  | 'entertainment'
  | 'food_and_beverage'
  | 'service';

export type Chain = {
  __typename?: 'Chain';
  brands?: Maybe<Array<Maybe<Brand>>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ChallengeToRegisterCreditCardErrorCode =
  | 'cardDeclined'
  | 'cardDeclinedByCardIssuer'
  | 'expiredCard'
  | 'invalidCardInfo'
  | 'unknown';

export type ChallengeToRegisterCreditCardInput = {
  nickname: Scalars['String']['input'];
  paymentMethodId: Scalars['ID']['input'];
};

export type ChallengeToRegisterCreditCardResponse = ChallengeToRegisterCreditCardResponseError | ChallengeToRegisterCreditCardResponseRequiresAction | ChallengeToRegisterCreditCardResponseSuccess;

export type ChallengeToRegisterCreditCardResponseError = {
  __typename?: 'ChallengeToRegisterCreditCardResponseError';
  errorCode: ChallengeToRegisterCreditCardErrorCode;
};

export type ChallengeToRegisterCreditCardResponseRequiresAction = {
  __typename?: 'ChallengeToRegisterCreditCardResponseRequiresAction';
  redirectUrl: Scalars['String']['output'];
};

export type ChallengeToRegisterCreditCardResponseSuccess = {
  __typename?: 'ChallengeToRegisterCreditCardResponseSuccess';
  card: StripeCreditCard;
};

export type ChangeRoomDetailsErrorCode =
  | 'invalidRequest'
  | 'notAvailable'
  | 'notChanged'
  | 'notFound'
  | 'unexpected';

export type ChangeRoomDetailsErrorResponse = {
  __typename?: 'ChangeRoomDetailsErrorResponse';
  errorCode: ChangeRoomDetailsErrorCode;
};

export type ChangeRoomDetailsInput = {
  itineraryId: Scalars['ID']['input'];
  roomDetails: Array<ChangeRoomDetailsRoomInput>;
  travelId: Scalars['ID']['input'];
};

export type ChangeRoomDetailsResponse = ChangeRoomDetailsErrorResponse | ChangeRoomDetailsSuccessResponse;

export type ChangeRoomDetailsRoomInput = {
  expediaHotelRoomId: Scalars['ID']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  roomItineraryId: Scalars['ID']['input'];
  specialRequest?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeRoomDetailsSuccessResponse = {
  __typename?: 'ChangeRoomDetailsSuccessResponse';
  travel: TravelInDetail;
};

export type ChangeTravelDateErrorCode =
  | 'alreadyRebooked'
  | 'cannotUseInvoicePayment'
  | 'cardDeclined'
  | 'expiredCard'
  | 'failedToBook'
  | 'failedToCancel'
  | 'invalidCardInfo'
  | 'invalidPaymentMethod'
  | 'noBooking'
  | 'noEpsItinerary'
  | 'noPaymentMethod'
  | 'noPreparation'
  | 'noTravel'
  | 'paymentFailedButNoCharge'
  | 'priceChanged'
  | 'requires3ds'
  | 'soldOut'
  | 'unexpected';

export type ChangeTravelDateErrorResponse = {
  __typename?: 'ChangeTravelDateErrorResponse';
  errorCode: ChangeTravelDateErrorCode;
  /** 再度prepareを呼ぶ必要があるかどうか */
  rePrepareRequired: Scalars['Boolean']['output'];
  /** カード会社に問い合わせてもらわないといけないかどうか */
  shouldAskToCardIssuer: Scalars['Boolean']['output'];
};

export type ChangeTravelDateInput = {
  /** 登録済みのカードID */
  existingPaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  /** 新しく使いたいカード情報 */
  newPaymentMethod?: InputMaybe<BookExpediaHotelNewPaymentMethodInput>;
  priceCheckId: Scalars['ID']['input'];
  travelId: Scalars['ID']['input'];
};

export type ChangeTravelDateResponse = ChangeTravelDateErrorResponse | ChangeTravelDateSuccessResponse;

export type ChangeTravelDateSuccessResponse = {
  __typename?: 'ChangeTravelDateSuccessResponse';
  newTravel: TravelInDetail;
  oldTravel: TravelInDetail;
};

export type Charge = {
  __typename?: 'Charge';
  billableCurrency: Amount;
  requestCurrency: Amount;
};

export type Checkin = {
  __typename?: 'Checkin';
  _24Hour?: Maybe<Scalars['String']['output']>;
  beginTime?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  minAge?: Maybe<Scalars['Float']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
};

export type CheckinNote = {
  __typename?: 'CheckinNote';
  beginTime?: Maybe<Scalars['String']['output']>;
  checkoutTime?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  minAge?: Maybe<Scalars['Int']['output']>;
  /** 24時間チェックインサービス的なものがある場合、それを説明する文章が入る模様 */
  twentyFourHour?: Maybe<Scalars['String']['output']>;
};

export type CheckinRangeInput = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type Checkout = {
  __typename?: 'Checkout';
  time: Scalars['String']['output'];
};

export type ClipHotelRateErrorCode =
  | 'reachMaxCount';

export type ClipHotelRateErrorResponse = {
  __typename?: 'ClipHotelRateErrorResponse';
  errorCode: ClipHotelRateErrorCode;
};

export type ClipHotelRateInput = {
  epsPropertyId: Scalars['String']['input'];
  epsRateId: Scalars['String']['input'];
  epsRoomId: Scalars['String']['input'];
  isPackageRate: Scalars['Boolean']['input'];
};

export type ClipHotelRateResponse = ClipHotelRateErrorResponse | ClipHotelRateSuccessResponse;

export type ClipHotelRateSuccessResponse = {
  __typename?: 'ClipHotelRateSuccessResponse';
  newClippedHotelRate: ClippedHotelRate;
};

export type ClippedHotelRate = {
  __typename?: 'ClippedHotelRate';
  createdAt: Scalars['DateTime']['output'];
  epsPropertyId: Scalars['ID']['output'];
  epsRateId: Scalars['ID']['output'];
  epsRoomId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isPackageRate: Scalars['Boolean']['output'];
  propertyContent?: Maybe<PropertyContentInDetail>;
  /** roomがnull = ホテルが存在しないかホテルにその部屋が存在しない。在庫がない場合はratesが空になっている。 */
  room?: Maybe<RoomWithRate>;
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type ClippedHotelRateRoomArgs = {
  input: RoomsWithRateInput;
};

export type ConfirmChallengeToRegisterCreditCardInput = {
  setupIntentId: Scalars['ID']['input'];
};

export type ConfirmChallengeToRegisterCreditCardResponse = {
  __typename?: 'ConfirmChallengeToRegisterCreditCardResponse';
  errorCode?: Maybe<ChallengeToRegisterCreditCardErrorCode>;
  success: Scalars['Boolean']['output'];
};

export type Connection = {
  nodes: Array<Node>;
  pageInfo: PageInfoInterface;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CreateAgencyRegistrationInput = {
  agencyLicense: AgencyLicense;
  agencyLicenseNumber: Scalars['String']['input'];
  agencyName: Scalars['String']['input'];
  agencyNameEnglish: Scalars['String']['input'];
  agencyWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  branchEmergencyPhone: Scalars['String']['input'];
  branchFax?: InputMaybe<Scalars['String']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  branchPhone: Scalars['String']['input'];
  cityAndLine: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type CreateAgencyRegistrationResponse = {
  __typename?: 'CreateAgencyRegistrationResponse';
  agencyRegistration: AgencyRegistration;
  myself: Myself;
};

export type CreateAgencyTravelMemoInput = {
  text: Scalars['String']['input'];
  travelId: Scalars['ID']['input'];
};

export type CreateAgencyTravelMemoResponse = {
  __typename?: 'CreateAgencyTravelMemoResponse';
  agencyTravelMemo: AgencyTravelMemo;
};

export type CreateOperatorErrorCode =
  | 'alreadyIssued';

export type CreatePasswordResetCodeInput = {
  invitationCode: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};

export type CreatePasswordResetCodeResponse = {
  __typename?: 'CreatePasswordResetCodeResponse';
  code: Scalars['String']['output'];
};

export type Dates = {
  __typename?: 'Dates';
  added: Scalars['String']['output'];
  updated: Scalars['String']['output'];
};

export type Deal = {
  __typename?: 'Deal';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type DelegateAgencyAdminErrorCode =
  | 'notFound'
  | 'notPermitted';

export type DelegateAgencyAdminErrorResponse = {
  __typename?: 'DelegateAgencyAdminErrorResponse';
  errorCode: DelegateAgencyAdminErrorCode;
};

export type DelegateAgencyAdminInput = {
  employeeId: Scalars['ID']['input'];
};

export type DelegateAgencyAdminResponse = DelegateAgencyAdminErrorResponse | DelegateAgencyAdminSuccessResponse;

export type DelegateAgencyAdminSuccessResponse = {
  __typename?: 'DelegateAgencyAdminSuccessResponse';
  newAdminEmployee: Employee;
  oldAdminEmployee: Employee;
};

export type DeleteAgencyTravelMemoResponse = {
  __typename?: 'DeleteAgencyTravelMemoResponse';
  deletedAgencyTravelMemo: AgencyTravelMemo;
};

export type DeleteCreditCardResponse = {
  __typename?: 'DeleteCreditCardResponse';
  deletedCard: StripeCreditCard;
};

export type DeleteEmployeeErrorCode =
  | 'alreadyDeleted'
  | 'notDeletable'
  | 'notFound'
  | 'notPermitted';

export type DeleteEmployeeErrorResponse = {
  __typename?: 'DeleteEmployeeErrorResponse';
  errorCode: DeleteEmployeeErrorCode;
};

export type DeleteEmployeeResponse = DeleteEmployeeErrorResponse | DeleteEmployeeSuccessResponse;

export type DeleteEmployeeSuccessResponse = {
  __typename?: 'DeleteEmployeeSuccessResponse';
  deletedEmployee: Employee;
};

export type Deposit = {
  __typename?: 'Deposit';
  currency?: Maybe<Scalars['String']['output']>;
  due?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Employee = Node & {
  __typename?: 'Employee';
  agencyBranch: AgencyBranchInDetail;
  branchId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  role: EmployeeRole;
  status: EmployeeStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeeConnection = Connection & {
  __typename?: 'EmployeeConnection';
  nodes: Array<Employee>;
  pageInfo: PageInfo;
};

export type EmployeeRole =
  | 'admin'
  | 'member';

export type EmployeeStatus =
  | 'active'
  | 'deleted';

export type ExpediaHotelRoom = {
  __typename?: 'ExpediaHotelRoom';
  bedType: Scalars['String']['output'];
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  epsItineraryId: Scalars['ID']['output'];
  epsPropertyId: Scalars['ID']['output'];
  epsRateId: Scalars['ID']['output'];
  epsRoomId: Scalars['ID']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  hotelName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPackageRate: Scalars['Boolean']['output'];
  occupancy: Scalars['String']['output'];
  paymentPrice: Scalars['Int']['output'];
  refundPrice: Scalars['Int']['output'];
  roomName: Scalars['String']['output'];
  roomNumber: Scalars['Int']['output'];
  salesPrice: Scalars['Int']['output'];
  specialRequest?: Maybe<Scalars['String']['output']>;
  status: ExpediaHotelRoomStatus;
  stayPrice: Scalars['Int']['output'];
  stayPricePerNight: Array<Scalars['Int']['output']>;
  taxAndServicePrice: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ExpediaHotelRoomStatus =
  | 'booked'
  | 'canceled';

export type FeePrice = {
  __typename?: 'FeePrice';
  currency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Fees = {
  __typename?: 'Fees';
  mandatory?: Maybe<Scalars['String']['output']>;
  optional?: Maybe<Scalars['String']['output']>;
  travelerService?: Maybe<Scalars['String']['output']>;
};

export type FeesPricingInformation = {
  __typename?: 'FeesPricingInformation';
  mandatoryFee?: Maybe<Charge>;
  mandatoryTax?: Maybe<Charge>;
  resortFee?: Maybe<Charge>;
};

export type FilterTravelsInput = {
  checkin?: InputMaybe<CheckinRangeInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TravelStatusFilterInput>;
  travelNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Frequency =
  | 'one_way'
  | 'per_day'
  | 'per_night'
  | 'per_stay'
  | 'per_week'
  | 'round_trip'
  | 'unknown';

export type GeneralAttributes = {
  __typename?: 'GeneralAttributes';
  canUseUnicodeInSpecialRequest: Scalars['Boolean']['output'];
};

export type Guest = {
  __typename?: 'Guest';
  /** アメニティの評価 */
  amenities?: Maybe<Scalars['Float']['output']>;
  /** 清潔さの評価 */
  cleanliness?: Maybe<Scalars['Float']['output']>;
  /** 快適さの評価 */
  comfort?: Maybe<Scalars['Float']['output']>;
  /** 周辺環境の評価 */
  condition?: Maybe<Scalars['Float']['output']>;
  /** 口コミ件数 */
  count: Scalars['Float']['output'];
  location?: Maybe<Scalars['Float']['output']>;
  /** 周辺環境の評価 */
  neighborhood?: Maybe<Scalars['Float']['output']>;
  /** 口コミ評価 */
  overall: Scalars['Float']['output'];
  quality?: Maybe<Scalars['Float']['output']>;
  recommendationPercent?: Maybe<Scalars['String']['output']>;
  /** スタッフの評価 */
  service?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Image = {
  __typename?: 'Image';
  caption?: Maybe<Scalars['String']['output']>;
  category: ImageCategory;
  heroImage: Scalars['Boolean']['output'];
  sizedLinks: ImageLink;
  url: Scalars['String']['output'];
};

export type ImageCategory =
  | 'commonArea'
  | 'exterior'
  | 'facility'
  | 'others'
  | 'pool'
  | 'restaurant'
  | 'room'
  | 'views';

export type ImageLink = {
  __typename?: 'ImageLink';
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['String']['output']>;
};

export type ImportantNotes = {
  __typename?: 'ImportantNotes';
  /** チェックイン・チェックアウトに関すること */
  checkin?: Maybe<CheckinNote>;
  /** チェックインに関する特記事項(htmlタグ含む) */
  checkinSpecialInstructions?: Maybe<Scalars['String']['output']>;
  /** 宿泊に関して(htmlタグ含む) */
  instructions?: Maybe<Scalars['String']['output']>;
  /** その他の情報(htmlタグ含む) */
  knowBeforeYouGo?: Maybe<Scalars['String']['output']>;
  /** 施設でお支払いいただく料金(htmlタグ含む) */
  mandatoryFee?: Maybe<Scalars['String']['output']>;
  /** オプションの追加料金(htmlタグ含む) */
  optionalFee?: Maybe<Scalars['String']['output']>;
};

export type IncrementalSearchPropertyContentInput = {
  categoryIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  coordinate?: InputMaybe<SearchPropertyContentCoordinate>;
  gteGuestRating?: InputMaybe<Scalars['Float']['input']>;
  gteGuestRatingCount?: InputMaybe<Scalars['Int']['input']>;
  keyword: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  regionId?: InputMaybe<Scalars['String']['input']>;
  regionType?: InputMaybe<IncrementalSearchRegionTypeInput>;
};

export type IncrementalSearchRegionInput = {
  coordinate?: InputMaybe<SearchRegionCoordinate>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<IncrementalSearchRegionTypeInput>>;
};

export type IncrementalSearchRegionTypeInput =
  | 'airport'
  | 'city'
  | 'continent'
  | 'country'
  | 'high_level_region'
  | 'metro_station'
  | 'multi_city_vicinity'
  | 'neighborhood'
  | 'point_of_interest'
  | 'province_state'
  | 'train_station';

export type IncrementalSearchResponse = {
  __typename?: 'IncrementalSearchResponse';
  data: Array<IncrementalSearchResponseData>;
};

export type IncrementalSearchResponseData = {
  __typename?: 'IncrementalSearchResponseData';
  coordinates: Coordinates;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: IncrementalSearchResponseDataType;
};

export type IncrementalSearchResponseDataType =
  | 'airport'
  | 'city'
  | 'continent'
  | 'country'
  | 'high_level_region'
  | 'metro_station'
  | 'multi_city_vicinity'
  | 'neighborhood'
  | 'point_of_interest'
  | 'property_content'
  | 'province_state'
  | 'train_station';

/** 感染対策 */
export type InfectionPrevention = {
  __typename?: 'InfectionPrevention';
  /** 消毒・清掃に関する説明 */
  disinfectionAndCleaningDescriptions: Array<Scalars['String']['output']>;
  /** 手指消毒液を提供 */
  existHandSanitizer: Scalars['Boolean']['output'];
  /** ガイドライン準拠 */
  hasCompliedGuidelines: Scalars['Boolean']['output'];
  /** 清掃強化 */
  hasReinforcedCleaning: Scalars['Boolean']['output'];
  /** 感染への配慮に関する説明 */
  infectionControlConsiderationDescriptions: Array<Scalars['String']['output']>;
  /** 感染予防用品に関する説明 */
  infectionPreventionSuppliesDescriptions: Array<Scalars['String']['output']>;
  /** 非対面式チェックイン */
  nonFaceToFaceCheckin: Scalars['Boolean']['output'];
  /** その他に関する説明 */
  theOthersDescriptions: Array<Scalars['String']['output']>;
};

export type InviteEmployeeErrorCode =
  | 'alreadyBelongingToAnotherBranch';

export type InviteEmployeeErrorResponse = {
  __typename?: 'InviteEmployeeErrorResponse';
  errorCode: InviteEmployeeErrorCode;
};

export type InviteEmployeeInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InviteEmployeeResponse = InviteEmployeeErrorResponse | InviteEmployeeSuccessResponse;

export type InviteEmployeeSuccessResponse = {
  __typename?: 'InviteEmployeeSuccessResponse';
  invitedEmployee: Employee;
};

export type Invoice = Node & {
  __typename?: 'Invoice';
  agencyBranch: AgencyBranchInList;
  branchId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  dueDate: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  price: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: InvoiceStatus;
  stripeInvoiceId: Scalars['ID']['output'];
  stripePaymentIntentId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceConnection = Connection & {
  __typename?: 'InvoiceConnection';
  nodes: Array<Invoice>;
  pageInfo: PageInfo;
};

export type InvoiceDownloadFileType =
  | 'csv'
  | 'pdf';

export type InvoiceDownloadLinkInput = {
  id: Scalars['ID']['input'];
  type: InvoiceDownloadFileType;
};

export type InvoiceStatus =
  | 'open'
  | 'paid'
  | 'partiallyPaid'
  | 'reissuedOutOfSystem'
  | 'void';

/** Expediaの旅程データ */
export type Itinerary = {
  __typename?: 'Itinerary';
  id: Scalars['ID']['output'];
  propertyId: Scalars['ID']['output'];
  rooms: Array<RoomItinerary>;
  totalPropertyPrice?: Maybe<PropertyPrice>;
};

export type Language =
  | 'en'
  | 'ja';

export type Link = {
  __typename?: 'Link';
  href: Scalars['String']['output'];
  method: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  coordinates: Coordinates;
};

export type MappedRateAmenities = {
  __typename?: 'MappedRateAmenities';
  enMealLabels: Array<Scalars['String']['output']>;
  freeWiFi: Scalars['Boolean']['output'];
  jaMealLabels: Array<Scalars['String']['output']>;
  mealType?: Maybe<RateAmenitiesMealType>;
  wifi?: Maybe<MappedRateAmenity>;
};

export type MappedRateAmenity = {
  __typename?: 'MappedRateAmenity';
  enName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jaName: Scalars['String']['output'];
};

export type MarkUpRateSetting = {
  __typename?: 'MarkUpRateSetting';
  id: Scalars['ID']['output'];
  saRatePercent: Scalars['Float']['output'];
};

export type MaxAllowed = {
  __typename?: 'MaxAllowed';
  adults: Scalars['Float']['output'];
  children: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type MerchantOfRecord =
  | 'expedia'
  | 'property';

export type Mutation = {
  __typename?: 'Mutation';
  bookExpediaHotel: BookExpediaHotelResponse;
  cancelRooms: CancelRoomsResponse;
  challengeToRegisterCreditCard: ChallengeToRegisterCreditCardResponse;
  changeRoomDetails: ChangeRoomDetailsResponse;
  changeTravelDate: ChangeTravelDateResponse;
  clipHotelRate: ClipHotelRateResponse;
  confirmChallengeToRegisterCreditCard: ConfirmChallengeToRegisterCreditCardResponse;
  createAgencyRegistration: CreateAgencyRegistrationResponse;
  createAgencyTravelMemo: CreateAgencyTravelMemoResponse;
  createPasswordResetCode: CreatePasswordResetCodeResponse;
  /** 同期的に請求書を締める。startDateのデフォルトは最も古い未処理の請求書払のチェックアウト日、endDateのデフォルトは今日。入金期日は1時間後。 */
  debugOpeCreateInvoiceOfTravels: Scalars['Boolean']['output'];
  delegateAgencyAdmin: DelegateAgencyAdminResponse;
  deleteAgencyTravelMemo: DeleteAgencyTravelMemoResponse;
  deleteClippedHotelRates: Array<ClippedHotelRate>;
  deleteCreditCard: DeleteCreditCardResponse;
  deleteEmployee: DeleteEmployeeResponse;
  inviteEmployee: InviteEmployeeResponse;
  opeCancelRooms: CancelRoomsResponse;
  opeChangeRoomDetails: ChangeRoomDetailsResponse;
  opeCreateAgencyBranchMemo: OpeAgencyBranchMemo;
  opeCreateOperator: OpeCreateOperatorResponse;
  opeCreateTravelMemo: OpeCreateTravelMemoResponse;
  opeDeleteAgencyBranchMemo: OpeAgencyBranchMemo;
  opeDeleteOperator: OpeDeleteOperatorResponse;
  opeDeleteTravelMemo: OpeDeleteTravelMemoResponse;
  opeJudgeAgencyRegistration: OpeJudgeAgencyRegistrationResponse;
  opeMakeInvoiceVoid: Invoice;
  opeRefundRoom: OpeRefundRoomResponse;
  opeUpdateAgencyBranchSaRateSetting: AgencyBranchInDetail;
  opeUpdateAgencyBranchStaff: AgencyBranchInDetail;
  opeUpdateAgencyBranchStatus: AgencyBranchInDetail;
  opeUpdateInvoicePaymentAvailability: AgencyBranchInDetail;
  opeUpdateMarkUpRateSetting: RateSetting;
  opeUpdateOperator: OpeUpdateOperatorResponse;
  opeUpdatePackageRateSetting: RateSetting;
  opeUpdateSaRateSetting: RateSetting;
  prepareToBookHotel: PrepareToBookHotelResponse;
  prepareToChangeTravelDate: PrepareToChangeTravelDateResponse;
  registerCreditCard: RegisterCreditCardResponse;
  resetPassword: Scalars['Boolean']['output'];
  updateProfile: Myself;
};


export type MutationBookExpediaHotelArgs = {
  input: BookExpediaHotelInput;
};


export type MutationCancelRoomsArgs = {
  input: CancelRoomsInput;
};


export type MutationChallengeToRegisterCreditCardArgs = {
  input: ChallengeToRegisterCreditCardInput;
};


export type MutationChangeRoomDetailsArgs = {
  input: ChangeRoomDetailsInput;
};


export type MutationChangeTravelDateArgs = {
  input: ChangeTravelDateInput;
};


export type MutationClipHotelRateArgs = {
  input: ClipHotelRateInput;
};


export type MutationConfirmChallengeToRegisterCreditCardArgs = {
  input: ConfirmChallengeToRegisterCreditCardInput;
};


export type MutationCreateAgencyRegistrationArgs = {
  input: CreateAgencyRegistrationInput;
};


export type MutationCreateAgencyTravelMemoArgs = {
  input: CreateAgencyTravelMemoInput;
};


export type MutationCreatePasswordResetCodeArgs = {
  input: CreatePasswordResetCodeInput;
};


export type MutationDebugOpeCreateInvoiceOfTravelsArgs = {
  branchId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationDelegateAgencyAdminArgs = {
  input: DelegateAgencyAdminInput;
};


export type MutationDeleteAgencyTravelMemoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClippedHotelRatesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCreditCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInviteEmployeeArgs = {
  input: InviteEmployeeInput;
};


export type MutationOpeCancelRoomsArgs = {
  input: CancelRoomsInput;
};


export type MutationOpeChangeRoomDetailsArgs = {
  input: ChangeRoomDetailsInput;
};


export type MutationOpeCreateAgencyBranchMemoArgs = {
  input: OpeCreateAgencyBranchMemoInput;
};


export type MutationOpeCreateOperatorArgs = {
  input: OpeCreateOperatorInput;
};


export type MutationOpeCreateTravelMemoArgs = {
  input: OpeCreateTravelMemoInput;
};


export type MutationOpeDeleteAgencyBranchMemoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOpeDeleteOperatorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOpeDeleteTravelMemoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOpeJudgeAgencyRegistrationArgs = {
  input: OpeJudgeAgencyRegistrationInput;
};


export type MutationOpeMakeInvoiceVoidArgs = {
  id: Scalars['ID']['input'];
  voidStatus: InvoiceStatus;
};


export type MutationOpeRefundRoomArgs = {
  input: OpeRefundRoomInput;
};


export type MutationOpeUpdateAgencyBranchSaRateSettingArgs = {
  input: OpeUpdateAgencyBranchSaRateSettingInput;
};


export type MutationOpeUpdateAgencyBranchStaffArgs = {
  input: OpeUpdateAgencyBranchStaffInput;
};


export type MutationOpeUpdateAgencyBranchStatusArgs = {
  id: Scalars['ID']['input'];
  status: AgencyBranchStatus;
};


export type MutationOpeUpdateInvoicePaymentAvailabilityArgs = {
  id: Scalars['ID']['input'];
  toBeAvailable: Scalars['Boolean']['input'];
};


export type MutationOpeUpdateMarkUpRateSettingArgs = {
  input: OpeUpdateMarkUpRateSettingInput;
};


export type MutationOpeUpdateOperatorArgs = {
  input: OpeUpdateOperatorInput;
};


export type MutationOpeUpdatePackageRateSettingArgs = {
  input: OpeUpdatePackageRateSettingInput;
};


export type MutationOpeUpdateSaRateSettingArgs = {
  input: OpeUpdateSaRateSettingInput;
};


export type MutationPrepareToBookHotelArgs = {
  input: PrepareToBookHotelInput;
};


export type MutationPrepareToChangeTravelDateArgs = {
  input: PrepareToChangeTravelDateInput;
};


export type MutationRegisterCreditCardArgs = {
  input: RegisterCreditCardInput;
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};

export type Myself = {
  __typename?: 'Myself';
  employee?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  /** 最新の申請 */
  latestAgencyRegistration?: Maybe<AgencyRegistration>;
};

export type News = Node & {
  __typename?: 'News';
  body: Scalars['String']['output'];
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  releaseDate: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  topImage?: Maybe<CmsImage>;
};

export type NewsConnection = Connection & {
  __typename?: 'NewsConnection';
  nodes: Array<News>;
  pageInfo: PageInfo;
};

export type NightCancelPenalty = CancelPenalty & {
  __typename?: 'NightCancelPenalty';
  currency: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  nights: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
};

export type NightCharge = {
  __typename?: 'NightCharge';
  currency: Scalars['String']['output'];
  type: NightlyChargeType;
  value: Scalars['Float']['output'];
};

export type NightPrice = {
  __typename?: 'NightPrice';
  /** 販売額における宿泊費 */
  stayPrice: Scalars['Int']['output'];
  /** 販売額における税サ */
  taxAndServicePrice: Scalars['Int']['output'];
};

export type NightlyChargeType =
  | 'adjustment'
  | 'base_rate'
  | 'compensation'
  | 'extra_person_fee'
  | 'property_fee'
  | 'recovery_charges_and_fees'
  | 'sales_tax'
  | 'tax_and_service_fee';

export type Node = {
  id: Scalars['ID']['output'];
};

export type Occupancy = {
  __typename?: 'Occupancy';
  ageCategories: Array<Maybe<AgeCategory>>;
  maxAllowed: MaxAllowed;
};

export type OfferType =
  | 'buy_one_get_one_free'
  | 'credit'
  | 'discount'
  | 'free'
  | 'voucher';

export type OnsitePayments = {
  __typename?: 'OnsitePayments';
  currency?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<Maybe<Brand>>>;
};

export type OpeAgencyBranchMemo = Node & {
  __typename?: 'OpeAgencyBranchMemo';
  branchId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  opeUser?: Maybe<OpeUser>;
  opeUserId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type OpeAgencyBranchesInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  staffName?: InputMaybe<Scalars['String']['input']>;
};

export type OpeAgencyRegistrationConnection = Connection & {
  __typename?: 'OpeAgencyRegistrationConnection';
  nodes: Array<AgencyRegistration>;
  pageInfo: PageInfo;
};

export type OpeAgencyRegistrationsInput = {
  statuses?: InputMaybe<Array<AgencyRegistrationStatus>>;
};

export type OpeCreateAgencyBranchMemoInput = {
  branchId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type OpeCreateOperatorErrorResponse = {
  __typename?: 'OpeCreateOperatorErrorResponse';
  errorCode: CreateOperatorErrorCode;
};

export type OpeCreateOperatorInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  role?: InputMaybe<OpeUserRole>;
};

export type OpeCreateOperatorResponse = OpeCreateOperatorErrorResponse | OpeCreateOperatorSuccessResponse;

export type OpeCreateOperatorSuccessResponse = {
  __typename?: 'OpeCreateOperatorSuccessResponse';
  OpeUser: OpeUser;
};

export type OpeCreateTravelMemoInput = {
  text: Scalars['String']['input'];
  travelId: Scalars['ID']['input'];
};

export type OpeCreateTravelMemoResponse = {
  __typename?: 'OpeCreateTravelMemoResponse';
  opeTravelMemo: OpeTravelMemo;
};

export type OpeDeleteOperatorInput = {
  id: Scalars['ID']['input'];
};

export type OpeDeleteOperatorResponse = {
  __typename?: 'OpeDeleteOperatorResponse';
  deletedOpeUser: OpeUser;
};

export type OpeDeleteTravelMemoResponse = {
  __typename?: 'OpeDeleteTravelMemoResponse';
  deletedOpeTravelMemo: OpeTravelMemo;
};

export type OpeFilterTravelsInput = {
  branchId?: InputMaybe<Scalars['ID']['input']>;
  checkin?: InputMaybe<CheckinRangeInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TravelStatusFilterInput>;
  travelNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OpeInvoicesInput = {
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
};

export type OpeJudgeAgencyRegistrationInput = {
  agencyRegistrationId: Scalars['ID']['input'];
  status: AgencyRegistrationStatus;
};

export type OpeJudgeAgencyRegistrationResponse = {
  __typename?: 'OpeJudgeAgencyRegistrationResponse';
  agency?: Maybe<Agency>;
  agencyBranch?: Maybe<AgencyBranchInDetail>;
  agencyRegistration: AgencyRegistration;
  employee?: Maybe<Employee>;
};

export type OpeRefundRoomAmount = {
  currency: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type OpeRefundRoomErrorCode =
  | 'failedToRefund'
  | 'invalidPairOfArgs'
  /** 請求書にすでに登録されているので返金できない */
  | 'invoiceAlreadyOpened'
  | 'paymentPriceExceeded';

export type OpeRefundRoomErrorResponse = {
  __typename?: 'OpeRefundRoomErrorResponse';
  errorCode: OpeRefundRoomErrorCode;
};

export type OpeRefundRoomInput = {
  expediaHotelRoomId: Scalars['ID']['input'];
  refundAmount: OpeRefundRoomAmount;
  roomItineraryId: Scalars['ID']['input'];
  travelId: Scalars['ID']['input'];
};

export type OpeRefundRoomResponse = OpeRefundRoomErrorResponse | OpeRefundRoomSuccessResponse;

export type OpeRefundRoomSuccessResponse = {
  __typename?: 'OpeRefundRoomSuccessResponse';
  travel: TravelInDetail;
};

export type OpeTravelMemo = Node & {
  __typename?: 'OpeTravelMemo';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  opeUser?: Maybe<OpeUser>;
  opeUserId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  travelId: Scalars['ID']['output'];
};

export type OpeUpdateAgencyBranchSaRateSettingInput = {
  branchId: Scalars['ID']['input'];
  tier: SaTierType;
};

export type OpeUpdateAgencyBranchStaffInput = {
  branchId: Scalars['ID']['input'];
  staffName: Scalars['String']['input'];
};

export type OpeUpdateMarkUpRateSettingInput = {
  saRatePercent?: InputMaybe<Scalars['Float']['input']>;
};

export type OpeUpdateOperatorInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  role: OpeUserRole;
};

export type OpeUpdateOperatorResponse = {
  __typename?: 'OpeUpdateOperatorResponse';
  opeUser: OpeUser;
};

export type OpeUpdatePackageRateSettingInput = {
  paymentRatePercent?: InputMaybe<Scalars['Float']['input']>;
  salesRatePercent?: InputMaybe<Scalars['Float']['input']>;
};

export type OpeUpdateSaRateSettingInput = {
  tier1Percent?: InputMaybe<Scalars['Float']['input']>;
  tier2Percent?: InputMaybe<Scalars['Float']['input']>;
  tier3Percent?: InputMaybe<Scalars['Float']['input']>;
  tier4Percent?: InputMaybe<Scalars['Float']['input']>;
};

export type OpeUser = Node & {
  __typename?: 'OpeUser';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  role: OpeUserRole;
};

export type OpeUserConnection = Connection & {
  __typename?: 'OpeUserConnection';
  nodes: Array<OpeUser>;
  pageInfo: PageInfo;
};

export type OpeUserRole =
  | 'admin'
  | 'member';

export type PackageRate = Rate & {
  __typename?: 'PackageRate';
  amenities: Array<Amenity>;
  availableRooms: Scalars['Float']['output'];
  bedGroups: Array<BedGroupAvailability>;
  cancelPenalties: Array<CancelPenalty>;
  cardOnFileLimit?: Maybe<Amount>;
  deposits?: Maybe<Array<Maybe<Deposit>>>;
  id: Scalars['ID']['output'];
  is3rdParty: Scalars['Boolean']['output'];
  isPackageRate: Scalars['Boolean']['output'];
  mappedRateAmenities: MappedRateAmenities;
  memberDealAvailable: Scalars['Boolean']['output'];
  merchantOfRecord: MerchantOfRecord;
  pricing: RatePricing;
  promotions?: Maybe<Promotions>;
  rateAmenities: RateAmenities;
  refundable: Scalars['Boolean']['output'];
  refundableDamageDeposit?: Maybe<Amount>;
  status: RateStatus;
};

export type PageInfo = PageInfoInterface & {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PageInfoInterface = {
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginationInput = {
  /** 指定したcursorより後のデータを取得する */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** limit指定なしだと全件取得 */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentType =
  | 'card'
  | 'invoice';

/** VoucherをPDFとして保存する方法 */
export type PdfHelp = {
  __typename?: 'PdfHelp';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PercentCancelPenalty = CancelPenalty & {
  __typename?: 'PercentCancelPenalty';
  currency: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  percent: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
};

export type PkgRateSetting = {
  __typename?: 'PkgRateSetting';
  id: Scalars['ID']['output'];
  paymentRatePercent: Scalars['Float']['output'];
  salesRatePercent: Scalars['Float']['output'];
};

export type Policies = {
  __typename?: 'Policies';
  knowBeforeYouGo: Scalars['String']['output'];
};

export type Preferred = {
  __typename?: 'Preferred';
  iataAirportCode: Scalars['String']['output'];
};

export type PrepareToBookHotelErrorCode =
  | 'noRate'
  | 'noRoom'
  | 'soldOut';

export type PrepareToBookHotelErrorResponse = {
  __typename?: 'PrepareToBookHotelErrorResponse';
  errorCode: PrepareToBookHotelErrorCode;
};

export type PrepareToBookHotelInput = {
  /** format: `YYYY-MM-DD` */
  checkin: Scalars['String']['input'];
  /** format: `YYYY-MM-DD` */
  checkout: Scalars['String']['input'];
  isHotelPackage: Scalars['Boolean']['input'];
  /** format: `numberOfAdults[-firstChildAge[,nextChildAge]]` */
  occupancies: Array<Scalars['String']['input']>;
  propertyId: Scalars['String']['input'];
  rateId: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
};

export type PrepareToBookHotelResponse = PrepareToBookHotelErrorResponse | PrepareToBookHotelSuccessResponse;

export type PrepareToBookHotelSuccessResponse = {
  __typename?: 'PrepareToBookHotelSuccessResponse';
  /** @deprecated Field no longer supported */
  creditCards: Array<StripeCreditCard>;
  enPropertyContent: PropertyContentInDetail;
  /** 請求書払の利用必須 */
  mustUseInvoicePayment: Scalars['Boolean']['output'];
  priceCheckId: Scalars['ID']['output'];
  propertyContent: PropertyContentInDetail;
  room: RoomAvailability;
  usingRate: Rate;
};

export type PrepareToChangeTravelDateErrorCode =
  | 'alreadyCanceled'
  | 'alreadyRebookedButNeedsCancel'
  | 'noEpsItinerary'
  | 'noTravel'
  | 'soldOut';

export type PrepareToChangeTravelDateErrorResponse = {
  __typename?: 'PrepareToChangeTravelDateErrorResponse';
  errorCode: PrepareToChangeTravelDateErrorCode;
};

export type PrepareToChangeTravelDateInput = {
  checkin: Scalars['String']['input'];
  checkout: Scalars['String']['input'];
  travelId: Scalars['ID']['input'];
};

export type PrepareToChangeTravelDateResponse = PrepareToChangeTravelDateErrorResponse | PrepareToChangeTravelDateSuccessResponse;

export type PrepareToChangeTravelDateSuccessResponse = {
  __typename?: 'PrepareToChangeTravelDateSuccessResponse';
  /** @deprecated Field no longer supported */
  creditCards: Array<StripeCreditCard>;
  /** 請求書払の利用必須 */
  mustUseInvoicePayment: Scalars['Boolean']['output'];
  priceCheckId: Scalars['ID']['output'];
  priceDifference: PriceDifferenceOfChangingTravelDate;
  rate: Rate;
};

export type PriceDifferenceOfChangingTravelDate = {
  __typename?: 'PriceDifferenceOfChangingTravelDate';
  /** キャンセル料 */
  cancelPenaltyPrice: Scalars['Int']['output'];
  /** 決済額（変更後） */
  paymentPriceAfter: Scalars['Int']['output'];
  /** 決済額（変更前） */
  paymentPriceBefore: Scalars['Int']['output'];
  /** 差額。+だったら追加で支払いが必要で、-だったら返金。 */
  totalDifferencePrice: Scalars['Int']['output'];
};

export type PricingInformation = {
  __typename?: 'PricingInformation';
  /** 日毎の内訳 */
  nightsPrice: Array<NightPrice>;
  /** occupanciesで渡したものがキーとして入ってる */
  occupancy: Scalars['String']['output'];
  /** 決済額 */
  paymentPrice: Scalars['Int']['output'];
  /** 現地支払額 */
  propertyPrice?: Maybe<PropertyPrice>;
  /** 販売額 */
  salesPrice: Scalars['Int']['output'];
};

/** プライバシーポリシー */
export type PrivacyPolicy = {
  __typename?: 'PrivacyPolicy';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Promotions = {
  __typename?: 'Promotions';
  deal?: Maybe<Deal>;
  valueAdds: Array<ValueAdd>;
};

export type Property = {
  __typename?: 'Property';
  rating: Scalars['Float']['output'];
  type: PropertyType;
};

export type PropertyContent = {
  address: Address;
  airports?: Maybe<Airports>;
  allInclusive?: Maybe<AllInclusive>;
  amenity: PropertyContentAmenities;
  attributes?: Maybe<Attributes>;
  brand: Brand;
  businessModel: BusinessModel;
  category: Brand;
  chain: Chain;
  checkin: Checkin;
  checkout?: Maybe<Checkout>;
  dates: Dates;
  descriptions: PropertyContentDescriptions;
  fax?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Fees>;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  importantNotes: ImportantNotes;
  location: Location;
  multiUnit: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  onsitePayments: OnsitePayments;
  paymentRegistrationRecommended: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  policies?: Maybe<Policies>;
  propertyId: Scalars['ID']['output'];
  rank: Scalars['Float']['output'];
  rates: Array<RateContent>;
  ratings?: Maybe<Ratings>;
  rooms: Array<Room>;
  spokenLanguages: Array<SpokenLanguage>;
  statistics: Array<Statistic>;
  supplySource: Scalars['String']['output'];
  taxId?: Maybe<Scalars['String']['output']>;
  vacationRentalDetails?: Maybe<VacationRentalDetails>;
};

/** botaで利用するアメニティに絞ってまとめたもの */
export type PropertyContentAmenities = {
  __typename?: 'PropertyContentAmenities';
  allTimeReception: Scalars['Boolean']['output'];
  fitness: Scalars['Boolean']['output'];
  freeWiFi: Scalars['Boolean']['output'];
  laundry: Scalars['Boolean']['output'];
  meetingRoom: Scalars['Boolean']['output'];
  multiLanguage: Scalars['Boolean']['output'];
  parking: Scalars['Boolean']['output'];
  pool: Scalars['Boolean']['output'];
  restaurants: Scalars['Boolean']['output'];
  sauna: Scalars['Boolean']['output'];
  spa: Scalars['Boolean']['output'];
};

export type PropertyContentDescriptions = {
  __typename?: 'PropertyContentDescriptions';
  amenities?: Maybe<Scalars['String']['output']>;
  businessAmenities?: Maybe<Scalars['String']['output']>;
  dining?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  nationalRatings?: Maybe<Scalars['String']['output']>;
  /** ホテル詳細のその他に対応(htmlタグが入ってくることがある) */
  renovations?: Maybe<Scalars['String']['output']>;
  rooms?: Maybe<Scalars['String']['output']>;
  /** 周辺空港(データの一例: 東京 - 成田国際空港 (NRT) - 69.4 km / 43.1 マイル) */
  surroundingAirports: Array<Scalars['String']['output']>;
  /** 周辺施設 */
  surroundingSpots: Array<Spot>;
};

/** 詳細画面で返却するPropertyContent */
export type PropertyContentInDetail = Node & PropertyContent & {
  __typename?: 'PropertyContentInDetail';
  address: Address;
  airports?: Maybe<Airports>;
  allInclusive?: Maybe<AllInclusive>;
  amenity: PropertyContentAmenities;
  attributes: Attributes;
  brand: Brand;
  businessModel: BusinessModel;
  category: Brand;
  chain: Chain;
  checkin: Checkin;
  checkout?: Maybe<Checkout>;
  dates: Dates;
  descriptions: PropertyContentDescriptions;
  fax?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Fees>;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  importantNotes: ImportantNotes;
  infectionPrevention: InfectionPrevention;
  language?: Maybe<Scalars['String']['output']>;
  location: Location;
  multiUnit: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  onsitePayments: OnsitePayments;
  paymentRegistrationRecommended: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  policies?: Maybe<Policies>;
  propertyId: Scalars['ID']['output'];
  rank: Scalars['Float']['output'];
  rates: Array<RateContent>;
  ratings?: Maybe<Ratings>;
  rooms: Array<Room>;
  roomsWithRate: Array<RoomWithRate>;
  spokenLanguages: Array<SpokenLanguage>;
  statistics: Array<Statistic>;
  supplySource: Scalars['String']['output'];
  taxId?: Maybe<Scalars['String']['output']>;
  themes: Array<Theme>;
  vacationRentalDetails?: Maybe<VacationRentalDetails>;
  withPet: WithPet;
};


/** 詳細画面で返却するPropertyContent */
export type PropertyContentInDetailRoomsWithRateArgs = {
  input: RoomsWithRateInput;
};

export type PropertyContentInDetailInput = {
  language?: InputMaybe<Language>;
};

/** 検索結果で返却するPropertyContent */
export type PropertyContentInSearch = Node & PropertyContent & {
  __typename?: 'PropertyContentInSearch';
  address: Address;
  airports?: Maybe<Airports>;
  allInclusive?: Maybe<AllInclusive>;
  amenity: PropertyContentAmenities;
  attributes?: Maybe<Attributes>;
  brand: Brand;
  businessModel: BusinessModel;
  category: Brand;
  chain: Chain;
  /** 1室1泊あたりのEPSから取得した最も安い料金 */
  cheapestPrice?: Maybe<SearchedPrice>;
  checkin: Checkin;
  checkout?: Maybe<Checkout>;
  dates: Dates;
  descriptions: PropertyContentDescriptions;
  fax?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Fees>;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  importantNotes: ImportantNotes;
  location: Location;
  multiUnit: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** 英語名 */
  nameEn?: Maybe<Scalars['String']['output']>;
  onsitePayments: OnsitePayments;
  paymentRegistrationRecommended: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  policies?: Maybe<Policies>;
  propertyId: Scalars['ID']['output'];
  rank: Scalars['Float']['output'];
  rates: Array<RateContent>;
  ratings?: Maybe<Ratings>;
  rooms: Array<Room>;
  spokenLanguages: Array<SpokenLanguage>;
  statistics: Array<Statistic>;
  supplySource: Scalars['String']['output'];
  taxId?: Maybe<Scalars['String']['output']>;
  vacationRentalDetails?: Maybe<VacationRentalDetails>;
};


/** 検索結果で返却するPropertyContent */
export type PropertyContentInSearchCheapestPriceArgs = {
  input: SearchPropertyContentPriceInput;
};

/** ゲストレビュー SSRでの利用は禁止(Expediaのルールでcacheすることが禁止されているため) */
export type PropertyGuestReview = {
  __typename?: 'PropertyGuestReview';
  body?: Maybe<Scalars['String']['output']>;
  rating: Scalars['String']['output'];
  reviewerName: Scalars['String']['output'];
  source?: Maybe<ReviewSource>;
  submittedDate: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PropertyManager = {
  __typename?: 'PropertyManager';
  links: Array<Maybe<Link>>;
  name: Scalars['String']['output'];
};

/** 現地支払額 */
export type PropertyPrice = {
  __typename?: 'PropertyPrice';
  /** 施設利用料 */
  mandatoryPrice?: Maybe<FeePrice>;
  /** 現地税 */
  mandatoryTaxPrice?: Maybe<FeePrice>;
  /** リゾート料金 */
  resortPrice?: Maybe<FeePrice>;
  total: FeePrice;
};

export type PropertyType =
  | 'Alternate'
  | 'Star';

export type Query = {
  __typename?: 'Query';
  clippedHotelRates: Array<ClippedHotelRate>;
  creditCards: Array<StripeCreditCard>;
  employees: EmployeeConnection;
  incrementalSearchPropertyContent: IncrementalSearchResponse;
  incrementalSearchRegion: IncrementalSearchResponse;
  invoiceDownloadLink: Scalars['String']['output'];
  invoices: InvoiceConnection;
  myself?: Maybe<Myself>;
  news: News;
  newsList: NewsConnection;
  opeAgencyBranch: AgencyBranchInDetail;
  opeAgencyBranchMemos: Array<OpeAgencyBranchMemo>;
  opeAgencyBranches: Array<AgencyBranchInList>;
  opeAgencyBranchesForCSV: Array<AgencyBranchInDetail>;
  opeAgencyRegistration: AgencyRegistration;
  opeAgencyRegistrations: OpeAgencyRegistrationConnection;
  opeEmployeesForCSV: Array<Employee>;
  opeInvoiceDownloadLink: Scalars['String']['output'];
  opeInvoices: InvoiceConnection;
  opeMyself?: Maybe<OpeUser>;
  opeOperators: OpeUserConnection;
  opeRateSetting: RateSetting;
  opeTravel: TravelInDetail;
  opeTravelDetailDownloadLink: Scalars['String']['output'];
  opeTravels: TravelConnection;
  opeTravelsForCSV: Array<TravelInDetail>;
  pdfHelp: PdfHelp;
  privacyPolicy: PrivacyPolicy;
  propertyContent: PropertyContentInDetail;
  propertyGuestReviews: Array<PropertyGuestReview>;
  searchPropertyContent: SearchPropertyContentResponse;
  terms: Terms;
  transactionLaw: TransactionLaw;
  travel: TravelInDetail;
  travelDetailDownloadLink: Scalars['String']['output'];
  travelDetails: Array<TravelInDetail>;
  travels: TravelConnection;
};


export type QueryEmployeesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryIncrementalSearchPropertyContentArgs = {
  input: IncrementalSearchPropertyContentInput;
};


export type QueryIncrementalSearchRegionArgs = {
  input: IncrementalSearchRegionInput;
};


export type QueryInvoiceDownloadLinkArgs = {
  input: InvoiceDownloadLinkInput;
};


export type QueryInvoicesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNewsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewsListArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOpeAgencyBranchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOpeAgencyBranchMemosArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryOpeAgencyBranchesArgs = {
  input: OpeAgencyBranchesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOpeAgencyRegistrationArgs = {
  agencyRegistrationId: Scalars['ID']['input'];
};


export type QueryOpeAgencyRegistrationsArgs = {
  input?: InputMaybe<OpeAgencyRegistrationsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOpeInvoiceDownloadLinkArgs = {
  input: InvoiceDownloadLinkInput;
};


export type QueryOpeInvoicesArgs = {
  input?: InputMaybe<OpeInvoicesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOpeOperatorsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOpeTravelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOpeTravelDetailDownloadLinkArgs = {
  input: TravelDetailDownloadLinkInput;
};


export type QueryOpeTravelsArgs = {
  input: OpeFilterTravelsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOpeTravelsForCsvArgs = {
  fiscalYear: Scalars['Int']['input'];
};


export type QueryPropertyContentArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<PropertyContentInDetailInput>;
};


export type QueryPropertyGuestReviewsArgs = {
  propertyId: Scalars['ID']['input'];
};


export type QuerySearchPropertyContentArgs = {
  input: SearchPropertyContentInput;
  pagination?: InputMaybe<SearchPropertyContentPaginationInput>;
};


export type QueryTravelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTravelDetailDownloadLinkArgs = {
  input: TravelDetailDownloadLinkInput;
};


export type QueryTravelsArgs = {
  input?: InputMaybe<FilterTravelsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type Rate = {
  amenities: Array<Amenity>;
  availableRooms: Scalars['Float']['output'];
  bedGroups: Array<BedGroupAvailability>;
  cancelPenalties: Array<CancelPenalty>;
  cardOnFileLimit?: Maybe<Amount>;
  deposits?: Maybe<Array<Maybe<Deposit>>>;
  id: Scalars['ID']['output'];
  is3rdParty: Scalars['Boolean']['output'];
  isPackageRate: Scalars['Boolean']['output'];
  mappedRateAmenities: MappedRateAmenities;
  memberDealAvailable: Scalars['Boolean']['output'];
  merchantOfRecord: MerchantOfRecord;
  pricing: RatePricing;
  promotions?: Maybe<Promotions>;
  rateAmenities: RateAmenities;
  refundable: Scalars['Boolean']['output'];
  refundableDamageDeposit?: Maybe<Amount>;
  status: RateStatus;
};

export type RateAmenities = {
  __typename?: 'RateAmenities';
  breakfast: Scalars['Boolean']['output'];
  freeWiFi: Scalars['Boolean']['output'];
  /** Expediaから取得できる食事に関するもの */
  mealLabels: Array<Scalars['String']['output']>;
  /** HoteCo側でカテゴライズしているもの */
  mealType?: Maybe<RateAmenitiesMealType>;
};

export type RateAmenitiesMealType =
  | 'allInclusive'
  | 'breakfastAndDinner'
  | 'breakfastOnly'
  | 'dinnerOnly'
  | 'fullBoard'
  | 'halfBoard';

export type RateContent = {
  __typename?: 'RateContent';
  amenities: Array<Amenity>;
  id: Scalars['String']['output'];
  mappedRateAmenities: MappedRateAmenities;
  rateAmenities: RateAmenities;
  specialOfferDescription?: Maybe<Scalars['String']['output']>;
};

export type RateItinerary = {
  __typename?: 'RateItinerary';
  /** 統一感ないので後で消したい */
  amenities: RateAmenities;
  amenityIds: Array<Scalars['String']['output']>;
  cancelPenalties: Array<CancelPenalty>;
  cancelRefund?: Maybe<CancelRefundItinerary>;
  id: Scalars['ID']['output'];
  is3rdParty: Scalars['Boolean']['output'];
  mappedRateAmenities: MappedRateAmenities;
  propertyPrice?: Maybe<PropertyPrice>;
  rateAmenities: RateAmenities;
  refundable: Scalars['Boolean']['output'];
};

export type RatePricing = {
  __typename?: 'RatePricing';
  averagePerOneRoomNight: RatePricingAverage;
  /** 客室ごとの料金 */
  occupancyPricing: Array<PricingInformation>;
  total: RatePricingTotal;
};

export type RatePricingAverage = {
  __typename?: 'RatePricingAverage';
  paymentPrice: Scalars['Int']['output'];
  salesPrice: Scalars['Int']['output'];
};

export type RatePricingTotal = {
  __typename?: 'RatePricingTotal';
  paymentPrice: Scalars['Int']['output'];
  /** 現地支払額 */
  propertyPrice?: Maybe<PropertyPrice>;
  salesPrice: Scalars['Int']['output'];
  stayPrice: Scalars['Int']['output'];
  taxAndServicePrice: Scalars['Int']['output'];
};

export type RateSetting = {
  __typename?: 'RateSetting';
  markUp: MarkUpRateSetting;
  pkg: PkgRateSetting;
  sa: SaRateSetting;
};

export type RateStatus =
  | 'available'
  | 'price_changed'
  | 'sold_out';

export type Ratings = {
  __typename?: 'Ratings';
  guest?: Maybe<Guest>;
  property?: Maybe<Property>;
};

export type RegisterCreditCardInput = {
  nickname: Scalars['String']['input'];
  paymentMethodId: Scalars['ID']['input'];
};

export type RegisterCreditCardResponse = {
  __typename?: 'RegisterCreditCardResponse';
  card: StripeCreditCard;
};

export type RentalAgreement = {
  __typename?: 'RentalAgreement';
  links: RentalAgreementLinks;
};

export type RentalAgreementLinks = {
  __typename?: 'RentalAgreementLinks';
  rentalAgreement: Link;
};

export type ReviewSource =
  | 'expedia'
  | 'hoteldotcom'
  | 'vrbo';

export type Room = {
  __typename?: 'Room';
  amenities: Array<Amenity>;
  area?: Maybe<Area>;
  bedGroups: Array<BedGroup>;
  descriptions?: Maybe<RoomDescriptions>;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  name?: Maybe<Scalars['String']['output']>;
  occupancy?: Maybe<Occupancy>;
  roomAmenities: RoomAmenities;
  views: Array<Brand>;
};

export type RoomAmenities = {
  __typename?: 'RoomAmenities';
  freeWiFi: Scalars['Boolean']['output'];
  smoking: AmenitySmoking;
};

export type RoomAvailability = {
  __typename?: 'RoomAvailability';
  id: Scalars['String']['output'];
  rates: Array<Rate>;
  roomName: Scalars['String']['output'];
};


export type RoomAvailabilityRatesArgs = {
  statuses?: InputMaybe<Array<RateStatus>>;
};

export type RoomDescriptions = {
  __typename?: 'RoomDescriptions';
  overview: Scalars['String']['output'];
};

export type RoomItinerary = {
  __typename?: 'RoomItinerary';
  bedGroupId?: Maybe<Scalars['String']['output']>;
  checkin: Scalars['String']['output'];
  checkout: Scalars['String']['output'];
  childAges: Array<Scalars['Int']['output']>;
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  numberOfAdults: Scalars['Int']['output'];
  propertyConfirmationId?: Maybe<Scalars['String']['output']>;
  rate: RateItinerary;
  /** EPS Room ID */
  roomId: Scalars['ID']['output'];
  roomNumber: Scalars['Int']['output'];
  smoking: Scalars['Boolean']['output'];
  specialRequest?: Maybe<Scalars['String']['output']>;
  status: RoomItineraryStatus;
  totalNights: Scalars['Int']['output'];
};

export type RoomItineraryStatus =
  | 'booked'
  | 'canceled'
  | 'pending';

/** RoomAvailabilityとは違い、部屋のアメニティ情報などもついている。PropertyContentのroomと混ぜてる。 */
export type RoomWithRate = {
  __typename?: 'RoomWithRate';
  amenities: Array<Amenity>;
  area?: Maybe<Area>;
  bedGroups: Array<BedGroup>;
  descriptions?: Maybe<RoomDescriptions>;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  name: Scalars['String']['output'];
  occupancy?: Maybe<Occupancy>;
  rates: Array<Rate>;
  roomAmenities: RoomAmenities;
  views: Array<Brand>;
};


/** RoomAvailabilityとは違い、部屋のアメニティ情報などもついている。PropertyContentのroomと混ぜてる。 */
export type RoomWithRateRatesArgs = {
  statuses?: InputMaybe<Array<RateStatus>>;
};

export type RoomsWithRateInput = {
  /** format: `YYYY-MM-DD` */
  checkin: Scalars['String']['input'];
  /** format: `YYYY-MM-DD` */
  checkout: Scalars['String']['input'];
  /** format: `numberOfAdults[-firstChildAge[,nextChildAge]]` */
  occupancies: Array<Scalars['String']['input']>;
};

export type SaRateSetting = {
  __typename?: 'SaRateSetting';
  id: Scalars['ID']['output'];
  tier1Percent: Scalars['Float']['output'];
  tier2Percent: Scalars['Float']['output'];
  tier3Percent: Scalars['Float']['output'];
  tier4Percent: Scalars['Float']['output'];
};

export type SaTierType =
  | 'tier1'
  | 'tier2'
  | 'tier3'
  | 'tier4';

export type SaleScenario = {
  __typename?: 'SaleScenario';
  corporate: Scalars['Boolean']['output'];
  distribution: Scalars['Boolean']['output'];
  member: Scalars['Boolean']['output'];
  package: Scalars['Boolean']['output'];
};

export type SearchPageInfo = PageInfoInterface & {
  __typename?: 'SearchPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type SearchPricingInfo = {
  __typename?: 'SearchPricingInfo';
  occupancy: Scalars['String']['output'];
};

export type SearchPropertyContentCategory =
  | 'apart'
  | 'bedBreakfast'
  | 'hostel'
  | 'hotel'
  | 'ryokan'
  | 'villa';

export type SearchPropertyContentCoordinate = {
  /** これは無視されるようになるので後で消す distance in km from passed coordinates */
  distance?: InputMaybe<Scalars['Float']['input']>;
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type SearchPropertyContentCurrency =
  | 'JPY';

export type SearchPropertyContentInput = {
  categories?: InputMaybe<Array<SearchPropertyContentCategory>>;
  /** format: `YYYY-MM-DD` */
  checkin?: InputMaybe<Scalars['String']['input']>;
  /** format: `YYYY-MM-DD` */
  checkout?: InputMaybe<Scalars['String']['input']>;
  coordinate?: InputMaybe<SearchPropertyContentCoordinate>;
  covid19Prevention?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<SearchPropertyContentCurrency>;
  facilities?: InputMaybe<Array<SearchPropertyContentInputFacility>>;
  gteGuestRating?: InputMaybe<Scalars['Float']['input']>;
  gteGuestRatingCount?: InputMaybe<Scalars['Int']['input']>;
  gteInclusivePrice?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  lteInclusivePrice?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** format: `numberOfAdults[-firstChildAge[,nextChildAge]]` */
  occupancies?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyContentId?: InputMaybe<Scalars['String']['input']>;
  propertyRatings?: InputMaybe<Array<SearchPropertyContentRatings>>;
  rateAmenities?: InputMaybe<SearchPropertyContentRateAmenityInput>;
  rateOption?: InputMaybe<SearchPropertyContentRateOption>;
  regionId?: InputMaybe<Scalars['String']['input']>;
  regionType?: InputMaybe<IncrementalSearchRegionTypeInput>;
  salesChannel?: InputMaybe<SearchPropertyContentSalesChannel>;
  salesEnvironment?: InputMaybe<SearchPropertyContentSalesEnvironment>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<SearchPropertyContentSortField>;
};

export type SearchPropertyContentInputFacility =
  | 'allTimeReception'
  | 'fitness'
  | 'freeWiFi'
  | 'lakeView'
  | 'laundry'
  | 'meetingRoom'
  | 'mountainView'
  | 'multiLanguage'
  | 'oceanView'
  | 'parking'
  | 'petOk'
  | 'pool'
  | 'restaurants'
  | 'sauna'
  | 'spa';

export type SearchPropertyContentPaginationInput = {
  /** 指定したcursorより後のデータを取得する */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** limit指定なしだと全件取得 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchPropertyContentPriceInput = {
  /** format: `YYYY-MM-DD` */
  checkin: Scalars['String']['input'];
  /** format: `YYYY-MM-DD` */
  checkout: Scalars['String']['input'];
  /** format: `numberOfAdults[-firstChildAge[,nextChildAge]]` */
  occupancies: Array<Scalars['String']['input']>;
};

export type SearchPropertyContentRateAmenityInput = {
  mealType?: InputMaybe<RateAmenitiesMealType>;
};

export type SearchPropertyContentRateOption =
  | 'none';

export type SearchPropertyContentRatings =
  | 's3'
  | 's4'
  | 's5';

export type SearchPropertyContentResponse = Connection & {
  __typename?: 'SearchPropertyContentResponse';
  nodes: Array<PropertyContentInSearch>;
  pageInfo: SearchPageInfo;
  pricingInfo?: Maybe<SearchPricingInfo>;
  /** inputで指定されたpropertyContent, 2ページ目以降はでない */
  specifiedPropertyContent?: Maybe<PropertyContentInSearch>;
};

export type SearchPropertyContentSalesChannel =
  | 'cache';

export type SearchPropertyContentSalesEnvironment =
  | 'hotelOnly'
  | 'hotelPackage';

export type SearchPropertyContentSortField =
  | 'inclusivePrice'
  | 'recommend';

export type SearchRegionCoordinate = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type SearchedPrice = {
  __typename?: 'SearchedPrice';
  /** 決済額 */
  paymentPrice: Scalars['Int']['output'];
  /** 販売額 */
  salesPrice: Scalars['Int']['output'];
};

export type SortDirection =
  | 'asc'
  | 'desc';

export type SpokenLanguage = {
  __typename?: 'SpokenLanguage';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Spot = {
  __typename?: 'Spot';
  distance: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StandAloneRate = Rate & {
  __typename?: 'StandAloneRate';
  amenities: Array<Amenity>;
  availableRooms: Scalars['Float']['output'];
  bedGroups: Array<BedGroupAvailability>;
  cancelPenalties: Array<CancelPenalty>;
  cardOnFileLimit?: Maybe<Amount>;
  deposits?: Maybe<Array<Maybe<Deposit>>>;
  id: Scalars['ID']['output'];
  is3rdParty: Scalars['Boolean']['output'];
  isPackageRate: Scalars['Boolean']['output'];
  mappedRateAmenities: MappedRateAmenities;
  memberDealAvailable: Scalars['Boolean']['output'];
  merchantOfRecord: MerchantOfRecord;
  pricing: RatePricing;
  promotions?: Maybe<Promotions>;
  rateAmenities: RateAmenities;
  refundable: Scalars['Boolean']['output'];
  refundableDamageDeposit?: Maybe<Amount>;
  status: RateStatus;
};

export type Statistic = {
  __typename?: 'Statistic';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Stay = {
  __typename?: 'Stay';
  currency: Scalars['String']['output'];
  type: StayType;
  value: Scalars['Float']['output'];
};

export type StayType =
  | 'base_rate'
  | 'property_fee'
  | 'sales_tax'
  | 'tax_and_service_fee';

export type StripeCreditCard = {
  __typename?: 'StripeCreditCard';
  branchId: Scalars['ID']['output'];
  brand: StripeCreditCardBrand;
  createdAt: Scalars['DateTime']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StripeCreditCardBrand =
  | 'amex'
  | 'diners'
  | 'discover'
  | 'jcb'
  | 'mastercard'
  | 'unionpay'
  | 'unknown'
  | 'visa';

/** 利用規約 */
export type Terms = {
  __typename?: 'Terms';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Theme = {
  __typename?: 'Theme';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** 特定商取引法表示 */
export type TransactionLaw = {
  __typename?: 'TransactionLaw';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TravelConnection = Connection & {
  __typename?: 'TravelConnection';
  nodes: Array<TravelInList>;
  pageInfo: PageInfo;
};

export type TravelDetailDownloadLinkInput = {
  /** 指定した部屋番号をそれぞれPDFにする。未指定の場合はすべての部屋を1つのPDFにする */
  roomNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  target: TravelDetailFileTarget;
  travelId: Scalars['ID']['input'];
};

export type TravelDetailFileTarget =
  /** お客様向け = 予約詳細 */
  | 'customer'
  /** ホテル向け = バウチャー */
  | 'hotel';

export type TravelHistory = Node & {
  __typename?: 'TravelHistory';
  createdAt: Scalars['DateTime']['output'];
  data: TravelHistoryData;
  historyType: TravelHistoryType;
  id: Scalars['ID']['output'];
  travelId: Scalars['ID']['output'];
};

export type TravelHistoryBy =
  | 'agencyBranch'
  | 'ope'
  | 'webhook';

export type TravelHistoryData = {
  dataType: TravelHistoryDataType;
};

export type TravelHistoryDataDateChanged = TravelHistoryData & {
  __typename?: 'TravelHistoryDataDateChanged';
  dataType: TravelHistoryDataType;
  nextTravelId: Scalars['ID']['output'];
};

export type TravelHistoryDataHotelOrRoomCreated = TravelHistoryData & {
  __typename?: 'TravelHistoryDataHotelOrRoomCreated';
  dataType: TravelHistoryDataType;
};

export type TravelHistoryDataRoomCanceled = TravelHistoryData & {
  __typename?: 'TravelHistoryDataRoomCanceled';
  by: TravelHistoryBy;
  dataType: TravelHistoryDataType;
  employeeId?: Maybe<Scalars['ID']['output']>;
  expediaHotelRoomId: Scalars['ID']['output'];
  roomItineraryId: Scalars['ID']['output'];
};

export type TravelHistoryDataRoomRefunded = TravelHistoryData & {
  __typename?: 'TravelHistoryDataRoomRefunded';
  by: TravelHistoryBy;
  dataType: TravelHistoryDataType;
  expediaHotelRoomId: Scalars['ID']['output'];
  refundPrice: Scalars['Int']['output'];
  roomItineraryId: Scalars['ID']['output'];
};

export type TravelHistoryDataTravelBooked = TravelHistoryData & {
  __typename?: 'TravelHistoryDataTravelBooked';
  dataType: TravelHistoryDataType;
  previousTravelId?: Maybe<Scalars['ID']['output']>;
};

export type TravelHistoryDataTravelCanceled = TravelHistoryData & {
  __typename?: 'TravelHistoryDataTravelCanceled';
  by: TravelHistoryBy;
  dataType: TravelHistoryDataType;
  employeeId?: Maybe<Scalars['ID']['output']>;
};

export type TravelHistoryDataType =
  | 'booked'
  | 'dateChanged'
  | 'hotelOrRoomCreated'
  | 'roomCanceled'
  | 'roomRefunded'
  | 'travelCanceled';

export type TravelHistoryType =
  | 'system';

export type TravelInDetail = Node & TravelInterface & {
  __typename?: 'TravelInDetail';
  agencyBranch: AgencyBranchInList;
  branchId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  employee?: Maybe<Employee>;
  employeeId: Scalars['ID']['output'];
  endDate: Scalars['DateTime']['output'];
  epsAffiliateReferenceId: Scalars['String']['output'];
  expediaHotelRooms: Array<ExpediaHotelRoom>;
  id: Scalars['ID']['output'];
  /** Expediaのドキュメント曰く作成されるのに少し時間がかかる場合があるらしいのでOptional */
  itinerary?: Maybe<Itinerary>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['ID']['output']>;
  paymentType: PaymentType;
  phone: Scalars['String']['output'];
  pricing: TravelPricing;
  /** propertyContentがExpediaから消える可能性がなくはないのでOptional */
  propertyContent?: Maybe<PropertyContentInDetail>;
  refundable: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
  status: TravelStatus;
  stripeCreditCard?: Maybe<StripeCreditCard>;
  travelNumber: Scalars['String']['output'];
  updateTimeline: Array<TravelUpdateTimeline>;
  updatedAt: Scalars['DateTime']['output'];
};


export type TravelInDetailPropertyContentArgs = {
  language?: InputMaybe<Language>;
};

export type TravelInList = Node & TravelInterface & {
  __typename?: 'TravelInList';
  agencyBranch: AgencyBranchInList;
  branchId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  employee?: Maybe<Employee>;
  employeeId: Scalars['ID']['output'];
  endDate: Scalars['DateTime']['output'];
  epsAffiliateReferenceId: Scalars['String']['output'];
  expediaHotelRooms: Array<ExpediaHotelRoom>;
  id: Scalars['ID']['output'];
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['ID']['output']>;
  paymentType: PaymentType;
  phone: Scalars['String']['output'];
  pricing: TravelPricing;
  refundable: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
  status: TravelStatus;
  travelNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TravelInterface = {
  agencyBranch: AgencyBranchInList;
  branchId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  employee?: Maybe<Employee>;
  employeeId: Scalars['ID']['output'];
  endDate: Scalars['DateTime']['output'];
  epsAffiliateReferenceId: Scalars['String']['output'];
  expediaHotelRooms: Array<ExpediaHotelRoom>;
  id: Scalars['ID']['output'];
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['ID']['output']>;
  paymentType: PaymentType;
  phone: Scalars['String']['output'];
  pricing: TravelPricing;
  refundable: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
  status: TravelStatus;
  travelNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TravelPricing = {
  __typename?: 'TravelPricing';
  averagePerOneRoomNight: RatePricingAverage;
  /** 客室ごとの料金 */
  occupancyPricing: Array<TravelPricingInformation>;
  total: TravelPricingTotal;
};

export type TravelPricingInformation = {
  __typename?: 'TravelPricingInformation';
  /** お支払い総額: 最終的な支出 */
  finalPaymentPrice: Scalars['Int']['output'];
  /** 日毎の内訳 */
  nightsPrice: Array<NightPrice>;
  /** occupanciesで渡したものがキーとして入ってる */
  occupancy: Scalars['String']['output'];
  /** 決済額 */
  paymentPrice: Scalars['Int']['output'];
  /** 返金額 */
  refundPrice: Scalars['Int']['output'];
  /** 販売額 */
  salesPrice: Scalars['Int']['output'];
};

export type TravelPricingTotal = {
  __typename?: 'TravelPricingTotal';
  /** 決済額から返金額を差し引いた金額。最終的な支出。 */
  finalPaymentPrice: Scalars['Int']['output'];
  /** 決済額。任意の決済手段で1度支払った金額（返金等は考慮されていない、クレカ等の明細に載る金額） */
  paymentPrice: Scalars['Int']['output'];
  refundPrice: Scalars['Int']['output'];
  salesPrice: Scalars['Int']['output'];
  stayPrice: Scalars['Int']['output'];
  taxAndServicePrice: Scalars['Int']['output'];
};

export type TravelStatus =
  | 'booked'
  | 'canceled';

export type TravelStatusFilterInput =
  | 'all'
  | 'booked'
  | 'canceled'
  | 'completed';

export type TravelUpdateTimeline = AgencyTravelMemo | OpeTravelMemo | TravelHistory;

export type UpdateProfileInput = {
  name: Scalars['String']['input'];
};

export type VacationRentalDetails = {
  __typename?: 'VacationRentalDetails';
  amenities?: Maybe<Array<Maybe<Amenity>>>;
  houseRules: Array<Maybe<Scalars['String']['output']>>;
  listingId?: Maybe<Scalars['String']['output']>;
  listingNumber?: Maybe<Scalars['String']['output']>;
  listingSource?: Maybe<Scalars['String']['output']>;
  listingUnit?: Maybe<Scalars['String']['output']>;
  privateHost: Scalars['Boolean']['output'];
  propertyManager?: Maybe<PropertyManager>;
  registryNumber?: Maybe<Scalars['String']['output']>;
  rentalAgreement?: Maybe<RentalAgreement>;
  vrboSrpId?: Maybe<Scalars['String']['output']>;
};

export type ValueAdd = {
  __typename?: 'ValueAdd';
  category?: Maybe<CategoryValueAdd>;
  description: Scalars['String']['output'];
  frequency: Frequency;
  id: Scalars['String']['output'];
  offerType: OfferType;
  personCount?: Maybe<Scalars['Float']['output']>;
};

export type WithPet =
  | 'allowed'
  | 'denied'
  | 'unknown';

export type CreateAgencyRegistrationMutationVariables = Exact<{
  input: CreateAgencyRegistrationInput;
}>;


export type CreateAgencyRegistrationMutation = { __typename?: 'Mutation', createAgencyRegistration: { __typename?: 'CreateAgencyRegistrationResponse', agencyRegistration: { __typename?: 'AgencyRegistration', id: string, uid: string, status: AgencyRegistrationStatus, createdAt: string, updatedAt: string } } };

export type ClippedHotelRateItemFragment = { __typename?: 'ClippedHotelRate', id: string, epsPropertyId: string, epsRoomId: string, epsRateId: string, isPackageRate: boolean, propertyContent?: { __typename?: 'PropertyContentInDetail', id: string, name: string, ratings?: { __typename?: 'Ratings', property?: { __typename?: 'Property', type: PropertyType, rating: number } | undefined } | undefined } | undefined, room?: { __typename?: 'RoomWithRate', id: string, name: string, descriptions?: { __typename?: 'RoomDescriptions', overview: string } | undefined, images: Array<{ __typename?: 'Image', url: string }>, bedGroups: Array<{ __typename?: 'BedGroup', description: string }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, roomAmenities: { __typename?: 'RoomAmenities', freeWiFi: boolean }, rates: Array<{ __typename?: 'PackageRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', freeWiFi: boolean, jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string, configuration: Array<{ __typename?: 'BedGroupConfiguration', quantity: number, size: string, type: string } | undefined> }>, promotions?: { __typename?: 'Promotions', deal?: { __typename?: 'Deal', description: string } | undefined, valueAdds: Array<{ __typename?: 'ValueAdd', id: string, description: string, category?: CategoryValueAdd | undefined, offerType: OfferType }> } | undefined, pricing: { __typename?: 'RatePricing', averagePerOneRoomNight: { __typename?: 'RatePricingAverage', salesPrice: number, paymentPrice: number }, total: { __typename?: 'RatePricingTotal', stayPrice: number, taxAndServicePrice: number, salesPrice: number, paymentPrice: number }, occupancyPricing: Array<{ __typename?: 'PricingInformation', nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } } | { __typename?: 'StandAloneRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', freeWiFi: boolean, jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string, configuration: Array<{ __typename?: 'BedGroupConfiguration', quantity: number, size: string, type: string } | undefined> }>, promotions?: { __typename?: 'Promotions', deal?: { __typename?: 'Deal', description: string } | undefined, valueAdds: Array<{ __typename?: 'ValueAdd', id: string, description: string, category?: CategoryValueAdd | undefined, offerType: OfferType }> } | undefined, pricing: { __typename?: 'RatePricing', averagePerOneRoomNight: { __typename?: 'RatePricingAverage', salesPrice: number, paymentPrice: number }, total: { __typename?: 'RatePricingTotal', stayPrice: number, taxAndServicePrice: number, salesPrice: number, paymentPrice: number }, occupancyPricing: Array<{ __typename?: 'PricingInformation', nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } }> } | undefined };

export type ClippedHotelRatesQueryVariables = Exact<{
  input: RoomsWithRateInput;
}>;


export type ClippedHotelRatesQuery = { __typename?: 'Query', clippedHotelRates: Array<{ __typename?: 'ClippedHotelRate', id: string, epsPropertyId: string, epsRoomId: string, epsRateId: string, isPackageRate: boolean, propertyContent?: { __typename?: 'PropertyContentInDetail', id: string, name: string, ratings?: { __typename?: 'Ratings', property?: { __typename?: 'Property', type: PropertyType, rating: number } | undefined } | undefined } | undefined, room?: { __typename?: 'RoomWithRate', id: string, name: string, descriptions?: { __typename?: 'RoomDescriptions', overview: string } | undefined, images: Array<{ __typename?: 'Image', url: string }>, bedGroups: Array<{ __typename?: 'BedGroup', description: string }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, roomAmenities: { __typename?: 'RoomAmenities', freeWiFi: boolean }, rates: Array<{ __typename?: 'PackageRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', freeWiFi: boolean, jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string, configuration: Array<{ __typename?: 'BedGroupConfiguration', quantity: number, size: string, type: string } | undefined> }>, promotions?: { __typename?: 'Promotions', deal?: { __typename?: 'Deal', description: string } | undefined, valueAdds: Array<{ __typename?: 'ValueAdd', id: string, description: string, category?: CategoryValueAdd | undefined, offerType: OfferType }> } | undefined, pricing: { __typename?: 'RatePricing', averagePerOneRoomNight: { __typename?: 'RatePricingAverage', salesPrice: number, paymentPrice: number }, total: { __typename?: 'RatePricingTotal', stayPrice: number, taxAndServicePrice: number, salesPrice: number, paymentPrice: number }, occupancyPricing: Array<{ __typename?: 'PricingInformation', nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } } | { __typename?: 'StandAloneRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', freeWiFi: boolean, jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string, configuration: Array<{ __typename?: 'BedGroupConfiguration', quantity: number, size: string, type: string } | undefined> }>, promotions?: { __typename?: 'Promotions', deal?: { __typename?: 'Deal', description: string } | undefined, valueAdds: Array<{ __typename?: 'ValueAdd', id: string, description: string, category?: CategoryValueAdd | undefined, offerType: OfferType }> } | undefined, pricing: { __typename?: 'RatePricing', averagePerOneRoomNight: { __typename?: 'RatePricingAverage', salesPrice: number, paymentPrice: number }, total: { __typename?: 'RatePricingTotal', stayPrice: number, taxAndServicePrice: number, salesPrice: number, paymentPrice: number }, occupancyPricing: Array<{ __typename?: 'PricingInformation', nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } }> } | undefined }> };

export type DeleteClippedHotelRatesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteClippedHotelRatesMutation = { __typename?: 'Mutation', deleteClippedHotelRates: Array<{ __typename?: 'ClippedHotelRate', id: string }> };

export type CreatePasswordResetCodeMutationVariables = Exact<{
  input: CreatePasswordResetCodeInput;
}>;


export type CreatePasswordResetCodeMutation = { __typename?: 'Mutation', createPasswordResetCode: { __typename?: 'CreatePasswordResetCodeResponse', code: string } };

export type HotelDetailInfectionPreventionFragment = { __typename?: 'InfectionPrevention', hasReinforcedCleaning: boolean, existHandSanitizer: boolean, nonFaceToFaceCheckin: boolean, hasCompliedGuidelines: boolean, disinfectionAndCleaningDescriptions: Array<string>, infectionPreventionSuppliesDescriptions: Array<string>, infectionControlConsiderationDescriptions: Array<string>, theOthersDescriptions: Array<string> };

export type HotelDetailAddressFragment = { __typename?: 'Address', stateProvinceName?: string | undefined, city: string, line1: string, line2?: string | undefined };

export type ClipHotelRateMutationVariables = Exact<{
  input: ClipHotelRateInput;
}>;


export type ClipHotelRateMutation = { __typename?: 'Mutation', clipHotelRate: { __typename: 'ClipHotelRateErrorResponse', errorCode: ClipHotelRateErrorCode } | { __typename: 'ClipHotelRateSuccessResponse', newClippedHotelRate: { __typename?: 'ClippedHotelRate', id: string } } };

export type ExpediaHotelDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  roomsWithRateInput: RoomsWithRateInput;
}>;


export type ExpediaHotelDetailQuery = { __typename?: 'Query', enPropertyContent: { __typename?: 'PropertyContentInDetail', id: string, language?: string | undefined, name: string }, jaPropertyContent: { __typename?: 'PropertyContentInDetail', id: string, language?: string | undefined, name: string, withPet: WithPet, category: { __typename?: 'Brand', name: string }, spokenLanguages: Array<{ __typename?: 'SpokenLanguage', id: string }>, themes: Array<{ __typename?: 'Theme', id: string, name: string }>, address: { __typename?: 'Address', stateProvinceName?: string | undefined, city: string, line1: string, line2?: string | undefined }, location: { __typename?: 'Location', coordinates: { __typename?: 'Coordinates', latitude: number, longitude: number } }, ratings?: { __typename?: 'Ratings', guest?: { __typename?: 'Guest', overall: number, cleanliness?: number | undefined, count: number } | undefined, property?: { __typename?: 'Property', rating: number, type: PropertyType } | undefined } | undefined, images: Array<{ __typename?: 'Image', url: string, category: ImageCategory, caption?: string | undefined }>, importantNotes: { __typename?: 'ImportantNotes', checkinSpecialInstructions?: string | undefined, mandatoryFee?: string | undefined, optionalFee?: string | undefined, instructions?: string | undefined, knowBeforeYouGo?: string | undefined, checkin?: { __typename?: 'CheckinNote', beginTime?: string | undefined, endTime?: string | undefined, minAge?: number | undefined, twentyFourHour?: string | undefined, checkoutTime?: string | undefined } | undefined }, descriptions: { __typename?: 'PropertyContentDescriptions', amenities?: string | undefined, surroundingAirports: Array<string>, businessAmenities?: string | undefined, dining?: string | undefined, headline?: string | undefined, location?: string | undefined, nationalRatings?: string | undefined, renovations?: string | undefined, rooms?: string | undefined, surroundingSpots: Array<{ __typename?: 'Spot', name: string, distance: string }> }, facility: { __typename?: 'PropertyContentAmenities', allTimeReception: boolean, freeWiFi: boolean, sauna: boolean, fitness: boolean, pool: boolean, laundry: boolean, restaurants: boolean, meetingRoom: boolean, multiLanguage: boolean, parking: boolean, spa: boolean }, reviewRating?: { __typename?: 'Ratings', guest?: { __typename?: 'Guest', overall: number, count: number, cleanliness?: number | undefined, service?: number | undefined, comfort?: number | undefined, condition?: number | undefined, neighborhood?: number | undefined, amenities?: number | undefined } | undefined } | undefined, infectionPrevention: { __typename?: 'InfectionPrevention', hasReinforcedCleaning: boolean, existHandSanitizer: boolean, nonFaceToFaceCheckin: boolean, hasCompliedGuidelines: boolean, disinfectionAndCleaningDescriptions: Array<string>, infectionPreventionSuppliesDescriptions: Array<string>, infectionControlConsiderationDescriptions: Array<string>, theOthersDescriptions: Array<string> }, roomsWithRate: Array<{ __typename?: 'RoomWithRate', id: string, name: string, descriptions?: { __typename?: 'RoomDescriptions', overview: string } | undefined, images: Array<{ __typename?: 'Image', url: string }>, bedGroups: Array<{ __typename?: 'BedGroup', description: string }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, roomAmenities: { __typename?: 'RoomAmenities', freeWiFi: boolean }, rates: Array<{ __typename?: 'PackageRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', freeWiFi: boolean, jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string, configuration: Array<{ __typename?: 'BedGroupConfiguration', quantity: number, size: string, type: string } | undefined> }>, promotions?: { __typename?: 'Promotions', deal?: { __typename?: 'Deal', description: string } | undefined, valueAdds: Array<{ __typename?: 'ValueAdd', id: string, description: string, category?: CategoryValueAdd | undefined, offerType: OfferType }> } | undefined, pricing: { __typename?: 'RatePricing', averagePerOneRoomNight: { __typename?: 'RatePricingAverage', salesPrice: number, paymentPrice: number }, total: { __typename?: 'RatePricingTotal', stayPrice: number, taxAndServicePrice: number, salesPrice: number, paymentPrice: number }, occupancyPricing: Array<{ __typename?: 'PricingInformation', nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } } | { __typename?: 'StandAloneRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', freeWiFi: boolean, jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string, configuration: Array<{ __typename?: 'BedGroupConfiguration', quantity: number, size: string, type: string } | undefined> }>, promotions?: { __typename?: 'Promotions', deal?: { __typename?: 'Deal', description: string } | undefined, valueAdds: Array<{ __typename?: 'ValueAdd', id: string, description: string, category?: CategoryValueAdd | undefined, offerType: OfferType }> } | undefined, pricing: { __typename?: 'RatePricing', averagePerOneRoomNight: { __typename?: 'RatePricingAverage', salesPrice: number, paymentPrice: number }, total: { __typename?: 'RatePricingTotal', stayPrice: number, taxAndServicePrice: number, salesPrice: number, paymentPrice: number }, occupancyPricing: Array<{ __typename?: 'PricingInformation', nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } }> }> }, propertyGuestReviews: Array<{ __typename?: 'PropertyGuestReview', source?: ReviewSource | undefined, rating: string, reviewerName: string, submittedDate: string, title?: string | undefined, body?: string | undefined }> };

export type ExpediaHotelRoomsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  roomsWithRateInput: RoomsWithRateInput;
}>;


export type ExpediaHotelRoomsQuery = { __typename?: 'Query', propertyContent: { __typename?: 'PropertyContentInDetail', id: string, roomsWithRate: Array<{ __typename?: 'RoomWithRate', id: string, name: string, descriptions?: { __typename?: 'RoomDescriptions', overview: string } | undefined, images: Array<{ __typename?: 'Image', url: string }>, bedGroups: Array<{ __typename?: 'BedGroup', description: string }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, roomAmenities: { __typename?: 'RoomAmenities', freeWiFi: boolean }, rates: Array<{ __typename?: 'PackageRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', freeWiFi: boolean, jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string, configuration: Array<{ __typename?: 'BedGroupConfiguration', quantity: number, size: string, type: string } | undefined> }>, promotions?: { __typename?: 'Promotions', deal?: { __typename?: 'Deal', description: string } | undefined, valueAdds: Array<{ __typename?: 'ValueAdd', id: string, description: string, category?: CategoryValueAdd | undefined, offerType: OfferType }> } | undefined, pricing: { __typename?: 'RatePricing', averagePerOneRoomNight: { __typename?: 'RatePricingAverage', salesPrice: number, paymentPrice: number }, total: { __typename?: 'RatePricingTotal', stayPrice: number, taxAndServicePrice: number, salesPrice: number, paymentPrice: number }, occupancyPricing: Array<{ __typename?: 'PricingInformation', nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } } | { __typename?: 'StandAloneRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', freeWiFi: boolean, jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string, configuration: Array<{ __typename?: 'BedGroupConfiguration', quantity: number, size: string, type: string } | undefined> }>, promotions?: { __typename?: 'Promotions', deal?: { __typename?: 'Deal', description: string } | undefined, valueAdds: Array<{ __typename?: 'ValueAdd', id: string, description: string, category?: CategoryValueAdd | undefined, offerType: OfferType }> } | undefined, pricing: { __typename?: 'RatePricing', averagePerOneRoomNight: { __typename?: 'RatePricingAverage', salesPrice: number, paymentPrice: number }, total: { __typename?: 'RatePricingTotal', stayPrice: number, taxAndServicePrice: number, salesPrice: number, paymentPrice: number }, occupancyPricing: Array<{ __typename?: 'PricingInformation', nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } }> }> } };

export type HotelDetailFacilityAmenityFragment = { __typename?: 'PropertyContentAmenities', allTimeReception: boolean, freeWiFi: boolean, sauna: boolean, fitness: boolean, pool: boolean, laundry: boolean, restaurants: boolean, meetingRoom: boolean, multiLanguage: boolean, parking: boolean, spa: boolean };

export type HotelDetailImageFragment = { __typename?: 'Image', url: string, category: ImageCategory, caption?: string | undefined };

export type HotelDetailGuestReviewFragment = { __typename?: 'PropertyGuestReview', source?: ReviewSource | undefined, rating: string, reviewerName: string, submittedDate: string, title?: string | undefined, body?: string | undefined };

export type HotelDetailGuestRatingFragment = { __typename?: 'Guest', overall: number, count: number, cleanliness?: number | undefined, service?: number | undefined, comfort?: number | undefined, condition?: number | undefined, neighborhood?: number | undefined, amenities?: number | undefined };

export type BookExpediaHotelMutationVariables = Exact<{
  input: BookExpediaHotelInput;
}>;


export type BookExpediaHotelMutation = { __typename?: 'Mutation', bookExpediaHotel: { __typename: 'BookExpediaHotelErrorResponse', errorCode: BookExpediaHotelErrorCode, rePrepareRequired: boolean, shouldAskToCardIssuer: boolean } | { __typename: 'BookExpediaHotelSuccessResponse', travel: { __typename?: 'TravelInDetail', id: string, expediaHotelRooms: Array<{ __typename?: 'ExpediaHotelRoom', id: string, familyName: string, givenName: string }> } } };

export type PrepareToBookHotelMutationVariables = Exact<{
  input: PrepareToBookHotelInput;
}>;


export type PrepareToBookHotelMutation = { __typename?: 'Mutation', prepareToBookHotel: { __typename: 'PrepareToBookHotelErrorResponse', errorCode: PrepareToBookHotelErrorCode } | { __typename: 'PrepareToBookHotelSuccessResponse', priceCheckId: string, mustUseInvoicePayment: boolean, propertyContent: { __typename?: 'PropertyContentInDetail', language?: string | undefined, id: string, name: string, attributes: { __typename?: 'Attributes', general: { __typename?: 'GeneralAttributes', canUseUnicodeInSpecialRequest: boolean } }, importantNotes: { __typename?: 'ImportantNotes', checkinSpecialInstructions?: string | undefined, mandatoryFee?: string | undefined, optionalFee?: string | undefined, instructions?: string | undefined, knowBeforeYouGo?: string | undefined, checkin?: { __typename?: 'CheckinNote', beginTime?: string | undefined, endTime?: string | undefined, minAge?: number | undefined, twentyFourHour?: string | undefined, checkoutTime?: string | undefined } | undefined }, rooms: Array<{ __typename?: 'Room', id: string, roomAmenities: { __typename?: 'RoomAmenities', smoking: AmenitySmoking } }>, ratings?: { __typename?: 'Ratings', property?: { __typename?: 'Property', rating: number, type: PropertyType } | undefined, guest?: { __typename?: 'Guest', overall: number, count: number } | undefined } | undefined, images: Array<{ __typename?: 'Image', url: string }> }, enPropertyContent: { __typename?: 'PropertyContentInDetail', id: string, language?: string | undefined, name: string }, room: { __typename?: 'RoomAvailability', id: string, roomName: string }, usingRate: { __typename?: 'PackageRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string }>, pricing: { __typename?: 'RatePricing', total: { __typename?: 'RatePricingTotal', salesPrice: number, paymentPrice: number, taxAndServicePrice: number, stayPrice: number, propertyPrice?: { __typename?: 'PropertyPrice', total: { __typename?: 'FeePrice', currency: string, value: number }, resortPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined, mandatoryPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined, mandatoryTaxPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined } | undefined }, occupancyPricing: Array<{ __typename?: 'PricingInformation', occupancy: string, salesPrice: number, paymentPrice: number, nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } } | { __typename?: 'StandAloneRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string }>, pricing: { __typename?: 'RatePricing', total: { __typename?: 'RatePricingTotal', salesPrice: number, paymentPrice: number, taxAndServicePrice: number, stayPrice: number, propertyPrice?: { __typename?: 'PropertyPrice', total: { __typename?: 'FeePrice', currency: string, value: number }, resortPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined, mandatoryPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined, mandatoryTaxPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined } | undefined }, occupancyPricing: Array<{ __typename?: 'PricingInformation', occupancy: string, salesPrice: number, paymentPrice: number, nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } } } };

export type PrepareToBookHotelSuccessFragment = { __typename?: 'PrepareToBookHotelSuccessResponse', priceCheckId: string, mustUseInvoicePayment: boolean, propertyContent: { __typename?: 'PropertyContentInDetail', language?: string | undefined, id: string, name: string, attributes: { __typename?: 'Attributes', general: { __typename?: 'GeneralAttributes', canUseUnicodeInSpecialRequest: boolean } }, importantNotes: { __typename?: 'ImportantNotes', checkinSpecialInstructions?: string | undefined, mandatoryFee?: string | undefined, optionalFee?: string | undefined, instructions?: string | undefined, knowBeforeYouGo?: string | undefined, checkin?: { __typename?: 'CheckinNote', beginTime?: string | undefined, endTime?: string | undefined, minAge?: number | undefined, twentyFourHour?: string | undefined, checkoutTime?: string | undefined } | undefined }, rooms: Array<{ __typename?: 'Room', id: string, roomAmenities: { __typename?: 'RoomAmenities', smoking: AmenitySmoking } }>, ratings?: { __typename?: 'Ratings', property?: { __typename?: 'Property', rating: number, type: PropertyType } | undefined, guest?: { __typename?: 'Guest', overall: number, count: number } | undefined } | undefined, images: Array<{ __typename?: 'Image', url: string }> }, enPropertyContent: { __typename?: 'PropertyContentInDetail', id: string, language?: string | undefined, name: string }, room: { __typename?: 'RoomAvailability', id: string, roomName: string }, usingRate: { __typename?: 'PackageRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string }>, pricing: { __typename?: 'RatePricing', total: { __typename?: 'RatePricingTotal', salesPrice: number, paymentPrice: number, taxAndServicePrice: number, stayPrice: number, propertyPrice?: { __typename?: 'PropertyPrice', total: { __typename?: 'FeePrice', currency: string, value: number }, resortPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined, mandatoryPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined, mandatoryTaxPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined } | undefined }, occupancyPricing: Array<{ __typename?: 'PricingInformation', occupancy: string, salesPrice: number, paymentPrice: number, nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } } | { __typename?: 'StandAloneRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string }>, pricing: { __typename?: 'RatePricing', total: { __typename?: 'RatePricingTotal', salesPrice: number, paymentPrice: number, taxAndServicePrice: number, stayPrice: number, propertyPrice?: { __typename?: 'PropertyPrice', total: { __typename?: 'FeePrice', currency: string, value: number }, resortPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined, mandatoryPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined, mandatoryTaxPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined } | undefined }, occupancyPricing: Array<{ __typename?: 'PricingInformation', occupancy: string, salesPrice: number, paymentPrice: number, nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } } };

export type SearchExpediaHotelRoomWithRateFragment = { __typename?: 'RoomWithRate', id: string, name: string, descriptions?: { __typename?: 'RoomDescriptions', overview: string } | undefined, images: Array<{ __typename?: 'Image', url: string }>, bedGroups: Array<{ __typename?: 'BedGroup', description: string }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, roomAmenities: { __typename?: 'RoomAmenities', freeWiFi: boolean }, rates: Array<{ __typename?: 'PackageRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', freeWiFi: boolean, jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string, configuration: Array<{ __typename?: 'BedGroupConfiguration', quantity: number, size: string, type: string } | undefined> }>, promotions?: { __typename?: 'Promotions', deal?: { __typename?: 'Deal', description: string } | undefined, valueAdds: Array<{ __typename?: 'ValueAdd', id: string, description: string, category?: CategoryValueAdd | undefined, offerType: OfferType }> } | undefined, pricing: { __typename?: 'RatePricing', averagePerOneRoomNight: { __typename?: 'RatePricingAverage', salesPrice: number, paymentPrice: number }, total: { __typename?: 'RatePricingTotal', stayPrice: number, taxAndServicePrice: number, salesPrice: number, paymentPrice: number }, occupancyPricing: Array<{ __typename?: 'PricingInformation', nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } } | { __typename?: 'StandAloneRate', id: string, status: RateStatus, availableRooms: number, refundable: boolean, isPackageRate: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', freeWiFi: boolean, jaMealLabels: Array<string> }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, bedGroups: Array<{ __typename?: 'BedGroupAvailability', id: string, description: string, configuration: Array<{ __typename?: 'BedGroupConfiguration', quantity: number, size: string, type: string } | undefined> }>, promotions?: { __typename?: 'Promotions', deal?: { __typename?: 'Deal', description: string } | undefined, valueAdds: Array<{ __typename?: 'ValueAdd', id: string, description: string, category?: CategoryValueAdd | undefined, offerType: OfferType }> } | undefined, pricing: { __typename?: 'RatePricing', averagePerOneRoomNight: { __typename?: 'RatePricingAverage', salesPrice: number, paymentPrice: number }, total: { __typename?: 'RatePricingTotal', stayPrice: number, taxAndServicePrice: number, salesPrice: number, paymentPrice: number }, occupancyPricing: Array<{ __typename?: 'PricingInformation', nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> } }> };

export type SearchPropertyContentQueryVariables = Exact<{
  input: SearchPropertyContentInput;
  regionInput: IncrementalSearchRegionInput;
  cheapestPriceInput: SearchPropertyContentPriceInput;
  pagination?: InputMaybe<SearchPropertyContentPaginationInput>;
}>;


export type SearchPropertyContentQuery = { __typename?: 'Query', searchPropertyContent: { __typename?: 'SearchPropertyContentResponse', pageInfo: { __typename?: 'SearchPageInfo', hasNextPage: boolean, endCursor?: string | undefined, totalCount: number }, nodes: Array<{ __typename?: 'PropertyContentInSearch', id: string, name: string, nameEn?: string | undefined, address: { __typename?: 'Address', stateProvinceName?: string | undefined, city: string, line1: string, line2?: string | undefined }, images: Array<{ __typename?: 'Image', url: string }>, location: { __typename?: 'Location', coordinates: { __typename?: 'Coordinates', latitude: number, longitude: number } }, ratings?: { __typename?: 'Ratings', property?: { __typename?: 'Property', type: PropertyType, rating: number } | undefined, guest?: { __typename?: 'Guest', overall: number, count: number } | undefined } | undefined, descriptions: { __typename?: 'PropertyContentDescriptions', headline?: string | undefined }, cheapestPrice?: { __typename?: 'SearchedPrice', salesPrice: number, paymentPrice: number } | undefined }>, specifiedPropertyContent?: { __typename?: 'PropertyContentInSearch', id: string, name: string, nameEn?: string | undefined, address: { __typename?: 'Address', stateProvinceName?: string | undefined, city: string, line1: string, line2?: string | undefined }, images: Array<{ __typename?: 'Image', url: string }>, location: { __typename?: 'Location', coordinates: { __typename?: 'Coordinates', latitude: number, longitude: number } }, ratings?: { __typename?: 'Ratings', property?: { __typename?: 'Property', type: PropertyType, rating: number } | undefined, guest?: { __typename?: 'Guest', overall: number, count: number } | undefined } | undefined, descriptions: { __typename?: 'PropertyContentDescriptions', headline?: string | undefined }, cheapestPrice?: { __typename?: 'SearchedPrice', salesPrice: number, paymentPrice: number } | undefined } | undefined }, incrementalSearchRegion: { __typename?: 'IncrementalSearchResponse', data: Array<{ __typename?: 'IncrementalSearchResponseData', id: string, name: string, type: IncrementalSearchResponseDataType, coordinates: { __typename?: 'Coordinates', latitude: number, longitude: number } }> } };

export type SearchPropertyContentItemFragment = { __typename?: 'PropertyContentInSearch', id: string, name: string, nameEn?: string | undefined, address: { __typename?: 'Address', stateProvinceName?: string | undefined, city: string, line1: string, line2?: string | undefined }, images: Array<{ __typename?: 'Image', url: string }>, location: { __typename?: 'Location', coordinates: { __typename?: 'Coordinates', latitude: number, longitude: number } }, ratings?: { __typename?: 'Ratings', property?: { __typename?: 'Property', type: PropertyType, rating: number } | undefined, guest?: { __typename?: 'Guest', overall: number, count: number } | undefined } | undefined, descriptions: { __typename?: 'PropertyContentDescriptions', headline?: string | undefined }, cheapestPrice?: { __typename?: 'SearchedPrice', salesPrice: number, paymentPrice: number } | undefined };

export type SearchPropertyContentSpotFragment = { __typename?: 'IncrementalSearchResponseData', id: string, name: string, type: IncrementalSearchResponseDataType, coordinates: { __typename?: 'Coordinates', latitude: number, longitude: number } };

export type InvoiceDownloadLinkQueryVariables = Exact<{
  input: InvoiceDownloadLinkInput;
}>;


export type InvoiceDownloadLinkQuery = { __typename?: 'Query', invoiceDownloadLink: string };

export type InvoicesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type InvoicesQuery = { __typename?: 'Query', myself?: { __typename?: 'Myself', employee?: { __typename?: 'Employee', id: string, agencyBranch: { __typename?: 'AgencyBranchInDetail', id: string, cashBalance: number } } | undefined } | undefined, invoices: { __typename?: 'InvoiceConnection', nodes: Array<{ __typename?: 'Invoice', id: string, invoiceNumber: string, status: InvoiceStatus, startDate: string, endDate: string, dueDate: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | undefined } } };

export type NewsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NewsQuery = { __typename?: 'Query', news: { __typename?: 'News', id: string, title: string, body: string, category: string, releaseDate: string, topImage?: { __typename?: 'CMSImage', url: string, width: number, height: number } | undefined } };

export type NewsListQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type NewsListQuery = { __typename?: 'Query', newsList: { __typename?: 'NewsConnection', nodes: Array<{ __typename?: 'News', id: string, releaseDate: string, title: string, category: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | undefined } } };

export type PdfPrintGuideQueryVariables = Exact<{ [key: string]: never; }>;


export type PdfPrintGuideQuery = { __typename?: 'Query', pdfHelp: { __typename?: 'PdfHelp', title: string, body: string } };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'Myself', id: string, employee?: { __typename?: 'Employee', id: string, name: string, updatedAt: string } | undefined } };

export type EditableBranchInfoFragment = { __typename?: 'AgencyBranchInDetail', id: string, name?: string | undefined, websiteUrl?: string | undefined, state: string, cityAndLine: string, phone: string, emergencyPhone: string, fax?: string | undefined, agency: { __typename?: 'Agency', name: string, nameEnglish: string, license: AgencyLicense, licenseNumber: string } };

export type SettingsBranchesQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsBranchesQuery = { __typename?: 'Query', myself?: { __typename?: 'Myself', employee?: { __typename?: 'Employee', id: string, role: EmployeeRole, agencyBranch: { __typename?: 'AgencyBranchInDetail', id: string, name?: string | undefined, websiteUrl?: string | undefined, state: string, cityAndLine: string, phone: string, emergencyPhone: string, fax?: string | undefined, agency: { __typename?: 'Agency', name: string, nameEnglish: string, license: AgencyLicense, licenseNumber: string } } } | undefined, latestAgencyRegistration?: { __typename?: 'AgencyRegistration', id: string, status: AgencyRegistrationStatus, type: AgencyRegistrationType } | undefined } | undefined };

export type UpdateAgencyBranchMutationVariables = Exact<{
  input: CreateAgencyRegistrationInput;
}>;


export type UpdateAgencyBranchMutation = { __typename?: 'Mutation', createAgencyRegistration: { __typename?: 'CreateAgencyRegistrationResponse', agencyRegistration: { __typename?: 'AgencyRegistration', id: string, status: AgencyRegistrationStatus, type: AgencyRegistrationType } } };

export type CreditCardInTableFragment = { __typename?: 'StripeCreditCard', id: string, nickname: string, brand: StripeCreditCardBrand, last4: string, expYear: number, expMonth: number };

export type CreditCardsInTableQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditCardsInTableQuery = { __typename?: 'Query', creditCards: Array<{ __typename?: 'StripeCreditCard', id: string, nickname: string, brand: StripeCreditCardBrand, last4: string, expYear: number, expMonth: number }> };

export type DeleteCreditCardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCreditCardMutation = { __typename?: 'Mutation', deleteCreditCard: { __typename?: 'DeleteCreditCardResponse', deletedCard: { __typename?: 'StripeCreditCard', id: string } } };

export type RegisterCreditCardMutationVariables = Exact<{
  input: RegisterCreditCardInput;
}>;


export type RegisterCreditCardMutation = { __typename?: 'Mutation', registerCreditCard: { __typename?: 'RegisterCreditCardResponse', card: { __typename?: 'StripeCreditCard', id: string, nickname: string, brand: StripeCreditCardBrand, last4: string, expYear: number, expMonth: number } } };

export type DelegateAgencyAdminMutationVariables = Exact<{
  input: DelegateAgencyAdminInput;
}>;


export type DelegateAgencyAdminMutation = { __typename?: 'Mutation', delegateAgencyAdmin: { __typename: 'DelegateAgencyAdminErrorResponse', errorCode: DelegateAgencyAdminErrorCode } | { __typename: 'DelegateAgencyAdminSuccessResponse', oldAdminEmployee: { __typename?: 'Employee', id: string, name: string, email: string, role: EmployeeRole, status: EmployeeStatus, createdAt: string }, newAdminEmployee: { __typename?: 'Employee', id: string, name: string, email: string, role: EmployeeRole, status: EmployeeStatus, createdAt: string } } };

export type DeleteEmployeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEmployeeMutation = { __typename?: 'Mutation', deleteEmployee: { __typename: 'DeleteEmployeeErrorResponse', errorCode: DeleteEmployeeErrorCode } | { __typename: 'DeleteEmployeeSuccessResponse', deletedEmployee: { __typename?: 'Employee', id: string, name: string, email: string, role: EmployeeRole, status: EmployeeStatus, createdAt: string } } };

export type EmployeeInTableFragment = { __typename?: 'Employee', id: string, name: string, email: string, role: EmployeeRole, status: EmployeeStatus, createdAt: string };

export type EmployeesQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type EmployeesQuery = { __typename?: 'Query', employees: { __typename?: 'EmployeeConnection', nodes: Array<{ __typename?: 'Employee', id: string, name: string, email: string, role: EmployeeRole, status: EmployeeStatus, createdAt: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | undefined } } };

export type InviteEmployeeMutationVariables = Exact<{
  input: InviteEmployeeInput;
}>;


export type InviteEmployeeMutation = { __typename?: 'Mutation', inviteEmployee: { __typename: 'InviteEmployeeErrorResponse', errorCode: InviteEmployeeErrorCode } | { __typename: 'InviteEmployeeSuccessResponse', invitedEmployee: { __typename?: 'Employee', id: string, name: string, email: string, role: EmployeeRole, status: EmployeeStatus, createdAt: string } } };

export type TermsQueryVariables = Exact<{ [key: string]: never; }>;


export type TermsQuery = { __typename?: 'Query', terms: { __typename?: 'Terms', title: string, body: string } };

export type TopQueryVariables = Exact<{
  newsPagination: PaginationInput;
}>;


export type TopQuery = { __typename?: 'Query', newsList: { __typename?: 'NewsConnection', nodes: Array<{ __typename?: 'News', id: string, releaseDate: string, title: string, category: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | undefined } } };

export type TransactionLawQueryVariables = Exact<{ [key: string]: never; }>;


export type TransactionLawQuery = { __typename?: 'Query', transactionLaw: { __typename?: 'TransactionLaw', title: string, body: string } };

export type CancelRoomsMutationVariables = Exact<{
  input: CancelRoomsInput;
}>;


export type CancelRoomsMutation = { __typename?: 'Mutation', cancelRooms: { __typename: 'CancelRoomsErrorResponse', errorCode: CancelRoomsErrorCode } | { __typename: 'CancelRoomsSuccessResponse', travel: { __typename?: 'TravelInDetail', id: string, status: TravelStatus, expediaHotelRooms: Array<{ __typename?: 'ExpediaHotelRoom', id: string, status: ExpediaHotelRoomStatus, canceledAt?: string | undefined }>, itinerary?: { __typename?: 'Itinerary', id: string, rooms: Array<{ __typename?: 'RoomItinerary', id: string, status: RoomItineraryStatus }> } | undefined } } };

export type ChangeTravelDateMutationVariables = Exact<{
  input: ChangeTravelDateInput;
}>;


export type ChangeTravelDateMutation = { __typename?: 'Mutation', changeTravelDate: { __typename: 'ChangeTravelDateErrorResponse', errorCode: ChangeTravelDateErrorCode, rePrepareRequired: boolean, shouldAskToCardIssuer: boolean } | { __typename: 'ChangeTravelDateSuccessResponse', oldTravel: { __typename?: 'TravelInDetail', id: string, status: TravelStatus, expediaHotelRooms: Array<{ __typename?: 'ExpediaHotelRoom', id: string, status: ExpediaHotelRoomStatus }> }, newTravel: { __typename?: 'TravelInDetail', id: string, travelNumber: string } } };

export type TravelCompletedToChangeDateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TravelCompletedToChangeDateQuery = { __typename?: 'Query', travel: { __typename?: 'TravelInDetail', id: string, travelNumber: string } };

export type PrepareToChangeTravelDateMutationVariables = Exact<{
  input: PrepareToChangeTravelDateInput;
}>;


export type PrepareToChangeTravelDateMutation = { __typename?: 'Mutation', prepareToChangeTravelDate: { __typename: 'PrepareToChangeTravelDateErrorResponse', errorCode: PrepareToChangeTravelDateErrorCode } | { __typename: 'PrepareToChangeTravelDateSuccessResponse', priceCheckId: string, mustUseInvoicePayment: boolean, priceDifference: { __typename?: 'PriceDifferenceOfChangingTravelDate', paymentPriceAfter: number, paymentPriceBefore: number, cancelPenaltyPrice: number, totalDifferencePrice: number }, rate: { __typename?: 'PackageRate', id: string, refundable: boolean, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }> } | { __typename?: 'StandAloneRate', id: string, refundable: boolean, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }> }, creditCards: Array<{ __typename?: 'StripeCreditCard', id: string, brand: StripeCreditCardBrand, last4: string, nickname: string }> } };

export type PrepareToChangeTravelDateSuccessFragment = { __typename?: 'PrepareToChangeTravelDateSuccessResponse', priceCheckId: string, mustUseInvoicePayment: boolean, priceDifference: { __typename?: 'PriceDifferenceOfChangingTravelDate', paymentPriceAfter: number, paymentPriceBefore: number, cancelPenaltyPrice: number, totalDifferencePrice: number }, rate: { __typename?: 'PackageRate', id: string, refundable: boolean, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }> } | { __typename?: 'StandAloneRate', id: string, refundable: boolean, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }> }, creditCards: Array<{ __typename?: 'StripeCreditCard', id: string, brand: StripeCreditCardBrand, last4: string, nickname: string }> };

export type ChangeRoomDetailsSuccessFragment = { __typename?: 'ChangeRoomDetailsSuccessResponse', travel: { __typename?: 'TravelInDetail', id: string, status: TravelStatus, expediaHotelRooms: Array<{ __typename?: 'ExpediaHotelRoom', id: string, familyName: string, givenName: string, specialRequest?: string | undefined }>, itinerary?: { __typename?: 'Itinerary', id: string, rooms: Array<{ __typename?: 'RoomItinerary', id: string, status: RoomItineraryStatus, familyName: string, givenName: string, specialRequest?: string | undefined }> } | undefined } };

export type ChangeRoomDetailsMutationVariables = Exact<{
  input: ChangeRoomDetailsInput;
}>;


export type ChangeRoomDetailsMutation = { __typename?: 'Mutation', changeRoomDetails: { __typename: 'ChangeRoomDetailsErrorResponse', errorCode: ChangeRoomDetailsErrorCode } | { __typename: 'ChangeRoomDetailsSuccessResponse', travel: { __typename?: 'TravelInDetail', id: string, status: TravelStatus, expediaHotelRooms: Array<{ __typename?: 'ExpediaHotelRoom', id: string, familyName: string, givenName: string, specialRequest?: string | undefined }>, itinerary?: { __typename?: 'Itinerary', id: string, rooms: Array<{ __typename?: 'RoomItinerary', id: string, status: RoomItineraryStatus, familyName: string, givenName: string, specialRequest?: string | undefined }> } | undefined } } };

export type CompletedBookingTravelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompletedBookingTravelQuery = { __typename?: 'Query', travel: { __typename?: 'TravelInDetail', id: string, travelNumber: string } };

export type ItineraryHotelAddressFragment = { __typename?: 'Address', postalCode?: string | undefined, stateProvinceName?: string | undefined, city: string, line1: string, line2?: string | undefined };

export type ItinerariesQueryVariables = Exact<{
  travelId: Scalars['ID']['input'];
}>;


export type ItinerariesQuery = { __typename?: 'Query', travel: { __typename?: 'TravelInDetail', id: string, travelNumber: string, status: TravelStatus, jaPropertyContent?: { __typename?: 'PropertyContentInDetail', id: string, language?: string | undefined, name: string, phone?: string | undefined, address: { __typename?: 'Address', postalCode?: string | undefined, stateProvinceName?: string | undefined, city: string, line1: string, line2?: string | undefined }, rooms: Array<{ __typename?: 'Room', id: string, name?: string | undefined }>, rates: Array<{ __typename?: 'RateContent', id: string, mappedRateAmenities: { __typename?: 'MappedRateAmenities', jaMealLabels: Array<string> } }>, importantNotes: { __typename?: 'ImportantNotes', checkinSpecialInstructions?: string | undefined, mandatoryFee?: string | undefined, instructions?: string | undefined, optionalFee?: string | undefined, checkin?: { __typename?: 'CheckinNote', beginTime?: string | undefined, endTime?: string | undefined, minAge?: number | undefined, twentyFourHour?: string | undefined, checkoutTime?: string | undefined } | undefined } } | undefined, enPropertyContent?: { __typename?: 'PropertyContentInDetail', id: string, language?: string | undefined, name: string, address: { __typename?: 'Address', postalCode?: string | undefined, stateProvinceName?: string | undefined, city: string, line1: string, line2?: string | undefined } } | undefined, itinerary?: { __typename?: 'Itinerary', id: string, rooms: Array<{ __typename?: 'RoomItinerary', id: string, roomId: string, status: RoomItineraryStatus, familyName: string, givenName: string, checkin: string, checkout: string, totalNights: number, specialRequest?: string | undefined, smoking: boolean, roomNumber: number, rate: { __typename?: 'RateItinerary', id: string, refundable: boolean, mappedRateAmenities: { __typename?: 'MappedRateAmenities', jaMealLabels: Array<string>, wifi?: { __typename?: 'MappedRateAmenity', id: string, jaName: string, enName: string } | undefined }, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }> } }> } | undefined } };

export type TravelDetailDownloadLinkQueryVariables = Exact<{
  input: TravelDetailDownloadLinkInput;
}>;


export type TravelDetailDownloadLinkQuery = { __typename?: 'Query', travelDetailDownloadLink: string };

export type TravelInDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TravelInDetailQuery = { __typename?: 'Query', travel: { __typename?: 'TravelInDetail', id: string, travelNumber: string, email: string, phone: string, paymentType: PaymentType, status: TravelStatus, expediaHotelRooms: Array<{ __typename?: 'ExpediaHotelRoom', id: string, roomName: string, roomNumber: number, status: ExpediaHotelRoomStatus, hotelName: string }>, pricing: { __typename?: 'TravelPricing', total: { __typename?: 'TravelPricingTotal', salesPrice: number, paymentPrice: number, taxAndServicePrice: number, stayPrice: number, refundPrice: number, finalPaymentPrice: number }, occupancyPricing: Array<{ __typename?: 'TravelPricingInformation', occupancy: string, salesPrice: number, paymentPrice: number, refundPrice: number, finalPaymentPrice: number, nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> }, employee?: { __typename?: 'Employee', id: string, name: string, email: string, status: EmployeeStatus } | undefined, stripeCreditCard?: { __typename?: 'StripeCreditCard', id: string, brand: StripeCreditCardBrand, last4: string } | undefined, enPropertyContent?: { __typename?: 'PropertyContentInDetail', id: string, language?: string | undefined, name: string } | undefined, propertyContent?: { __typename?: 'PropertyContentInDetail', id: string, language?: string | undefined, name: string, ratings?: { __typename?: 'Ratings', property?: { __typename?: 'Property', rating: number, type: PropertyType } | undefined, guest?: { __typename?: 'Guest', overall: number, count: number } | undefined } | undefined, images: Array<{ __typename?: 'Image', url: string }>, importantNotes: { __typename?: 'ImportantNotes', checkinSpecialInstructions?: string | undefined, mandatoryFee?: string | undefined, optionalFee?: string | undefined, instructions?: string | undefined, knowBeforeYouGo?: string | undefined, checkin?: { __typename?: 'CheckinNote', beginTime?: string | undefined, endTime?: string | undefined, minAge?: number | undefined, twentyFourHour?: string | undefined, checkoutTime?: string | undefined } | undefined }, attributes: { __typename?: 'Attributes', general: { __typename?: 'GeneralAttributes', canUseUnicodeInSpecialRequest: boolean } }, rates: Array<{ __typename?: 'RateContent', id: string, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', jaMealLabels: Array<string> } }> } | undefined, itinerary?: { __typename?: 'Itinerary', id: string, rooms: Array<{ __typename?: 'RoomItinerary', id: string, bedGroupId?: string | undefined, checkin: string, checkout: string, numberOfAdults: number, childAges: Array<number>, givenName: string, familyName: string, status: RoomItineraryStatus, smoking: boolean, specialRequest?: string | undefined, rate: { __typename?: 'RateItinerary', id: string, refundable: boolean, amenityIds: Array<string>, is3rdParty: boolean, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }>, mappedRateAmenities: { __typename?: 'MappedRateAmenities', jaMealLabels: Array<string>, mealType?: RateAmenitiesMealType | undefined } } }>, totalPropertyPrice?: { __typename?: 'PropertyPrice', total: { __typename?: 'FeePrice', currency: string, value: number }, resortPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined, mandatoryPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined, mandatoryTaxPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined } | undefined } | undefined, updateTimeline: Array<{ __typename?: 'AgencyTravelMemo', id: string, text: string, createdAt: string, employee?: { __typename?: 'Employee', id: string, name: string } | undefined } | { __typename?: 'OpeTravelMemo' } | { __typename?: 'TravelHistory', id: string, historyType: TravelHistoryType, createdAt: string, data: { __typename?: 'TravelHistoryDataDateChanged', dataType: TravelHistoryDataType, nextTravelId: string } | { __typename?: 'TravelHistoryDataHotelOrRoomCreated', dataType: TravelHistoryDataType } | { __typename?: 'TravelHistoryDataRoomCanceled', expediaHotelRoomId: string, roomItineraryId: string, by: TravelHistoryBy, employeeId?: string | undefined, dataType: TravelHistoryDataType } | { __typename?: 'TravelHistoryDataRoomRefunded', dataType: TravelHistoryDataType, expediaHotelRoomId: string, roomItineraryId: string, refundPrice: number } | { __typename?: 'TravelHistoryDataTravelBooked', dataType: TravelHistoryDataType, previousTravelId?: string | undefined } | { __typename?: 'TravelHistoryDataTravelCanceled', by: TravelHistoryBy, employeeId?: string | undefined, dataType: TravelHistoryDataType } }> } };

export type TravelUpdateTimelineAgencyTravelMemoFragment = { __typename?: 'AgencyTravelMemo', id: string, text: string, createdAt: string, employee?: { __typename?: 'Employee', id: string, name: string } | undefined };

export type CreateAgencyTravelMemoMutationVariables = Exact<{
  input: CreateAgencyTravelMemoInput;
}>;


export type CreateAgencyTravelMemoMutation = { __typename?: 'Mutation', createAgencyTravelMemo: { __typename?: 'CreateAgencyTravelMemoResponse', agencyTravelMemo: { __typename?: 'AgencyTravelMemo', id: string, travelId: string, employeeId: string, text: string, createdAt: string, employee?: { __typename?: 'Employee', id: string, name: string } | undefined } } };

export type DeleteAgencyTravelMemoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAgencyTravelMemoMutation = { __typename?: 'Mutation', deleteAgencyTravelMemo: { __typename?: 'DeleteAgencyTravelMemoResponse', deletedAgencyTravelMemo: { __typename?: 'AgencyTravelMemo', id: string } } };

export type TravelUpdateTimelineTravelHistoryFragment = { __typename?: 'TravelHistory', id: string, historyType: TravelHistoryType, createdAt: string, data: { __typename?: 'TravelHistoryDataDateChanged', dataType: TravelHistoryDataType, nextTravelId: string } | { __typename?: 'TravelHistoryDataHotelOrRoomCreated', dataType: TravelHistoryDataType } | { __typename?: 'TravelHistoryDataRoomCanceled', expediaHotelRoomId: string, roomItineraryId: string, by: TravelHistoryBy, employeeId?: string | undefined, dataType: TravelHistoryDataType } | { __typename?: 'TravelHistoryDataRoomRefunded', dataType: TravelHistoryDataType, expediaHotelRoomId: string, roomItineraryId: string, refundPrice: number } | { __typename?: 'TravelHistoryDataTravelBooked', dataType: TravelHistoryDataType, previousTravelId?: string | undefined } | { __typename?: 'TravelHistoryDataTravelCanceled', by: TravelHistoryBy, employeeId?: string | undefined, dataType: TravelHistoryDataType } };

export type TravelUpdateTimelineFragment = { __typename?: 'TravelInDetail', updateTimeline: Array<{ __typename?: 'AgencyTravelMemo', id: string, text: string, createdAt: string, employee?: { __typename?: 'Employee', id: string, name: string } | undefined } | { __typename?: 'OpeTravelMemo' } | { __typename?: 'TravelHistory', id: string, historyType: TravelHistoryType, createdAt: string, data: { __typename?: 'TravelHistoryDataDateChanged', dataType: TravelHistoryDataType, nextTravelId: string } | { __typename?: 'TravelHistoryDataHotelOrRoomCreated', dataType: TravelHistoryDataType } | { __typename?: 'TravelHistoryDataRoomCanceled', expediaHotelRoomId: string, roomItineraryId: string, by: TravelHistoryBy, employeeId?: string | undefined, dataType: TravelHistoryDataType } | { __typename?: 'TravelHistoryDataRoomRefunded', dataType: TravelHistoryDataType, expediaHotelRoomId: string, roomItineraryId: string, refundPrice: number } | { __typename?: 'TravelHistoryDataTravelBooked', dataType: TravelHistoryDataType, previousTravelId?: string | undefined } | { __typename?: 'TravelHistoryDataTravelCanceled', by: TravelHistoryBy, employeeId?: string | undefined, dataType: TravelHistoryDataType } }> };

export type VoucherHotelAddressFragment = { __typename?: 'Address', postalCode?: string | undefined, stateProvinceName?: string | undefined, city: string, line1: string, line2?: string | undefined };

export type VouchersQueryVariables = Exact<{
  travelId: Scalars['ID']['input'];
}>;


export type VouchersQuery = { __typename?: 'Query', travel: { __typename?: 'TravelInDetail', id: string, travelNumber: string, status: TravelStatus, jaPropertyContent?: { __typename?: 'PropertyContentInDetail', id: string, name: string, phone?: string | undefined, address: { __typename?: 'Address', postalCode?: string | undefined, stateProvinceName?: string | undefined, city: string, line1: string, line2?: string | undefined }, rooms: Array<{ __typename?: 'Room', id: string, name?: string | undefined }>, importantNotes: { __typename?: 'ImportantNotes', checkinSpecialInstructions?: string | undefined, mandatoryFee?: string | undefined, checkin?: { __typename?: 'CheckinNote', beginTime?: string | undefined, endTime?: string | undefined, minAge?: number | undefined, twentyFourHour?: string | undefined, checkoutTime?: string | undefined } | undefined } } | undefined, enPropertyContent?: { __typename?: 'PropertyContentInDetail', id: string, name: string, address: { __typename?: 'Address', postalCode?: string | undefined, stateProvinceName?: string | undefined, city: string, line1: string, line2?: string | undefined }, rooms: Array<{ __typename?: 'Room', id: string, name?: string | undefined }> } | undefined, itinerary?: { __typename?: 'Itinerary', id: string, rooms: Array<{ __typename?: 'RoomItinerary', id: string, roomId: string, propertyConfirmationId?: string | undefined, status: RoomItineraryStatus, familyName: string, givenName: string, checkin: string, checkout: string, totalNights: number, specialRequest?: string | undefined, smoking: boolean, rate: { __typename?: 'RateItinerary', id: string, mappedRateAmenities: { __typename?: 'MappedRateAmenities', freeWiFi: boolean, jaMealLabels: Array<string>, enMealLabels: Array<string>, wifi?: { __typename?: 'MappedRateAmenity', id: string, jaName: string, enName: string } | undefined } } }> } | undefined } };

export type TravelsQueryVariables = Exact<{
  input?: InputMaybe<FilterTravelsInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type TravelsQuery = { __typename?: 'Query', travels: { __typename?: 'TravelConnection', nodes: Array<{ __typename?: 'TravelInList', id: string, travelNumber: string, paymentType: PaymentType, startDate: string, endDate: string, createdAt: string, employee?: { __typename?: 'Employee', id: string, name: string } | undefined, pricing: { __typename?: 'TravelPricing', total: { __typename?: 'TravelPricingTotal', finalPaymentPrice: number } }, expediaHotelRooms: Array<{ __typename?: 'ExpediaHotelRoom', id: string, hotelName: string, city?: string | undefined, isPackageRate: boolean, familyName: string, givenName: string }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | undefined } } };

type CancelPenalties_AmountCancelPenalty_Fragment = { __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string };

type CancelPenalties_NightCancelPenalty_Fragment = { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string };

type CancelPenalties_PercentCancelPenalty_Fragment = { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string };

export type CancelPenaltiesFragment = CancelPenalties_AmountCancelPenalty_Fragment | CancelPenalties_NightCancelPenalty_Fragment | CancelPenalties_PercentCancelPenalty_Fragment;

export type HotelImportantNotesFragment = { __typename?: 'ImportantNotes', checkinSpecialInstructions?: string | undefined, mandatoryFee?: string | undefined, optionalFee?: string | undefined, instructions?: string | undefined, knowBeforeYouGo?: string | undefined, checkin?: { __typename?: 'CheckinNote', beginTime?: string | undefined, endTime?: string | undefined, minAge?: number | undefined, twentyFourHour?: string | undefined, checkoutTime?: string | undefined } | undefined };

export type HotelOverviewCardFragment = { __typename?: 'PropertyContentInDetail', id: string, name: string, ratings?: { __typename?: 'Ratings', property?: { __typename?: 'Property', rating: number, type: PropertyType } | undefined, guest?: { __typename?: 'Guest', overall: number, count: number } | undefined } | undefined, images: Array<{ __typename?: 'Image', url: string }> };

export type NewsListItemFragment = { __typename?: 'News', id: string, releaseDate: string, title: string, category: string };

export type RoomPriceDetailTableForRatePricingFragment = { __typename?: 'RatePricing', total: { __typename?: 'RatePricingTotal', salesPrice: number, paymentPrice: number, taxAndServicePrice: number, stayPrice: number, propertyPrice?: { __typename?: 'PropertyPrice', total: { __typename?: 'FeePrice', currency: string, value: number }, resortPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined, mandatoryPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined, mandatoryTaxPrice?: { __typename?: 'FeePrice', currency: string, value: number } | undefined } | undefined }, occupancyPricing: Array<{ __typename?: 'PricingInformation', occupancy: string, salesPrice: number, paymentPrice: number, nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> };

export type RoomPriceDetailTableForTravelPricingFragment = { __typename?: 'TravelPricing', total: { __typename?: 'TravelPricingTotal', salesPrice: number, paymentPrice: number, taxAndServicePrice: number, stayPrice: number, refundPrice: number, finalPaymentPrice: number }, occupancyPricing: Array<{ __typename?: 'TravelPricingInformation', occupancy: string, salesPrice: number, paymentPrice: number, refundPrice: number, finalPaymentPrice: number, nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> };

export type ChallengeToRegisterCreditCardMutationVariables = Exact<{
  input: ChallengeToRegisterCreditCardInput;
}>;


export type ChallengeToRegisterCreditCardMutation = { __typename?: 'Mutation', challengeToRegisterCreditCard: { __typename: 'ChallengeToRegisterCreditCardResponseError', errorCode: ChallengeToRegisterCreditCardErrorCode } | { __typename: 'ChallengeToRegisterCreditCardResponseRequiresAction', redirectUrl: string } | { __typename: 'ChallengeToRegisterCreditCardResponseSuccess', card: { __typename?: 'StripeCreditCard', id: string } } };

export type ConfirmChallengeToRegisterCreditCardMutationVariables = Exact<{
  input: ConfirmChallengeToRegisterCreditCardInput;
}>;


export type ConfirmChallengeToRegisterCreditCardMutation = { __typename?: 'Mutation', confirmChallengeToRegisterCreditCard: { __typename?: 'ConfirmChallengeToRegisterCreditCardResponse', success: boolean, errorCode?: ChallengeToRegisterCreditCardErrorCode | undefined } };

export type CreditCardForSelectFragment = { __typename?: 'StripeCreditCard', id: string, brand: StripeCreditCardBrand, last4: string, nickname: string };

export type CreditCardsForSelectPaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditCardsForSelectPaymentMethodQuery = { __typename?: 'Query', creditCards: Array<{ __typename?: 'StripeCreditCard', id: string, brand: StripeCreditCardBrand, last4: string, nickname: string }> };

export type TravelDetailsForCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type TravelDetailsForCsvQuery = { __typename?: 'Query', travelDetails: Array<{ __typename?: 'TravelInDetail', id: string, travelNumber: string, email: string, phone: string, paymentType: PaymentType, startDate: string, endDate: string, createdAt: string, employee?: { __typename?: 'Employee', id: string, name: string } | undefined, expediaHotelRooms: Array<{ __typename?: 'ExpediaHotelRoom', id: string, hotelName: string, city?: string | undefined, isPackageRate: boolean, familyName: string, givenName: string, roomName: string, roomNumber: number, bedType: string, status: ExpediaHotelRoomStatus, refundPrice: number }>, pricing: { __typename?: 'TravelPricing', total: { __typename?: 'TravelPricingTotal', salesPrice: number, paymentPrice: number, taxAndServicePrice: number, stayPrice: number, refundPrice: number, finalPaymentPrice: number }, occupancyPricing: Array<{ __typename?: 'TravelPricingInformation', occupancy: string, salesPrice: number, paymentPrice: number, refundPrice: number, finalPaymentPrice: number, nightsPrice: Array<{ __typename?: 'NightPrice', stayPrice: number, taxAndServicePrice: number }> }> }, itinerary?: { __typename?: 'Itinerary', id: string, rooms: Array<{ __typename?: 'RoomItinerary', id: string, rate: { __typename?: 'RateItinerary', id: string, cancelPenalties: Array<{ __typename: 'AmountCancelPenalty', amount: string, start: string, end: string, currency: string } | { __typename: 'NightCancelPenalty', nights: string, start: string, end: string, currency: string } | { __typename: 'PercentCancelPenalty', percent: string, start: string, end: string, currency: string }> } }> } | undefined }> };

export type MyselfQueryVariables = Exact<{ [key: string]: never; }>;


export type MyselfQuery = { __typename?: 'Query', myself?: { __typename?: 'Myself', id: string, employee?: { __typename?: 'Employee', id: string, name: string, role: EmployeeRole, email: string, agencyBranch: { __typename?: 'AgencyBranchInDetail', id: string, companyId: string, status: AgencyBranchStatus, isInvoicePaymentEnabled: boolean } } | undefined, latestAgencyRegistration?: { __typename?: 'AgencyRegistration', id: string, status: AgencyRegistrationStatus, type: AgencyRegistrationType } | undefined } | undefined };

export type IncrementalSearchPropertyContentQueryVariables = Exact<{
  input: IncrementalSearchPropertyContentInput;
}>;


export type IncrementalSearchPropertyContentQuery = { __typename?: 'Query', incrementalSearchPropertyContent: { __typename?: 'IncrementalSearchResponse', data: Array<{ __typename?: 'IncrementalSearchResponseData', id: string, name: string, location?: string | undefined, type: IncrementalSearchResponseDataType, coordinates: { __typename?: 'Coordinates', latitude: number, longitude: number } }> } };

export type IncrementalSearchRegionQueryVariables = Exact<{
  input: IncrementalSearchRegionInput;
}>;


export type IncrementalSearchRegionQuery = { __typename?: 'Query', incrementalSearchRegion: { __typename?: 'IncrementalSearchResponse', data: Array<{ __typename?: 'IncrementalSearchResponseData', id: string, name: string, location?: string | undefined, type: IncrementalSearchResponseDataType, coordinates: { __typename?: 'Coordinates', latitude: number, longitude: number } }> } };

export const CancelPenaltiesFragmentDoc = gql`
    fragment CancelPenalties on CancelPenalty {
  __typename
  start
  end
  currency
  ... on AmountCancelPenalty {
    amount
  }
  ... on NightCancelPenalty {
    nights
  }
  ... on PercentCancelPenalty {
    percent
  }
}
    `;
export const SearchExpediaHotelRoomWithRateFragmentDoc = gql`
    fragment SearchExpediaHotelRoomWithRate on RoomWithRate {
  id
  name
  descriptions {
    overview
  }
  images {
    url
  }
  bedGroups {
    description
  }
  amenities {
    id
    name
  }
  roomAmenities {
    freeWiFi
  }
  rates {
    id
    status
    availableRooms
    refundable
    isPackageRate
    amenities {
      id
      name
    }
    mappedRateAmenities {
      freeWiFi
      jaMealLabels
    }
    cancelPenalties {
      ...CancelPenalties
    }
    bedGroups {
      id
      description
      configuration {
        quantity
        size
        type
      }
    }
    promotions {
      deal {
        description
      }
      valueAdds {
        id
        description
        category
        offerType
      }
    }
    pricing {
      averagePerOneRoomNight {
        salesPrice
        paymentPrice
      }
      total {
        stayPrice
        taxAndServicePrice
        salesPrice
        paymentPrice
      }
      occupancyPricing {
        nightsPrice {
          stayPrice
          taxAndServicePrice
        }
      }
    }
  }
}
    ${CancelPenaltiesFragmentDoc}`;
export const ClippedHotelRateItemFragmentDoc = gql`
    fragment ClippedHotelRateItem on ClippedHotelRate {
  id
  epsPropertyId
  epsRoomId
  epsRateId
  isPackageRate
  propertyContent {
    id
    name
    ratings {
      property {
        type
        rating
      }
    }
  }
  room(input: $input) {
    ...SearchExpediaHotelRoomWithRate
  }
}
    ${SearchExpediaHotelRoomWithRateFragmentDoc}`;
export const HotelDetailInfectionPreventionFragmentDoc = gql`
    fragment hotelDetailInfectionPrevention on InfectionPrevention {
  hasReinforcedCleaning
  existHandSanitizer
  nonFaceToFaceCheckin
  hasCompliedGuidelines
  disinfectionAndCleaningDescriptions
  infectionPreventionSuppliesDescriptions
  infectionControlConsiderationDescriptions
  theOthersDescriptions
}
    `;
export const HotelDetailAddressFragmentDoc = gql`
    fragment HotelDetailAddress on Address {
  stateProvinceName
  city
  line1
  line2
}
    `;
export const HotelDetailFacilityAmenityFragmentDoc = gql`
    fragment hotelDetailFacilityAmenity on PropertyContentAmenities {
  allTimeReception
  freeWiFi
  sauna
  fitness
  pool
  laundry
  restaurants
  meetingRoom
  multiLanguage
  parking
  spa
}
    `;
export const HotelDetailImageFragmentDoc = gql`
    fragment HotelDetailImage on Image {
  url
  category
  caption
}
    `;
export const HotelDetailGuestReviewFragmentDoc = gql`
    fragment hotelDetailGuestReview on PropertyGuestReview {
  source
  rating
  reviewerName
  submittedDate
  title
  body
}
    `;
export const HotelDetailGuestRatingFragmentDoc = gql`
    fragment hotelDetailGuestRating on Guest {
  overall
  count
  cleanliness
  service
  comfort
  condition
  neighborhood
  amenities
}
    `;
export const HotelOverviewCardFragmentDoc = gql`
    fragment HotelOverviewCard on PropertyContentInDetail {
  id
  name
  ratings {
    property {
      rating
      type
    }
    guest {
      overall
      count
    }
  }
  images {
    url
  }
}
    `;
export const HotelImportantNotesFragmentDoc = gql`
    fragment HotelImportantNotes on ImportantNotes {
  checkin {
    beginTime
    endTime
    minAge
    twentyFourHour
    checkoutTime
  }
  checkinSpecialInstructions
  mandatoryFee
  optionalFee
  instructions
  knowBeforeYouGo
}
    `;
export const RoomPriceDetailTableForRatePricingFragmentDoc = gql`
    fragment RoomPriceDetailTableForRatePricing on RatePricing {
  total {
    salesPrice
    paymentPrice
    taxAndServicePrice
    stayPrice
    propertyPrice {
      total {
        currency
        value
      }
      resortPrice {
        currency
        value
      }
      mandatoryPrice {
        currency
        value
      }
      mandatoryTaxPrice {
        currency
        value
      }
    }
  }
  occupancyPricing {
    occupancy
    salesPrice
    paymentPrice
    nightsPrice {
      stayPrice
      taxAndServicePrice
    }
  }
}
    `;
export const PrepareToBookHotelSuccessFragmentDoc = gql`
    fragment PrepareToBookHotelSuccess on PrepareToBookHotelSuccessResponse {
  priceCheckId
  mustUseInvoicePayment
  propertyContent {
    ...HotelOverviewCard
    language
    attributes {
      general {
        canUseUnicodeInSpecialRequest
      }
    }
    importantNotes {
      ...HotelImportantNotes
    }
    rooms {
      id
      roomAmenities {
        smoking
      }
    }
  }
  enPropertyContent {
    id
    language
    name
  }
  room {
    id
    roomName
  }
  usingRate {
    id
    status
    availableRooms
    refundable
    isPackageRate
    amenities {
      id
      name
    }
    mappedRateAmenities {
      jaMealLabels
    }
    cancelPenalties {
      ...CancelPenalties
    }
    bedGroups {
      id
      description
    }
    pricing {
      ...RoomPriceDetailTableForRatePricing
    }
  }
}
    ${HotelOverviewCardFragmentDoc}
${HotelImportantNotesFragmentDoc}
${CancelPenaltiesFragmentDoc}
${RoomPriceDetailTableForRatePricingFragmentDoc}`;
export const SearchPropertyContentItemFragmentDoc = gql`
    fragment SearchPropertyContentItem on PropertyContentInSearch {
  id
  name
  nameEn
  address {
    stateProvinceName
    city
    line1
    line2
  }
  images {
    url
  }
  location {
    coordinates {
      latitude
      longitude
    }
  }
  ratings {
    property {
      type
      rating
    }
    guest {
      overall
      count
    }
  }
  descriptions {
    headline
  }
  cheapestPrice(input: $cheapestPriceInput) {
    salesPrice
    paymentPrice
  }
}
    `;
export const SearchPropertyContentSpotFragmentDoc = gql`
    fragment SearchPropertyContentSpot on IncrementalSearchResponseData {
  id
  name
  type
  coordinates {
    latitude
    longitude
  }
}
    `;
export const EditableBranchInfoFragmentDoc = gql`
    fragment EditableBranchInfo on AgencyBranchInDetail {
  id
  name
  websiteUrl
  state
  cityAndLine
  phone
  emergencyPhone
  fax
  agency {
    name
    nameEnglish
    license
    licenseNumber
  }
}
    `;
export const CreditCardInTableFragmentDoc = gql`
    fragment CreditCardInTable on StripeCreditCard {
  id
  nickname
  brand
  last4
  expYear
  expMonth
}
    `;
export const EmployeeInTableFragmentDoc = gql`
    fragment EmployeeInTable on Employee {
  id
  name
  email
  role
  status
  createdAt
}
    `;
export const CreditCardForSelectFragmentDoc = gql`
    fragment CreditCardForSelect on StripeCreditCard {
  id
  brand
  last4
  nickname
}
    `;
export const PrepareToChangeTravelDateSuccessFragmentDoc = gql`
    fragment PrepareToChangeTravelDateSuccess on PrepareToChangeTravelDateSuccessResponse {
  priceCheckId
  priceDifference {
    paymentPriceAfter
    paymentPriceBefore
    cancelPenaltyPrice
    totalDifferencePrice
  }
  rate {
    id
    refundable
    cancelPenalties {
      ...CancelPenalties
    }
  }
  creditCards {
    ...CreditCardForSelect
  }
  mustUseInvoicePayment
}
    ${CancelPenaltiesFragmentDoc}
${CreditCardForSelectFragmentDoc}`;
export const ChangeRoomDetailsSuccessFragmentDoc = gql`
    fragment ChangeRoomDetailsSuccess on ChangeRoomDetailsSuccessResponse {
  travel {
    id
    status
    expediaHotelRooms {
      id
      familyName
      givenName
      specialRequest
    }
    itinerary {
      id
      rooms {
        id
        status
        familyName
        givenName
        specialRequest
      }
    }
  }
}
    `;
export const ItineraryHotelAddressFragmentDoc = gql`
    fragment ItineraryHotelAddress on Address {
  postalCode
  stateProvinceName
  city
  line1
  line2
}
    `;
export const TravelUpdateTimelineAgencyTravelMemoFragmentDoc = gql`
    fragment TravelUpdateTimelineAgencyTravelMemo on AgencyTravelMemo {
  id
  text
  createdAt
  employee {
    id
    name
  }
}
    `;
export const TravelUpdateTimelineTravelHistoryFragmentDoc = gql`
    fragment TravelUpdateTimelineTravelHistory on TravelHistory {
  id
  historyType
  data {
    ... on TravelHistoryDataTravelBooked {
      dataType
      previousTravelId
    }
    ... on TravelHistoryDataRoomCanceled {
      expediaHotelRoomId
      roomItineraryId
      by
      employeeId
      dataType
    }
    ... on TravelHistoryDataTravelCanceled {
      by
      employeeId
      dataType
    }
    ... on TravelHistoryDataHotelOrRoomCreated {
      dataType
    }
    ... on TravelHistoryDataRoomRefunded {
      dataType
      expediaHotelRoomId
      roomItineraryId
      refundPrice
    }
    ... on TravelHistoryDataDateChanged {
      dataType
      nextTravelId
    }
  }
  createdAt
}
    `;
export const TravelUpdateTimelineFragmentDoc = gql`
    fragment TravelUpdateTimeline on TravelInDetail {
  updateTimeline {
    ... on AgencyTravelMemo {
      ...TravelUpdateTimelineAgencyTravelMemo
    }
    ... on TravelHistory {
      ...TravelUpdateTimelineTravelHistory
    }
  }
}
    ${TravelUpdateTimelineAgencyTravelMemoFragmentDoc}
${TravelUpdateTimelineTravelHistoryFragmentDoc}`;
export const VoucherHotelAddressFragmentDoc = gql`
    fragment VoucherHotelAddress on Address {
  postalCode
  stateProvinceName
  city
  line1
  line2
}
    `;
export const NewsListItemFragmentDoc = gql`
    fragment NewsListItem on News {
  id
  releaseDate
  title
  category
}
    `;
export const RoomPriceDetailTableForTravelPricingFragmentDoc = gql`
    fragment RoomPriceDetailTableForTravelPricing on TravelPricing {
  total {
    salesPrice
    paymentPrice
    taxAndServicePrice
    stayPrice
    refundPrice
    finalPaymentPrice
  }
  occupancyPricing {
    occupancy
    salesPrice
    paymentPrice
    nightsPrice {
      stayPrice
      taxAndServicePrice
    }
    refundPrice
    finalPaymentPrice
  }
}
    `;
export const CreateAgencyRegistrationDocument = gql`
    mutation createAgencyRegistration($input: CreateAgencyRegistrationInput!) {
  createAgencyRegistration(input: $input) {
    agencyRegistration {
      id
      uid
      status
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateAgencyRegistrationMutationFn = Apollo.MutationFunction<CreateAgencyRegistrationMutation, CreateAgencyRegistrationMutationVariables>;

/**
 * __useCreateAgencyRegistrationMutation__
 *
 * To run a mutation, you first call `useCreateAgencyRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyRegistrationMutation, { data, loading, error }] = useCreateAgencyRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgencyRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyRegistrationMutation, CreateAgencyRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyRegistrationMutation, CreateAgencyRegistrationMutationVariables>(CreateAgencyRegistrationDocument, options);
      }
export type CreateAgencyRegistrationMutationHookResult = ReturnType<typeof useCreateAgencyRegistrationMutation>;
export type CreateAgencyRegistrationMutationResult = Apollo.MutationResult<CreateAgencyRegistrationMutation>;
export type CreateAgencyRegistrationMutationOptions = Apollo.BaseMutationOptions<CreateAgencyRegistrationMutation, CreateAgencyRegistrationMutationVariables>;
export const ClippedHotelRatesDocument = gql`
    query clippedHotelRates($input: RoomsWithRateInput!) {
  clippedHotelRates {
    ...ClippedHotelRateItem
  }
}
    ${ClippedHotelRateItemFragmentDoc}`;

/**
 * __useClippedHotelRatesQuery__
 *
 * To run a query within a React component, call `useClippedHotelRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClippedHotelRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClippedHotelRatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClippedHotelRatesQuery(baseOptions: Apollo.QueryHookOptions<ClippedHotelRatesQuery, ClippedHotelRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClippedHotelRatesQuery, ClippedHotelRatesQueryVariables>(ClippedHotelRatesDocument, options);
      }
export function useClippedHotelRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClippedHotelRatesQuery, ClippedHotelRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClippedHotelRatesQuery, ClippedHotelRatesQueryVariables>(ClippedHotelRatesDocument, options);
        }
export type ClippedHotelRatesQueryHookResult = ReturnType<typeof useClippedHotelRatesQuery>;
export type ClippedHotelRatesLazyQueryHookResult = ReturnType<typeof useClippedHotelRatesLazyQuery>;
export type ClippedHotelRatesQueryResult = Apollo.QueryResult<ClippedHotelRatesQuery, ClippedHotelRatesQueryVariables>;
export const DeleteClippedHotelRatesDocument = gql`
    mutation deleteClippedHotelRates($ids: [ID!]!) {
  deleteClippedHotelRates(ids: $ids) {
    id
  }
}
    `;
export type DeleteClippedHotelRatesMutationFn = Apollo.MutationFunction<DeleteClippedHotelRatesMutation, DeleteClippedHotelRatesMutationVariables>;

/**
 * __useDeleteClippedHotelRatesMutation__
 *
 * To run a mutation, you first call `useDeleteClippedHotelRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClippedHotelRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClippedHotelRatesMutation, { data, loading, error }] = useDeleteClippedHotelRatesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteClippedHotelRatesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClippedHotelRatesMutation, DeleteClippedHotelRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClippedHotelRatesMutation, DeleteClippedHotelRatesMutationVariables>(DeleteClippedHotelRatesDocument, options);
      }
export type DeleteClippedHotelRatesMutationHookResult = ReturnType<typeof useDeleteClippedHotelRatesMutation>;
export type DeleteClippedHotelRatesMutationResult = Apollo.MutationResult<DeleteClippedHotelRatesMutation>;
export type DeleteClippedHotelRatesMutationOptions = Apollo.BaseMutationOptions<DeleteClippedHotelRatesMutation, DeleteClippedHotelRatesMutationVariables>;
export const CreatePasswordResetCodeDocument = gql`
    mutation createPasswordResetCode($input: CreatePasswordResetCodeInput!) {
  createPasswordResetCode(input: $input) {
    code
  }
}
    `;
export type CreatePasswordResetCodeMutationFn = Apollo.MutationFunction<CreatePasswordResetCodeMutation, CreatePasswordResetCodeMutationVariables>;

/**
 * __useCreatePasswordResetCodeMutation__
 *
 * To run a mutation, you first call `useCreatePasswordResetCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePasswordResetCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPasswordResetCodeMutation, { data, loading, error }] = useCreatePasswordResetCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePasswordResetCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePasswordResetCodeMutation, CreatePasswordResetCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePasswordResetCodeMutation, CreatePasswordResetCodeMutationVariables>(CreatePasswordResetCodeDocument, options);
      }
export type CreatePasswordResetCodeMutationHookResult = ReturnType<typeof useCreatePasswordResetCodeMutation>;
export type CreatePasswordResetCodeMutationResult = Apollo.MutationResult<CreatePasswordResetCodeMutation>;
export type CreatePasswordResetCodeMutationOptions = Apollo.BaseMutationOptions<CreatePasswordResetCodeMutation, CreatePasswordResetCodeMutationVariables>;
export const ClipHotelRateDocument = gql`
    mutation clipHotelRate($input: ClipHotelRateInput!) {
  clipHotelRate(input: $input) {
    __typename
    ... on ClipHotelRateErrorResponse {
      errorCode
    }
    ... on ClipHotelRateSuccessResponse {
      newClippedHotelRate {
        id
      }
    }
  }
}
    `;
export type ClipHotelRateMutationFn = Apollo.MutationFunction<ClipHotelRateMutation, ClipHotelRateMutationVariables>;

/**
 * __useClipHotelRateMutation__
 *
 * To run a mutation, you first call `useClipHotelRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClipHotelRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clipHotelRateMutation, { data, loading, error }] = useClipHotelRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClipHotelRateMutation(baseOptions?: Apollo.MutationHookOptions<ClipHotelRateMutation, ClipHotelRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClipHotelRateMutation, ClipHotelRateMutationVariables>(ClipHotelRateDocument, options);
      }
export type ClipHotelRateMutationHookResult = ReturnType<typeof useClipHotelRateMutation>;
export type ClipHotelRateMutationResult = Apollo.MutationResult<ClipHotelRateMutation>;
export type ClipHotelRateMutationOptions = Apollo.BaseMutationOptions<ClipHotelRateMutation, ClipHotelRateMutationVariables>;
export const ExpediaHotelDetailDocument = gql`
    query expediaHotelDetail($id: ID!, $roomsWithRateInput: RoomsWithRateInput!) {
  enPropertyContent: propertyContent(id: $id, input: {language: en}) {
    id
    language
    name
  }
  jaPropertyContent: propertyContent(id: $id) {
    id
    language
    name
    category {
      name
    }
    spokenLanguages {
      id
    }
    themes {
      id
      name
    }
    withPet
    address {
      ...HotelDetailAddress
    }
    location {
      coordinates {
        latitude
        longitude
      }
    }
    ratings {
      guest {
        overall
        cleanliness
        count
      }
      property {
        rating
        type
      }
    }
    images {
      ...HotelDetailImage
    }
    importantNotes {
      ...HotelImportantNotes
    }
    descriptions {
      amenities
      surroundingSpots {
        name
        distance
      }
      surroundingAirports
      businessAmenities
      dining
      headline
      location
      nationalRatings
      renovations
      rooms
    }
    facility: amenity {
      ...hotelDetailFacilityAmenity
    }
    reviewRating: ratings {
      guest {
        ...hotelDetailGuestRating
      }
    }
    infectionPrevention {
      ...hotelDetailInfectionPrevention
    }
    roomsWithRate(input: $roomsWithRateInput) {
      ...SearchExpediaHotelRoomWithRate
    }
  }
  propertyGuestReviews(propertyId: $id) {
    ...hotelDetailGuestReview
  }
}
    ${HotelDetailAddressFragmentDoc}
${HotelDetailImageFragmentDoc}
${HotelImportantNotesFragmentDoc}
${HotelDetailFacilityAmenityFragmentDoc}
${HotelDetailGuestRatingFragmentDoc}
${HotelDetailInfectionPreventionFragmentDoc}
${SearchExpediaHotelRoomWithRateFragmentDoc}
${HotelDetailGuestReviewFragmentDoc}`;

/**
 * __useExpediaHotelDetailQuery__
 *
 * To run a query within a React component, call `useExpediaHotelDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpediaHotelDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpediaHotelDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      roomsWithRateInput: // value for 'roomsWithRateInput'
 *   },
 * });
 */
export function useExpediaHotelDetailQuery(baseOptions: Apollo.QueryHookOptions<ExpediaHotelDetailQuery, ExpediaHotelDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpediaHotelDetailQuery, ExpediaHotelDetailQueryVariables>(ExpediaHotelDetailDocument, options);
      }
export function useExpediaHotelDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpediaHotelDetailQuery, ExpediaHotelDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpediaHotelDetailQuery, ExpediaHotelDetailQueryVariables>(ExpediaHotelDetailDocument, options);
        }
export type ExpediaHotelDetailQueryHookResult = ReturnType<typeof useExpediaHotelDetailQuery>;
export type ExpediaHotelDetailLazyQueryHookResult = ReturnType<typeof useExpediaHotelDetailLazyQuery>;
export type ExpediaHotelDetailQueryResult = Apollo.QueryResult<ExpediaHotelDetailQuery, ExpediaHotelDetailQueryVariables>;
export const ExpediaHotelRoomsDocument = gql`
    query expediaHotelRooms($id: ID!, $roomsWithRateInput: RoomsWithRateInput!) {
  propertyContent(id: $id) {
    id
    roomsWithRate(input: $roomsWithRateInput) {
      ...SearchExpediaHotelRoomWithRate
    }
  }
}
    ${SearchExpediaHotelRoomWithRateFragmentDoc}`;

/**
 * __useExpediaHotelRoomsQuery__
 *
 * To run a query within a React component, call `useExpediaHotelRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpediaHotelRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpediaHotelRoomsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      roomsWithRateInput: // value for 'roomsWithRateInput'
 *   },
 * });
 */
export function useExpediaHotelRoomsQuery(baseOptions: Apollo.QueryHookOptions<ExpediaHotelRoomsQuery, ExpediaHotelRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpediaHotelRoomsQuery, ExpediaHotelRoomsQueryVariables>(ExpediaHotelRoomsDocument, options);
      }
export function useExpediaHotelRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpediaHotelRoomsQuery, ExpediaHotelRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpediaHotelRoomsQuery, ExpediaHotelRoomsQueryVariables>(ExpediaHotelRoomsDocument, options);
        }
export type ExpediaHotelRoomsQueryHookResult = ReturnType<typeof useExpediaHotelRoomsQuery>;
export type ExpediaHotelRoomsLazyQueryHookResult = ReturnType<typeof useExpediaHotelRoomsLazyQuery>;
export type ExpediaHotelRoomsQueryResult = Apollo.QueryResult<ExpediaHotelRoomsQuery, ExpediaHotelRoomsQueryVariables>;
export const BookExpediaHotelDocument = gql`
    mutation bookExpediaHotel($input: BookExpediaHotelInput!) {
  bookExpediaHotel(input: $input) {
    __typename
    ... on BookExpediaHotelSuccessResponse {
      travel {
        id
        expediaHotelRooms {
          id
          familyName
          givenName
        }
      }
    }
    ... on BookExpediaHotelErrorResponse {
      errorCode
      rePrepareRequired
      shouldAskToCardIssuer
    }
  }
}
    `;
export type BookExpediaHotelMutationFn = Apollo.MutationFunction<BookExpediaHotelMutation, BookExpediaHotelMutationVariables>;

/**
 * __useBookExpediaHotelMutation__
 *
 * To run a mutation, you first call `useBookExpediaHotelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookExpediaHotelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookExpediaHotelMutation, { data, loading, error }] = useBookExpediaHotelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookExpediaHotelMutation(baseOptions?: Apollo.MutationHookOptions<BookExpediaHotelMutation, BookExpediaHotelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookExpediaHotelMutation, BookExpediaHotelMutationVariables>(BookExpediaHotelDocument, options);
      }
export type BookExpediaHotelMutationHookResult = ReturnType<typeof useBookExpediaHotelMutation>;
export type BookExpediaHotelMutationResult = Apollo.MutationResult<BookExpediaHotelMutation>;
export type BookExpediaHotelMutationOptions = Apollo.BaseMutationOptions<BookExpediaHotelMutation, BookExpediaHotelMutationVariables>;
export const PrepareToBookHotelDocument = gql`
    mutation prepareToBookHotel($input: PrepareToBookHotelInput!) {
  prepareToBookHotel(input: $input) {
    __typename
    ... on PrepareToBookHotelSuccessResponse {
      ...PrepareToBookHotelSuccess
    }
    ... on PrepareToBookHotelErrorResponse {
      errorCode
    }
  }
}
    ${PrepareToBookHotelSuccessFragmentDoc}`;
export type PrepareToBookHotelMutationFn = Apollo.MutationFunction<PrepareToBookHotelMutation, PrepareToBookHotelMutationVariables>;

/**
 * __usePrepareToBookHotelMutation__
 *
 * To run a mutation, you first call `usePrepareToBookHotelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareToBookHotelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareToBookHotelMutation, { data, loading, error }] = usePrepareToBookHotelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepareToBookHotelMutation(baseOptions?: Apollo.MutationHookOptions<PrepareToBookHotelMutation, PrepareToBookHotelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepareToBookHotelMutation, PrepareToBookHotelMutationVariables>(PrepareToBookHotelDocument, options);
      }
export type PrepareToBookHotelMutationHookResult = ReturnType<typeof usePrepareToBookHotelMutation>;
export type PrepareToBookHotelMutationResult = Apollo.MutationResult<PrepareToBookHotelMutation>;
export type PrepareToBookHotelMutationOptions = Apollo.BaseMutationOptions<PrepareToBookHotelMutation, PrepareToBookHotelMutationVariables>;
export const SearchPropertyContentDocument = gql`
    query searchPropertyContent($input: SearchPropertyContentInput!, $regionInput: IncrementalSearchRegionInput!, $cheapestPriceInput: SearchPropertyContentPriceInput!, $pagination: SearchPropertyContentPaginationInput) {
  searchPropertyContent(input: $input, pagination: $pagination) {
    pageInfo {
      hasNextPage
      endCursor
      totalCount
    }
    nodes {
      ...SearchPropertyContentItem
    }
    specifiedPropertyContent {
      ...SearchPropertyContentItem
    }
  }
  incrementalSearchRegion(input: $regionInput) {
    data {
      ...SearchPropertyContentSpot
    }
  }
}
    ${SearchPropertyContentItemFragmentDoc}
${SearchPropertyContentSpotFragmentDoc}`;

/**
 * __useSearchPropertyContentQuery__
 *
 * To run a query within a React component, call `useSearchPropertyContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPropertyContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPropertyContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *      regionInput: // value for 'regionInput'
 *      cheapestPriceInput: // value for 'cheapestPriceInput'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchPropertyContentQuery(baseOptions: Apollo.QueryHookOptions<SearchPropertyContentQuery, SearchPropertyContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPropertyContentQuery, SearchPropertyContentQueryVariables>(SearchPropertyContentDocument, options);
      }
export function useSearchPropertyContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPropertyContentQuery, SearchPropertyContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPropertyContentQuery, SearchPropertyContentQueryVariables>(SearchPropertyContentDocument, options);
        }
export type SearchPropertyContentQueryHookResult = ReturnType<typeof useSearchPropertyContentQuery>;
export type SearchPropertyContentLazyQueryHookResult = ReturnType<typeof useSearchPropertyContentLazyQuery>;
export type SearchPropertyContentQueryResult = Apollo.QueryResult<SearchPropertyContentQuery, SearchPropertyContentQueryVariables>;
export const InvoiceDownloadLinkDocument = gql`
    query invoiceDownloadLink($input: InvoiceDownloadLinkInput!) {
  invoiceDownloadLink(input: $input)
}
    `;

/**
 * __useInvoiceDownloadLinkQuery__
 *
 * To run a query within a React component, call `useInvoiceDownloadLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceDownloadLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceDownloadLinkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceDownloadLinkQuery(baseOptions: Apollo.QueryHookOptions<InvoiceDownloadLinkQuery, InvoiceDownloadLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceDownloadLinkQuery, InvoiceDownloadLinkQueryVariables>(InvoiceDownloadLinkDocument, options);
      }
export function useInvoiceDownloadLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceDownloadLinkQuery, InvoiceDownloadLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceDownloadLinkQuery, InvoiceDownloadLinkQueryVariables>(InvoiceDownloadLinkDocument, options);
        }
export type InvoiceDownloadLinkQueryHookResult = ReturnType<typeof useInvoiceDownloadLinkQuery>;
export type InvoiceDownloadLinkLazyQueryHookResult = ReturnType<typeof useInvoiceDownloadLinkLazyQuery>;
export type InvoiceDownloadLinkQueryResult = Apollo.QueryResult<InvoiceDownloadLinkQuery, InvoiceDownloadLinkQueryVariables>;
export const InvoicesDocument = gql`
    query invoices($pagination: PaginationInput) {
  myself {
    employee {
      id
      agencyBranch {
        id
        cashBalance
      }
    }
  }
  invoices(pagination: $pagination) {
    nodes {
      id
      invoiceNumber
      status
      startDate
      endDate
      dueDate
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const NewsDocument = gql`
    query news($id: ID!) {
  news(id: $id) {
    id
    title
    body
    category
    releaseDate
    topImage {
      url
      width
      height
    }
  }
}
    `;

/**
 * __useNewsQuery__
 *
 * To run a query within a React component, call `useNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewsQuery(baseOptions: Apollo.QueryHookOptions<NewsQuery, NewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsQuery, NewsQueryVariables>(NewsDocument, options);
      }
export function useNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsQuery, NewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsQuery, NewsQueryVariables>(NewsDocument, options);
        }
export type NewsQueryHookResult = ReturnType<typeof useNewsQuery>;
export type NewsLazyQueryHookResult = ReturnType<typeof useNewsLazyQuery>;
export type NewsQueryResult = Apollo.QueryResult<NewsQuery, NewsQueryVariables>;
export const NewsListDocument = gql`
    query newsList($pagination: PaginationInput!) {
  newsList(pagination: $pagination) {
    nodes {
      ...NewsListItem
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${NewsListItemFragmentDoc}`;

/**
 * __useNewsListQuery__
 *
 * To run a query within a React component, call `useNewsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsListQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useNewsListQuery(baseOptions: Apollo.QueryHookOptions<NewsListQuery, NewsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsListQuery, NewsListQueryVariables>(NewsListDocument, options);
      }
export function useNewsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsListQuery, NewsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsListQuery, NewsListQueryVariables>(NewsListDocument, options);
        }
export type NewsListQueryHookResult = ReturnType<typeof useNewsListQuery>;
export type NewsListLazyQueryHookResult = ReturnType<typeof useNewsListLazyQuery>;
export type NewsListQueryResult = Apollo.QueryResult<NewsListQuery, NewsListQueryVariables>;
export const PdfPrintGuideDocument = gql`
    query pdfPrintGuide {
  pdfHelp {
    title
    body
  }
}
    `;

/**
 * __usePdfPrintGuideQuery__
 *
 * To run a query within a React component, call `usePdfPrintGuideQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfPrintGuideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfPrintGuideQuery({
 *   variables: {
 *   },
 * });
 */
export function usePdfPrintGuideQuery(baseOptions?: Apollo.QueryHookOptions<PdfPrintGuideQuery, PdfPrintGuideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfPrintGuideQuery, PdfPrintGuideQueryVariables>(PdfPrintGuideDocument, options);
      }
export function usePdfPrintGuideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfPrintGuideQuery, PdfPrintGuideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfPrintGuideQuery, PdfPrintGuideQueryVariables>(PdfPrintGuideDocument, options);
        }
export type PdfPrintGuideQueryHookResult = ReturnType<typeof usePdfPrintGuideQuery>;
export type PdfPrintGuideLazyQueryHookResult = ReturnType<typeof usePdfPrintGuideLazyQuery>;
export type PdfPrintGuideQueryResult = Apollo.QueryResult<PdfPrintGuideQuery, PdfPrintGuideQueryVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($email: String!) {
  resetPassword(email: $email)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation updateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    id
    employee {
      id
      name
      updatedAt
    }
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const SettingsBranchesDocument = gql`
    query settingsBranches {
  myself {
    employee {
      id
      role
      agencyBranch {
        ...EditableBranchInfo
      }
    }
    latestAgencyRegistration {
      id
      status
      type
    }
  }
}
    ${EditableBranchInfoFragmentDoc}`;

/**
 * __useSettingsBranchesQuery__
 *
 * To run a query within a React component, call `useSettingsBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsBranchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsBranchesQuery(baseOptions?: Apollo.QueryHookOptions<SettingsBranchesQuery, SettingsBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsBranchesQuery, SettingsBranchesQueryVariables>(SettingsBranchesDocument, options);
      }
export function useSettingsBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsBranchesQuery, SettingsBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsBranchesQuery, SettingsBranchesQueryVariables>(SettingsBranchesDocument, options);
        }
export type SettingsBranchesQueryHookResult = ReturnType<typeof useSettingsBranchesQuery>;
export type SettingsBranchesLazyQueryHookResult = ReturnType<typeof useSettingsBranchesLazyQuery>;
export type SettingsBranchesQueryResult = Apollo.QueryResult<SettingsBranchesQuery, SettingsBranchesQueryVariables>;
export const UpdateAgencyBranchDocument = gql`
    mutation updateAgencyBranch($input: CreateAgencyRegistrationInput!) {
  createAgencyRegistration(input: $input) {
    agencyRegistration {
      id
      status
      type
    }
  }
}
    `;
export type UpdateAgencyBranchMutationFn = Apollo.MutationFunction<UpdateAgencyBranchMutation, UpdateAgencyBranchMutationVariables>;

/**
 * __useUpdateAgencyBranchMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyBranchMutation, { data, loading, error }] = useUpdateAgencyBranchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgencyBranchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyBranchMutation, UpdateAgencyBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyBranchMutation, UpdateAgencyBranchMutationVariables>(UpdateAgencyBranchDocument, options);
      }
export type UpdateAgencyBranchMutationHookResult = ReturnType<typeof useUpdateAgencyBranchMutation>;
export type UpdateAgencyBranchMutationResult = Apollo.MutationResult<UpdateAgencyBranchMutation>;
export type UpdateAgencyBranchMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyBranchMutation, UpdateAgencyBranchMutationVariables>;
export const CreditCardsInTableDocument = gql`
    query creditCardsInTable {
  creditCards {
    ...CreditCardInTable
  }
}
    ${CreditCardInTableFragmentDoc}`;

/**
 * __useCreditCardsInTableQuery__
 *
 * To run a query within a React component, call `useCreditCardsInTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditCardsInTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditCardsInTableQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditCardsInTableQuery(baseOptions?: Apollo.QueryHookOptions<CreditCardsInTableQuery, CreditCardsInTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditCardsInTableQuery, CreditCardsInTableQueryVariables>(CreditCardsInTableDocument, options);
      }
export function useCreditCardsInTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditCardsInTableQuery, CreditCardsInTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditCardsInTableQuery, CreditCardsInTableQueryVariables>(CreditCardsInTableDocument, options);
        }
export type CreditCardsInTableQueryHookResult = ReturnType<typeof useCreditCardsInTableQuery>;
export type CreditCardsInTableLazyQueryHookResult = ReturnType<typeof useCreditCardsInTableLazyQuery>;
export type CreditCardsInTableQueryResult = Apollo.QueryResult<CreditCardsInTableQuery, CreditCardsInTableQueryVariables>;
export const DeleteCreditCardDocument = gql`
    mutation deleteCreditCard($id: ID!) {
  deleteCreditCard(id: $id) {
    deletedCard {
      id
    }
  }
}
    `;
export type DeleteCreditCardMutationFn = Apollo.MutationFunction<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>;

/**
 * __useDeleteCreditCardMutation__
 *
 * To run a mutation, you first call `useDeleteCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreditCardMutation, { data, loading, error }] = useDeleteCreditCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>(DeleteCreditCardDocument, options);
      }
export type DeleteCreditCardMutationHookResult = ReturnType<typeof useDeleteCreditCardMutation>;
export type DeleteCreditCardMutationResult = Apollo.MutationResult<DeleteCreditCardMutation>;
export type DeleteCreditCardMutationOptions = Apollo.BaseMutationOptions<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>;
export const RegisterCreditCardDocument = gql`
    mutation registerCreditCard($input: RegisterCreditCardInput!) {
  registerCreditCard(input: $input) {
    card {
      ...CreditCardInTable
    }
  }
}
    ${CreditCardInTableFragmentDoc}`;
export type RegisterCreditCardMutationFn = Apollo.MutationFunction<RegisterCreditCardMutation, RegisterCreditCardMutationVariables>;

/**
 * __useRegisterCreditCardMutation__
 *
 * To run a mutation, you first call `useRegisterCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCreditCardMutation, { data, loading, error }] = useRegisterCreditCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<RegisterCreditCardMutation, RegisterCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterCreditCardMutation, RegisterCreditCardMutationVariables>(RegisterCreditCardDocument, options);
      }
export type RegisterCreditCardMutationHookResult = ReturnType<typeof useRegisterCreditCardMutation>;
export type RegisterCreditCardMutationResult = Apollo.MutationResult<RegisterCreditCardMutation>;
export type RegisterCreditCardMutationOptions = Apollo.BaseMutationOptions<RegisterCreditCardMutation, RegisterCreditCardMutationVariables>;
export const DelegateAgencyAdminDocument = gql`
    mutation delegateAgencyAdmin($input: DelegateAgencyAdminInput!) {
  delegateAgencyAdmin(input: $input) {
    __typename
    ... on DelegateAgencyAdminSuccessResponse {
      oldAdminEmployee {
        ...EmployeeInTable
      }
      newAdminEmployee {
        ...EmployeeInTable
      }
    }
    ... on DelegateAgencyAdminErrorResponse {
      errorCode
    }
  }
}
    ${EmployeeInTableFragmentDoc}`;
export type DelegateAgencyAdminMutationFn = Apollo.MutationFunction<DelegateAgencyAdminMutation, DelegateAgencyAdminMutationVariables>;

/**
 * __useDelegateAgencyAdminMutation__
 *
 * To run a mutation, you first call `useDelegateAgencyAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelegateAgencyAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [delegateAgencyAdminMutation, { data, loading, error }] = useDelegateAgencyAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDelegateAgencyAdminMutation(baseOptions?: Apollo.MutationHookOptions<DelegateAgencyAdminMutation, DelegateAgencyAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DelegateAgencyAdminMutation, DelegateAgencyAdminMutationVariables>(DelegateAgencyAdminDocument, options);
      }
export type DelegateAgencyAdminMutationHookResult = ReturnType<typeof useDelegateAgencyAdminMutation>;
export type DelegateAgencyAdminMutationResult = Apollo.MutationResult<DelegateAgencyAdminMutation>;
export type DelegateAgencyAdminMutationOptions = Apollo.BaseMutationOptions<DelegateAgencyAdminMutation, DelegateAgencyAdminMutationVariables>;
export const DeleteEmployeeDocument = gql`
    mutation DeleteEmployee($id: ID!) {
  deleteEmployee(id: $id) {
    __typename
    ... on DeleteEmployeeSuccessResponse {
      deletedEmployee {
        ...EmployeeInTable
      }
    }
    ... on DeleteEmployeeErrorResponse {
      errorCode
    }
  }
}
    ${EmployeeInTableFragmentDoc}`;
export type DeleteEmployeeMutationFn = Apollo.MutationFunction<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;

/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
      }
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<DeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const EmployeesDocument = gql`
    query employees($pagination: PaginationInput!) {
  employees(pagination: $pagination) {
    nodes {
      ...EmployeeInTable
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${EmployeeInTableFragmentDoc}`;

/**
 * __useEmployeesQuery__
 *
 * To run a query within a React component, call `useEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useEmployeesQuery(baseOptions: Apollo.QueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
      }
export function useEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
        }
export type EmployeesQueryHookResult = ReturnType<typeof useEmployeesQuery>;
export type EmployeesLazyQueryHookResult = ReturnType<typeof useEmployeesLazyQuery>;
export type EmployeesQueryResult = Apollo.QueryResult<EmployeesQuery, EmployeesQueryVariables>;
export const InviteEmployeeDocument = gql`
    mutation inviteEmployee($input: InviteEmployeeInput!) {
  inviteEmployee(input: $input) {
    __typename
    ... on InviteEmployeeSuccessResponse {
      invitedEmployee {
        ...EmployeeInTable
      }
    }
    ... on InviteEmployeeErrorResponse {
      errorCode
    }
  }
}
    ${EmployeeInTableFragmentDoc}`;
export type InviteEmployeeMutationFn = Apollo.MutationFunction<InviteEmployeeMutation, InviteEmployeeMutationVariables>;

/**
 * __useInviteEmployeeMutation__
 *
 * To run a mutation, you first call `useInviteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteEmployeeMutation, { data, loading, error }] = useInviteEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<InviteEmployeeMutation, InviteEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteEmployeeMutation, InviteEmployeeMutationVariables>(InviteEmployeeDocument, options);
      }
export type InviteEmployeeMutationHookResult = ReturnType<typeof useInviteEmployeeMutation>;
export type InviteEmployeeMutationResult = Apollo.MutationResult<InviteEmployeeMutation>;
export type InviteEmployeeMutationOptions = Apollo.BaseMutationOptions<InviteEmployeeMutation, InviteEmployeeMutationVariables>;
export const TermsDocument = gql`
    query terms {
  terms {
    title
    body
  }
}
    `;

/**
 * __useTermsQuery__
 *
 * To run a query within a React component, call `useTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTermsQuery(baseOptions?: Apollo.QueryHookOptions<TermsQuery, TermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TermsQuery, TermsQueryVariables>(TermsDocument, options);
      }
export function useTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TermsQuery, TermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TermsQuery, TermsQueryVariables>(TermsDocument, options);
        }
export type TermsQueryHookResult = ReturnType<typeof useTermsQuery>;
export type TermsLazyQueryHookResult = ReturnType<typeof useTermsLazyQuery>;
export type TermsQueryResult = Apollo.QueryResult<TermsQuery, TermsQueryVariables>;
export const TopDocument = gql`
    query top($newsPagination: PaginationInput!) {
  newsList(pagination: $newsPagination) {
    nodes {
      ...NewsListItem
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${NewsListItemFragmentDoc}`;

/**
 * __useTopQuery__
 *
 * To run a query within a React component, call `useTopQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopQuery({
 *   variables: {
 *      newsPagination: // value for 'newsPagination'
 *   },
 * });
 */
export function useTopQuery(baseOptions: Apollo.QueryHookOptions<TopQuery, TopQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopQuery, TopQueryVariables>(TopDocument, options);
      }
export function useTopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopQuery, TopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopQuery, TopQueryVariables>(TopDocument, options);
        }
export type TopQueryHookResult = ReturnType<typeof useTopQuery>;
export type TopLazyQueryHookResult = ReturnType<typeof useTopLazyQuery>;
export type TopQueryResult = Apollo.QueryResult<TopQuery, TopQueryVariables>;
export const TransactionLawDocument = gql`
    query transactionLaw {
  transactionLaw {
    title
    body
  }
}
    `;

/**
 * __useTransactionLawQuery__
 *
 * To run a query within a React component, call `useTransactionLawQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionLawQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionLawQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransactionLawQuery(baseOptions?: Apollo.QueryHookOptions<TransactionLawQuery, TransactionLawQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionLawQuery, TransactionLawQueryVariables>(TransactionLawDocument, options);
      }
export function useTransactionLawLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionLawQuery, TransactionLawQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionLawQuery, TransactionLawQueryVariables>(TransactionLawDocument, options);
        }
export type TransactionLawQueryHookResult = ReturnType<typeof useTransactionLawQuery>;
export type TransactionLawLazyQueryHookResult = ReturnType<typeof useTransactionLawLazyQuery>;
export type TransactionLawQueryResult = Apollo.QueryResult<TransactionLawQuery, TransactionLawQueryVariables>;
export const CancelRoomsDocument = gql`
    mutation cancelRooms($input: CancelRoomsInput!) {
  cancelRooms(input: $input) {
    __typename
    ... on CancelRoomsSuccessResponse {
      travel {
        id
        status
        expediaHotelRooms {
          id
          status
          status
          canceledAt
        }
        itinerary {
          id
          rooms {
            id
            status
          }
        }
      }
    }
    ... on CancelRoomsErrorResponse {
      errorCode
    }
  }
}
    `;
export type CancelRoomsMutationFn = Apollo.MutationFunction<CancelRoomsMutation, CancelRoomsMutationVariables>;

/**
 * __useCancelRoomsMutation__
 *
 * To run a mutation, you first call `useCancelRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRoomsMutation, { data, loading, error }] = useCancelRoomsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelRoomsMutation(baseOptions?: Apollo.MutationHookOptions<CancelRoomsMutation, CancelRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelRoomsMutation, CancelRoomsMutationVariables>(CancelRoomsDocument, options);
      }
export type CancelRoomsMutationHookResult = ReturnType<typeof useCancelRoomsMutation>;
export type CancelRoomsMutationResult = Apollo.MutationResult<CancelRoomsMutation>;
export type CancelRoomsMutationOptions = Apollo.BaseMutationOptions<CancelRoomsMutation, CancelRoomsMutationVariables>;
export const ChangeTravelDateDocument = gql`
    mutation changeTravelDate($input: ChangeTravelDateInput!) {
  changeTravelDate(input: $input) {
    __typename
    ... on ChangeTravelDateSuccessResponse {
      oldTravel {
        id
        status
        expediaHotelRooms {
          id
          status
        }
      }
      newTravel {
        id
        travelNumber
      }
    }
    ... on ChangeTravelDateErrorResponse {
      errorCode
      rePrepareRequired
      shouldAskToCardIssuer
    }
  }
}
    `;
export type ChangeTravelDateMutationFn = Apollo.MutationFunction<ChangeTravelDateMutation, ChangeTravelDateMutationVariables>;

/**
 * __useChangeTravelDateMutation__
 *
 * To run a mutation, you first call `useChangeTravelDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTravelDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTravelDateMutation, { data, loading, error }] = useChangeTravelDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeTravelDateMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTravelDateMutation, ChangeTravelDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTravelDateMutation, ChangeTravelDateMutationVariables>(ChangeTravelDateDocument, options);
      }
export type ChangeTravelDateMutationHookResult = ReturnType<typeof useChangeTravelDateMutation>;
export type ChangeTravelDateMutationResult = Apollo.MutationResult<ChangeTravelDateMutation>;
export type ChangeTravelDateMutationOptions = Apollo.BaseMutationOptions<ChangeTravelDateMutation, ChangeTravelDateMutationVariables>;
export const TravelCompletedToChangeDateDocument = gql`
    query travelCompletedToChangeDate($id: ID!) {
  travel(id: $id) {
    id
    travelNumber
  }
}
    `;

/**
 * __useTravelCompletedToChangeDateQuery__
 *
 * To run a query within a React component, call `useTravelCompletedToChangeDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelCompletedToChangeDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelCompletedToChangeDateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTravelCompletedToChangeDateQuery(baseOptions: Apollo.QueryHookOptions<TravelCompletedToChangeDateQuery, TravelCompletedToChangeDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelCompletedToChangeDateQuery, TravelCompletedToChangeDateQueryVariables>(TravelCompletedToChangeDateDocument, options);
      }
export function useTravelCompletedToChangeDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelCompletedToChangeDateQuery, TravelCompletedToChangeDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelCompletedToChangeDateQuery, TravelCompletedToChangeDateQueryVariables>(TravelCompletedToChangeDateDocument, options);
        }
export type TravelCompletedToChangeDateQueryHookResult = ReturnType<typeof useTravelCompletedToChangeDateQuery>;
export type TravelCompletedToChangeDateLazyQueryHookResult = ReturnType<typeof useTravelCompletedToChangeDateLazyQuery>;
export type TravelCompletedToChangeDateQueryResult = Apollo.QueryResult<TravelCompletedToChangeDateQuery, TravelCompletedToChangeDateQueryVariables>;
export const PrepareToChangeTravelDateDocument = gql`
    mutation prepareToChangeTravelDate($input: PrepareToChangeTravelDateInput!) {
  prepareToChangeTravelDate(input: $input) {
    __typename
    ... on PrepareToChangeTravelDateSuccessResponse {
      ...PrepareToChangeTravelDateSuccess
    }
    ... on PrepareToChangeTravelDateErrorResponse {
      errorCode
    }
  }
}
    ${PrepareToChangeTravelDateSuccessFragmentDoc}`;
export type PrepareToChangeTravelDateMutationFn = Apollo.MutationFunction<PrepareToChangeTravelDateMutation, PrepareToChangeTravelDateMutationVariables>;

/**
 * __usePrepareToChangeTravelDateMutation__
 *
 * To run a mutation, you first call `usePrepareToChangeTravelDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareToChangeTravelDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareToChangeTravelDateMutation, { data, loading, error }] = usePrepareToChangeTravelDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepareToChangeTravelDateMutation(baseOptions?: Apollo.MutationHookOptions<PrepareToChangeTravelDateMutation, PrepareToChangeTravelDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepareToChangeTravelDateMutation, PrepareToChangeTravelDateMutationVariables>(PrepareToChangeTravelDateDocument, options);
      }
export type PrepareToChangeTravelDateMutationHookResult = ReturnType<typeof usePrepareToChangeTravelDateMutation>;
export type PrepareToChangeTravelDateMutationResult = Apollo.MutationResult<PrepareToChangeTravelDateMutation>;
export type PrepareToChangeTravelDateMutationOptions = Apollo.BaseMutationOptions<PrepareToChangeTravelDateMutation, PrepareToChangeTravelDateMutationVariables>;
export const ChangeRoomDetailsDocument = gql`
    mutation changeRoomDetails($input: ChangeRoomDetailsInput!) {
  changeRoomDetails(input: $input) {
    __typename
    ... on ChangeRoomDetailsSuccessResponse {
      ...ChangeRoomDetailsSuccess
    }
    ... on ChangeRoomDetailsErrorResponse {
      errorCode
    }
  }
}
    ${ChangeRoomDetailsSuccessFragmentDoc}`;
export type ChangeRoomDetailsMutationFn = Apollo.MutationFunction<ChangeRoomDetailsMutation, ChangeRoomDetailsMutationVariables>;

/**
 * __useChangeRoomDetailsMutation__
 *
 * To run a mutation, you first call `useChangeRoomDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeRoomDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeRoomDetailsMutation, { data, loading, error }] = useChangeRoomDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeRoomDetailsMutation(baseOptions?: Apollo.MutationHookOptions<ChangeRoomDetailsMutation, ChangeRoomDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeRoomDetailsMutation, ChangeRoomDetailsMutationVariables>(ChangeRoomDetailsDocument, options);
      }
export type ChangeRoomDetailsMutationHookResult = ReturnType<typeof useChangeRoomDetailsMutation>;
export type ChangeRoomDetailsMutationResult = Apollo.MutationResult<ChangeRoomDetailsMutation>;
export type ChangeRoomDetailsMutationOptions = Apollo.BaseMutationOptions<ChangeRoomDetailsMutation, ChangeRoomDetailsMutationVariables>;
export const CompletedBookingTravelDocument = gql`
    query completedBookingTravel($id: ID!) {
  travel(id: $id) {
    id
    travelNumber
  }
}
    `;

/**
 * __useCompletedBookingTravelQuery__
 *
 * To run a query within a React component, call `useCompletedBookingTravelQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedBookingTravelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedBookingTravelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompletedBookingTravelQuery(baseOptions: Apollo.QueryHookOptions<CompletedBookingTravelQuery, CompletedBookingTravelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompletedBookingTravelQuery, CompletedBookingTravelQueryVariables>(CompletedBookingTravelDocument, options);
      }
export function useCompletedBookingTravelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedBookingTravelQuery, CompletedBookingTravelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompletedBookingTravelQuery, CompletedBookingTravelQueryVariables>(CompletedBookingTravelDocument, options);
        }
export type CompletedBookingTravelQueryHookResult = ReturnType<typeof useCompletedBookingTravelQuery>;
export type CompletedBookingTravelLazyQueryHookResult = ReturnType<typeof useCompletedBookingTravelLazyQuery>;
export type CompletedBookingTravelQueryResult = Apollo.QueryResult<CompletedBookingTravelQuery, CompletedBookingTravelQueryVariables>;
export const ItinerariesDocument = gql`
    query itineraries($travelId: ID!) {
  travel(id: $travelId) {
    id
    travelNumber
    status
    jaPropertyContent: propertyContent(language: ja) {
      id
      language
      name
      address {
        ...ItineraryHotelAddress
      }
      phone
      rooms {
        id
        name
      }
      rates {
        id
        mappedRateAmenities {
          jaMealLabels
        }
      }
      importantNotes {
        checkin {
          beginTime
          endTime
          minAge
          twentyFourHour
          checkoutTime
        }
        checkinSpecialInstructions
        mandatoryFee
        instructions
        optionalFee
      }
    }
    enPropertyContent: propertyContent(language: en) {
      id
      language
      name
      address {
        ...ItineraryHotelAddress
      }
    }
    itinerary {
      id
      rooms {
        id
        roomId
        status
        familyName
        givenName
        checkin
        checkout
        totalNights
        specialRequest
        smoking
        roomNumber
        rate {
          id
          mappedRateAmenities {
            wifi {
              id
              jaName
              enName
            }
            jaMealLabels
          }
          refundable
          cancelPenalties {
            ...CancelPenalties
          }
        }
      }
    }
  }
}
    ${ItineraryHotelAddressFragmentDoc}
${CancelPenaltiesFragmentDoc}`;

/**
 * __useItinerariesQuery__
 *
 * To run a query within a React component, call `useItinerariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useItinerariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItinerariesQuery({
 *   variables: {
 *      travelId: // value for 'travelId'
 *   },
 * });
 */
export function useItinerariesQuery(baseOptions: Apollo.QueryHookOptions<ItinerariesQuery, ItinerariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItinerariesQuery, ItinerariesQueryVariables>(ItinerariesDocument, options);
      }
export function useItinerariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItinerariesQuery, ItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItinerariesQuery, ItinerariesQueryVariables>(ItinerariesDocument, options);
        }
export type ItinerariesQueryHookResult = ReturnType<typeof useItinerariesQuery>;
export type ItinerariesLazyQueryHookResult = ReturnType<typeof useItinerariesLazyQuery>;
export type ItinerariesQueryResult = Apollo.QueryResult<ItinerariesQuery, ItinerariesQueryVariables>;
export const TravelDetailDownloadLinkDocument = gql`
    query travelDetailDownloadLink($input: TravelDetailDownloadLinkInput!) {
  travelDetailDownloadLink(input: $input)
}
    `;

/**
 * __useTravelDetailDownloadLinkQuery__
 *
 * To run a query within a React component, call `useTravelDetailDownloadLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelDetailDownloadLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelDetailDownloadLinkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTravelDetailDownloadLinkQuery(baseOptions: Apollo.QueryHookOptions<TravelDetailDownloadLinkQuery, TravelDetailDownloadLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelDetailDownloadLinkQuery, TravelDetailDownloadLinkQueryVariables>(TravelDetailDownloadLinkDocument, options);
      }
export function useTravelDetailDownloadLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelDetailDownloadLinkQuery, TravelDetailDownloadLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelDetailDownloadLinkQuery, TravelDetailDownloadLinkQueryVariables>(TravelDetailDownloadLinkDocument, options);
        }
export type TravelDetailDownloadLinkQueryHookResult = ReturnType<typeof useTravelDetailDownloadLinkQuery>;
export type TravelDetailDownloadLinkLazyQueryHookResult = ReturnType<typeof useTravelDetailDownloadLinkLazyQuery>;
export type TravelDetailDownloadLinkQueryResult = Apollo.QueryResult<TravelDetailDownloadLinkQuery, TravelDetailDownloadLinkQueryVariables>;
export const TravelInDetailDocument = gql`
    query travelInDetail($id: ID!) {
  travel(id: $id) {
    id
    travelNumber
    email
    phone
    paymentType
    status
    expediaHotelRooms {
      id
      roomName
      roomNumber
      status
      hotelName
    }
    pricing {
      ...RoomPriceDetailTableForTravelPricing
    }
    employee {
      id
      name
      email
      status
    }
    stripeCreditCard {
      id
      brand
      last4
    }
    enPropertyContent: propertyContent(language: en) {
      id
      language
      name
    }
    propertyContent {
      id
      language
      name
      ratings {
        property {
          rating
          type
        }
        guest {
          overall
          count
        }
      }
      images {
        url
      }
      importantNotes {
        ...HotelImportantNotes
      }
      attributes {
        general {
          canUseUnicodeInSpecialRequest
        }
      }
      rates {
        id
        amenities {
          id
          name
        }
        mappedRateAmenities {
          jaMealLabels
        }
      }
    }
    itinerary {
      id
      rooms {
        id
        bedGroupId
        checkin
        checkout
        numberOfAdults
        childAges
        givenName
        familyName
        status
        smoking
        specialRequest
        rate {
          id
          refundable
          cancelPenalties {
            ...CancelPenalties
          }
          amenityIds
          mappedRateAmenities {
            jaMealLabels
            mealType
          }
          is3rdParty
        }
      }
      totalPropertyPrice {
        total {
          currency
          value
        }
        resortPrice {
          currency
          value
        }
        mandatoryPrice {
          currency
          value
        }
        mandatoryTaxPrice {
          currency
          value
        }
      }
    }
    ...TravelUpdateTimeline
  }
}
    ${RoomPriceDetailTableForTravelPricingFragmentDoc}
${HotelImportantNotesFragmentDoc}
${CancelPenaltiesFragmentDoc}
${TravelUpdateTimelineFragmentDoc}`;

/**
 * __useTravelInDetailQuery__
 *
 * To run a query within a React component, call `useTravelInDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelInDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelInDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTravelInDetailQuery(baseOptions: Apollo.QueryHookOptions<TravelInDetailQuery, TravelInDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelInDetailQuery, TravelInDetailQueryVariables>(TravelInDetailDocument, options);
      }
export function useTravelInDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelInDetailQuery, TravelInDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelInDetailQuery, TravelInDetailQueryVariables>(TravelInDetailDocument, options);
        }
export type TravelInDetailQueryHookResult = ReturnType<typeof useTravelInDetailQuery>;
export type TravelInDetailLazyQueryHookResult = ReturnType<typeof useTravelInDetailLazyQuery>;
export type TravelInDetailQueryResult = Apollo.QueryResult<TravelInDetailQuery, TravelInDetailQueryVariables>;
export const CreateAgencyTravelMemoDocument = gql`
    mutation createAgencyTravelMemo($input: CreateAgencyTravelMemoInput!) {
  createAgencyTravelMemo(input: $input) {
    agencyTravelMemo {
      id
      travelId
      employeeId
      text
      createdAt
      employee {
        id
        name
      }
    }
  }
}
    `;
export type CreateAgencyTravelMemoMutationFn = Apollo.MutationFunction<CreateAgencyTravelMemoMutation, CreateAgencyTravelMemoMutationVariables>;

/**
 * __useCreateAgencyTravelMemoMutation__
 *
 * To run a mutation, you first call `useCreateAgencyTravelMemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyTravelMemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyTravelMemoMutation, { data, loading, error }] = useCreateAgencyTravelMemoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgencyTravelMemoMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyTravelMemoMutation, CreateAgencyTravelMemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyTravelMemoMutation, CreateAgencyTravelMemoMutationVariables>(CreateAgencyTravelMemoDocument, options);
      }
export type CreateAgencyTravelMemoMutationHookResult = ReturnType<typeof useCreateAgencyTravelMemoMutation>;
export type CreateAgencyTravelMemoMutationResult = Apollo.MutationResult<CreateAgencyTravelMemoMutation>;
export type CreateAgencyTravelMemoMutationOptions = Apollo.BaseMutationOptions<CreateAgencyTravelMemoMutation, CreateAgencyTravelMemoMutationVariables>;
export const DeleteAgencyTravelMemoDocument = gql`
    mutation deleteAgencyTravelMemo($id: ID!) {
  deleteAgencyTravelMemo(id: $id) {
    deletedAgencyTravelMemo {
      id
    }
  }
}
    `;
export type DeleteAgencyTravelMemoMutationFn = Apollo.MutationFunction<DeleteAgencyTravelMemoMutation, DeleteAgencyTravelMemoMutationVariables>;

/**
 * __useDeleteAgencyTravelMemoMutation__
 *
 * To run a mutation, you first call `useDeleteAgencyTravelMemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgencyTravelMemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgencyTravelMemoMutation, { data, loading, error }] = useDeleteAgencyTravelMemoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAgencyTravelMemoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAgencyTravelMemoMutation, DeleteAgencyTravelMemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAgencyTravelMemoMutation, DeleteAgencyTravelMemoMutationVariables>(DeleteAgencyTravelMemoDocument, options);
      }
export type DeleteAgencyTravelMemoMutationHookResult = ReturnType<typeof useDeleteAgencyTravelMemoMutation>;
export type DeleteAgencyTravelMemoMutationResult = Apollo.MutationResult<DeleteAgencyTravelMemoMutation>;
export type DeleteAgencyTravelMemoMutationOptions = Apollo.BaseMutationOptions<DeleteAgencyTravelMemoMutation, DeleteAgencyTravelMemoMutationVariables>;
export const VouchersDocument = gql`
    query vouchers($travelId: ID!) {
  travel(id: $travelId) {
    id
    travelNumber
    status
    jaPropertyContent: propertyContent(language: ja) {
      id
      name
      address {
        ...VoucherHotelAddress
      }
      phone
      rooms {
        id
        name
      }
      importantNotes {
        checkin {
          beginTime
          endTime
          minAge
          twentyFourHour
          checkoutTime
        }
        checkinSpecialInstructions
        mandatoryFee
      }
    }
    enPropertyContent: propertyContent(language: en) {
      id
      name
      address {
        ...VoucherHotelAddress
      }
      rooms {
        id
        name
      }
    }
    itinerary {
      id
      rooms {
        id
        roomId
        propertyConfirmationId
        status
        familyName
        givenName
        checkin
        checkout
        totalNights
        specialRequest
        smoking
        rate {
          id
          mappedRateAmenities {
            freeWiFi
            wifi {
              id
              jaName
              enName
            }
            jaMealLabels
            enMealLabels
          }
        }
      }
    }
  }
}
    ${VoucherHotelAddressFragmentDoc}`;

/**
 * __useVouchersQuery__
 *
 * To run a query within a React component, call `useVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVouchersQuery({
 *   variables: {
 *      travelId: // value for 'travelId'
 *   },
 * });
 */
export function useVouchersQuery(baseOptions: Apollo.QueryHookOptions<VouchersQuery, VouchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VouchersQuery, VouchersQueryVariables>(VouchersDocument, options);
      }
export function useVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VouchersQuery, VouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VouchersQuery, VouchersQueryVariables>(VouchersDocument, options);
        }
export type VouchersQueryHookResult = ReturnType<typeof useVouchersQuery>;
export type VouchersLazyQueryHookResult = ReturnType<typeof useVouchersLazyQuery>;
export type VouchersQueryResult = Apollo.QueryResult<VouchersQuery, VouchersQueryVariables>;
export const TravelsDocument = gql`
    query travels($input: FilterTravelsInput, $pagination: PaginationInput) {
  travels(input: $input, pagination: $pagination) {
    nodes {
      id
      travelNumber
      paymentType
      startDate
      endDate
      createdAt
      employee {
        id
        name
      }
      pricing {
        total {
          finalPaymentPrice
        }
      }
      expediaHotelRooms {
        id
        hotelName
        city
        isPackageRate
        familyName
        givenName
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useTravelsQuery__
 *
 * To run a query within a React component, call `useTravelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useTravelsQuery(baseOptions?: Apollo.QueryHookOptions<TravelsQuery, TravelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelsQuery, TravelsQueryVariables>(TravelsDocument, options);
      }
export function useTravelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelsQuery, TravelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelsQuery, TravelsQueryVariables>(TravelsDocument, options);
        }
export type TravelsQueryHookResult = ReturnType<typeof useTravelsQuery>;
export type TravelsLazyQueryHookResult = ReturnType<typeof useTravelsLazyQuery>;
export type TravelsQueryResult = Apollo.QueryResult<TravelsQuery, TravelsQueryVariables>;
export const ChallengeToRegisterCreditCardDocument = gql`
    mutation challengeToRegisterCreditCard($input: ChallengeToRegisterCreditCardInput!) {
  challengeToRegisterCreditCard(input: $input) {
    __typename
    ... on ChallengeToRegisterCreditCardResponseSuccess {
      card {
        id
      }
    }
    ... on ChallengeToRegisterCreditCardResponseRequiresAction {
      redirectUrl
    }
    ... on ChallengeToRegisterCreditCardResponseError {
      errorCode
    }
  }
}
    `;
export type ChallengeToRegisterCreditCardMutationFn = Apollo.MutationFunction<ChallengeToRegisterCreditCardMutation, ChallengeToRegisterCreditCardMutationVariables>;

/**
 * __useChallengeToRegisterCreditCardMutation__
 *
 * To run a mutation, you first call `useChallengeToRegisterCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeToRegisterCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeToRegisterCreditCardMutation, { data, loading, error }] = useChallengeToRegisterCreditCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChallengeToRegisterCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<ChallengeToRegisterCreditCardMutation, ChallengeToRegisterCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChallengeToRegisterCreditCardMutation, ChallengeToRegisterCreditCardMutationVariables>(ChallengeToRegisterCreditCardDocument, options);
      }
export type ChallengeToRegisterCreditCardMutationHookResult = ReturnType<typeof useChallengeToRegisterCreditCardMutation>;
export type ChallengeToRegisterCreditCardMutationResult = Apollo.MutationResult<ChallengeToRegisterCreditCardMutation>;
export type ChallengeToRegisterCreditCardMutationOptions = Apollo.BaseMutationOptions<ChallengeToRegisterCreditCardMutation, ChallengeToRegisterCreditCardMutationVariables>;
export const ConfirmChallengeToRegisterCreditCardDocument = gql`
    mutation confirmChallengeToRegisterCreditCard($input: ConfirmChallengeToRegisterCreditCardInput!) {
  confirmChallengeToRegisterCreditCard(input: $input) {
    success
    errorCode
  }
}
    `;
export type ConfirmChallengeToRegisterCreditCardMutationFn = Apollo.MutationFunction<ConfirmChallengeToRegisterCreditCardMutation, ConfirmChallengeToRegisterCreditCardMutationVariables>;

/**
 * __useConfirmChallengeToRegisterCreditCardMutation__
 *
 * To run a mutation, you first call `useConfirmChallengeToRegisterCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmChallengeToRegisterCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmChallengeToRegisterCreditCardMutation, { data, loading, error }] = useConfirmChallengeToRegisterCreditCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmChallengeToRegisterCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmChallengeToRegisterCreditCardMutation, ConfirmChallengeToRegisterCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmChallengeToRegisterCreditCardMutation, ConfirmChallengeToRegisterCreditCardMutationVariables>(ConfirmChallengeToRegisterCreditCardDocument, options);
      }
export type ConfirmChallengeToRegisterCreditCardMutationHookResult = ReturnType<typeof useConfirmChallengeToRegisterCreditCardMutation>;
export type ConfirmChallengeToRegisterCreditCardMutationResult = Apollo.MutationResult<ConfirmChallengeToRegisterCreditCardMutation>;
export type ConfirmChallengeToRegisterCreditCardMutationOptions = Apollo.BaseMutationOptions<ConfirmChallengeToRegisterCreditCardMutation, ConfirmChallengeToRegisterCreditCardMutationVariables>;
export const CreditCardsForSelectPaymentMethodDocument = gql`
    query creditCardsForSelectPaymentMethod {
  creditCards {
    ...CreditCardForSelect
  }
}
    ${CreditCardForSelectFragmentDoc}`;

/**
 * __useCreditCardsForSelectPaymentMethodQuery__
 *
 * To run a query within a React component, call `useCreditCardsForSelectPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditCardsForSelectPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditCardsForSelectPaymentMethodQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditCardsForSelectPaymentMethodQuery(baseOptions?: Apollo.QueryHookOptions<CreditCardsForSelectPaymentMethodQuery, CreditCardsForSelectPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditCardsForSelectPaymentMethodQuery, CreditCardsForSelectPaymentMethodQueryVariables>(CreditCardsForSelectPaymentMethodDocument, options);
      }
export function useCreditCardsForSelectPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditCardsForSelectPaymentMethodQuery, CreditCardsForSelectPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditCardsForSelectPaymentMethodQuery, CreditCardsForSelectPaymentMethodQueryVariables>(CreditCardsForSelectPaymentMethodDocument, options);
        }
export type CreditCardsForSelectPaymentMethodQueryHookResult = ReturnType<typeof useCreditCardsForSelectPaymentMethodQuery>;
export type CreditCardsForSelectPaymentMethodLazyQueryHookResult = ReturnType<typeof useCreditCardsForSelectPaymentMethodLazyQuery>;
export type CreditCardsForSelectPaymentMethodQueryResult = Apollo.QueryResult<CreditCardsForSelectPaymentMethodQuery, CreditCardsForSelectPaymentMethodQueryVariables>;
export const TravelDetailsForCsvDocument = gql`
    query travelDetailsForCsv {
  travelDetails {
    id
    travelNumber
    email
    phone
    paymentType
    startDate
    endDate
    createdAt
    employee {
      id
      name
    }
    expediaHotelRooms {
      id
      hotelName
      city
      isPackageRate
      familyName
      givenName
      roomName
      roomNumber
      bedType
      status
      refundPrice
    }
    pricing {
      ...RoomPriceDetailTableForTravelPricing
    }
    itinerary {
      id
      rooms {
        id
        rate {
          id
          cancelPenalties {
            ...CancelPenalties
          }
        }
      }
    }
  }
}
    ${RoomPriceDetailTableForTravelPricingFragmentDoc}
${CancelPenaltiesFragmentDoc}`;

/**
 * __useTravelDetailsForCsvQuery__
 *
 * To run a query within a React component, call `useTravelDetailsForCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelDetailsForCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelDetailsForCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useTravelDetailsForCsvQuery(baseOptions?: Apollo.QueryHookOptions<TravelDetailsForCsvQuery, TravelDetailsForCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelDetailsForCsvQuery, TravelDetailsForCsvQueryVariables>(TravelDetailsForCsvDocument, options);
      }
export function useTravelDetailsForCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelDetailsForCsvQuery, TravelDetailsForCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelDetailsForCsvQuery, TravelDetailsForCsvQueryVariables>(TravelDetailsForCsvDocument, options);
        }
export type TravelDetailsForCsvQueryHookResult = ReturnType<typeof useTravelDetailsForCsvQuery>;
export type TravelDetailsForCsvLazyQueryHookResult = ReturnType<typeof useTravelDetailsForCsvLazyQuery>;
export type TravelDetailsForCsvQueryResult = Apollo.QueryResult<TravelDetailsForCsvQuery, TravelDetailsForCsvQueryVariables>;
export const MyselfDocument = gql`
    query myself {
  myself {
    id
    employee {
      id
      name
      role
      email
      agencyBranch {
        id
        companyId
        status
        isInvoicePaymentEnabled
      }
    }
    latestAgencyRegistration {
      id
      status
      type
    }
  }
}
    `;

/**
 * __useMyselfQuery__
 *
 * To run a query within a React component, call `useMyselfQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyselfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyselfQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyselfQuery(baseOptions?: Apollo.QueryHookOptions<MyselfQuery, MyselfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyselfQuery, MyselfQueryVariables>(MyselfDocument, options);
      }
export function useMyselfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyselfQuery, MyselfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyselfQuery, MyselfQueryVariables>(MyselfDocument, options);
        }
export type MyselfQueryHookResult = ReturnType<typeof useMyselfQuery>;
export type MyselfLazyQueryHookResult = ReturnType<typeof useMyselfLazyQuery>;
export type MyselfQueryResult = Apollo.QueryResult<MyselfQuery, MyselfQueryVariables>;
export const IncrementalSearchPropertyContentDocument = gql`
    query incrementalSearchPropertyContent($input: IncrementalSearchPropertyContentInput!) {
  incrementalSearchPropertyContent(input: $input) {
    data {
      id
      name
      location
      coordinates {
        latitude
        longitude
      }
      type
    }
  }
}
    `;

/**
 * __useIncrementalSearchPropertyContentQuery__
 *
 * To run a query within a React component, call `useIncrementalSearchPropertyContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncrementalSearchPropertyContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncrementalSearchPropertyContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIncrementalSearchPropertyContentQuery(baseOptions: Apollo.QueryHookOptions<IncrementalSearchPropertyContentQuery, IncrementalSearchPropertyContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncrementalSearchPropertyContentQuery, IncrementalSearchPropertyContentQueryVariables>(IncrementalSearchPropertyContentDocument, options);
      }
export function useIncrementalSearchPropertyContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncrementalSearchPropertyContentQuery, IncrementalSearchPropertyContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncrementalSearchPropertyContentQuery, IncrementalSearchPropertyContentQueryVariables>(IncrementalSearchPropertyContentDocument, options);
        }
export type IncrementalSearchPropertyContentQueryHookResult = ReturnType<typeof useIncrementalSearchPropertyContentQuery>;
export type IncrementalSearchPropertyContentLazyQueryHookResult = ReturnType<typeof useIncrementalSearchPropertyContentLazyQuery>;
export type IncrementalSearchPropertyContentQueryResult = Apollo.QueryResult<IncrementalSearchPropertyContentQuery, IncrementalSearchPropertyContentQueryVariables>;
export const IncrementalSearchRegionDocument = gql`
    query incrementalSearchRegion($input: IncrementalSearchRegionInput!) {
  incrementalSearchRegion(input: $input) {
    data {
      id
      name
      location
      coordinates {
        latitude
        longitude
      }
      type
    }
  }
}
    `;

/**
 * __useIncrementalSearchRegionQuery__
 *
 * To run a query within a React component, call `useIncrementalSearchRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncrementalSearchRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncrementalSearchRegionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIncrementalSearchRegionQuery(baseOptions: Apollo.QueryHookOptions<IncrementalSearchRegionQuery, IncrementalSearchRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncrementalSearchRegionQuery, IncrementalSearchRegionQueryVariables>(IncrementalSearchRegionDocument, options);
      }
export function useIncrementalSearchRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncrementalSearchRegionQuery, IncrementalSearchRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncrementalSearchRegionQuery, IncrementalSearchRegionQueryVariables>(IncrementalSearchRegionDocument, options);
        }
export type IncrementalSearchRegionQueryHookResult = ReturnType<typeof useIncrementalSearchRegionQuery>;
export type IncrementalSearchRegionLazyQueryHookResult = ReturnType<typeof useIncrementalSearchRegionLazyQuery>;
export type IncrementalSearchRegionQueryResult = Apollo.QueryResult<IncrementalSearchRegionQuery, IncrementalSearchRegionQueryVariables>;